(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bo-advertorial"] && !Shopify.designMode) return;
  try {
    
    // Los CTA preservan los UTM del anuncio y marcan el origen advertorial
    (function () {
      // COD directo en la misma página: si el popup y los datos del producto están presentes,
      // el CTA abre el formulario aquí mismo (cero navegación). Si no, navega normal (?cod=1).
      document.addEventListener('click', function (ev) {
        var a = ev.target.closest('[data-adv-cta]');
        if (!a) return;
        var dataEl = document.getElementById('bo-adv-coddata');
        var dlg = document.getElementById('bo-cod-dialog');
        if (!dataEl || !dlg) return;
        ev.preventDefault();
        try {
          var d = JSON.parse(dataEl.textContent);
          var sav = { 1: 0 };
          if (d.savings) { d.savings.split(',').forEach(function (p) { var kv = p.split(':'); var q = parseInt(kv[0], 10), sv = parseInt(kv[1], 10); if (q && !isNaN(sv)) sav[q] = sv; }); }
          document.dispatchEvent(new CustomEvent('bo:open-cod', { detail: {
            variantId: d.variantId, qty: 1, unitPrice: d.unitPrice, saving: sav[1] || 0, savingsByQty: sav,
            title: d.title, image: d.image, moneyFormat: d.moneyFormat, variants: d.variants
          }}));
        } catch (er) { location.href = a.href; }
      });

      var mark = document.currentScript && document.currentScript.closest ? null : null;
      document.querySelectorAll('[data-adv-cta]').forEach(function (a) {
        try {
          var u = new URL(a.getAttribute('href'), location.origin);
          var cur = new URLSearchParams(location.search);
          cur.forEach(function (v, k) { u.searchParams.set(k, v); });
          var tk = (document.querySelector('.bo-adv') || {}).dataset ? (document.querySelector('.bo-adv').dataset.track || 'advertorial') : 'advertorial';
          if (!u.searchParams.get('utm_content')) u.searchParams.set('utm_content', tk);
          u.searchParams.set('cod', '1');
          a.href = u.pathname + '?' + u.searchParams.toString();
        } catch (e) {}
      });
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bo-buybox"] && !Shopify.designMode) return;
  try {
    
    (function () {
      if (window.boBuyBoxInit) return;
      window.boBuyBoxInit = true;
      document.addEventListener('click', function (event) {
        var swatch = event.target.closest('.bo-bb__swatch');
        if (!swatch) return;
        var card = swatch.closest('.bo-bb__card');
        if (!card) return;
        var image = card.querySelector('.bo-bb__img');
        var src = swatch.getAttribute('data-img');
        var srcset = swatch.getAttribute('data-srcset');
        if (image && src) {
          if (srcset) {
            image.setAttribute('srcset', srcset);
          }
          image.setAttribute('src', src);
        }
        var buy = swatch.getAttribute('data-buy');
        if (buy) {
          var links = card.querySelectorAll('.bo-bb__btn, a.bo-bb__imgwrap, .bo-bb__tlink');
          for (var j = 0; j < links.length; j++) {
            links[j].setAttribute('href', buy);
          }
        }
        var siblings = card.querySelectorAll('.bo-bb__swatch');
        for (var i = 0; i < siblings.length; i++) {
          siblings[i].classList.remove('is-active');
          siblings[i].setAttribute('aria-pressed', 'false');
        }
        swatch.classList.add('is-active');
        swatch.setAttribute('aria-pressed', 'true');
      });
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bo-clarity-pdp"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  var root = document.getElementById('bo-clpdp');
  if (!root) return;
  var endpoint = root.getAttribute('data-endpoint') || '';
  var source = root.getAttribute('data-source') || 'alpha-clarity-pdp';
  var LS_KEY = 'bo_clw_joined_v1';

  function normalizePhone(raw) {
    var d = String(raw || '').replace(/\D/g, '');
    if (d.length === 11 && d.indexOf('591') === 0) d = d.slice(3);
    if (d.length === 8 && (d[0] === '6' || d[0] === '7')) return d;
    return null;
  }

  function markDone(form, already, focus) {
    form.classList.add('is-done');
    var ok = form.querySelector('[data-clw-ok]');
    if (ok) {
      if (already) {
        var t = ok.querySelector('strong');
        if (t) t.textContent = 'Ya estabas en la lista';
      }
      ok.hidden = false;
      if (focus) {
        ok.setAttribute('tabindex', '-1');
        ok.focus({ preventScroll: true });
      }
    }
  }

  function setErr(form, msg) {
    var err = form.querySelector('[data-clw-err]');
    if (!err) return;
    if (msg) { err.textContent = msg; err.hidden = false; }
    else { err.textContent = ''; err.hidden = true; }
  }

  var forms = root.querySelectorAll('[data-clw-form]');
  var joined = false;
  try { joined = !!localStorage.getItem(LS_KEY); } catch (e) {}
  if (joined) forms.forEach(function (f) { markDone(f, true, false); });

  forms.forEach(function (form) {
    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      setErr(form, '');
      var nameIn = form.querySelector('input[name="name"]');
      var phoneIn = form.querySelector('input[name="phone"]');
      var btn = form.querySelector('[data-clw-btn]');
      var name = (nameIn.value || '').trim();
      var phone = normalizePhone(phoneIn.value);

      nameIn.setAttribute('aria-invalid', name.length < 2 ? 'true' : 'false');
      phoneIn.setAttribute('aria-invalid', phone ? 'false' : 'true');

      if (name.length < 2) { setErr(form, 'Escribe tu nombre para poder avisarte.'); nameIn.focus(); return; }
      if (!phone) { setErr(form, 'Revisa tu celular: son 8 dígitos y empieza en 6 o 7.'); phoneIn.focus(); return; }
      if (!endpoint) { setErr(form, 'El registro no está disponible en este momento. Escríbenos por WhatsApp.'); return; }

      btn.disabled = true;
      var label = btn.querySelector('[data-clw-btn-label]');
      var prev = label ? label.textContent : '';
      if (label) label.textContent = 'Registrando…';

      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name: name, phone: phone, source: source })
      })
        .then(function (r) { return r.json().catch(function () { return {}; }); })
        .then(function (data) {
          if (data && data.ok) {
            try { localStorage.setItem(LS_KEY, '1'); } catch (e) {}
            forms.forEach(function (f) { markDone(f, f !== form ? true : !!data.already, f === form); });
            var st = root.querySelector('[data-sticky]');
            if (st) st.hidden = true;
            if (!data.already && typeof window.boTrack === 'function') {
              window.boTrack('Lead', { content_name: 'Alpha Clarity Waitlist', content_category: 'preventa-pdp' });
            }
          } else if (data && data.error === 'phone') {
            setErr(form, 'Revisa tu celular: son 8 dígitos y empieza en 6 o 7.');
          } else {
            setErr(form, 'No pudimos registrarte. Intenta de nuevo en unos segundos.');
          }
        })
        .catch(function () {
          setErr(form, 'Sin conexión. Revisa tu internet e intenta de nuevo.');
        })
        .then(function () {
          btn.disabled = false;
          if (label) label.textContent = prev;
        });
    });
  });

  function initCarousel(carousel, dotsWrap, slideSel) {
    if (!carousel || !dotsWrap) return;
    var slides = carousel.querySelectorAll(slideSel);
    if (!slides.length) return;
    slides.forEach(function () { dotsWrap.appendChild(document.createElement('span')); });
    var dots = dotsWrap.querySelectorAll('span');
    var syncDots = function () {
      var mid = carousel.scrollLeft + carousel.clientWidth / 2;
      var idx = 0;
      slides.forEach(function (s, i) { if (s.offsetLeft <= mid) idx = i; });
      dots.forEach(function (d, i) { d.classList.toggle('is-on', i === idx); });
    };
    carousel.addEventListener('scroll', function () {
      window.requestAnimationFrame(syncDots);
    }, { passive: true });
    syncDots();
  }
  initCarousel(root.querySelector('[data-gallery]'), root.querySelector('[data-dots]'), '.bo-clpdp__slide');
  initCarousel(root.querySelector('[data-gallery2]'), root.querySelector('[data-dots2]'), '.bo-clpdp__foto');

  if ('IntersectionObserver' in window) {
    var vids = root.querySelectorAll('video');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.play().catch(function () {}); }
        else { e.target.pause(); }
      });
    }, { threshold: 0.15 });
    vids.forEach(function (v) { io.observe(v); });

    var sticky = root.querySelector('[data-sticky]');
    var topForm = document.getElementById('bo-clpdp-form-top');
    var finalSec = document.getElementById('bo-clpdp-final');
    if (sticky && topForm) {
      var topVisible = true, finalVisible = false, done = joined;
      var refresh = function () {
        sticky.hidden = topVisible || finalVisible || done || window.innerWidth >= 900;
      };
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { topVisible = e.isIntersecting; });
        refresh();
      }, { threshold: 0.05 }).observe(topForm);
      if (finalSec) {
        new IntersectionObserver(function (es) {
          es.forEach(function (e) { finalVisible = e.isIntersecting; });
          refresh();
        }, { threshold: 0.05 }).observe(finalSec);
      }
      root.addEventListener('click', function (e) {
        if (e.target.closest('[data-sticky-btn]')) {
          (finalSec || topForm).scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
      window.addEventListener('resize', refresh, { passive: true });
      refresh();
    }
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bo-cod-popup-page"] && !Shopify.designMode) return;
  try {
    
    (function () {
      var dlg = document.getElementById('bo-cod-dialog');
      if (!dlg || dlg.__boCodInit) return;
      dlg.__boCodInit = true;
      var endpoint = (dlg.getAttribute('data-endpoint') || '').trim();
      var fee = parseInt(dlg.getAttribute('data-fee'), 10) || 0;
      var upEnabled = dlg.getAttribute('data-up-enabled') === '1';
      var upChoose = dlg.getAttribute('data-up-choose') === '1';
      var upTimer = parseInt(dlg.getAttribute('data-up-timer'), 10) || 150;
      var upUnit = dlg.getAttribute('data-up-unit') || '30 tiras';
      var exitEnabled = dlg.getAttribute('data-exit-enabled') === '1';
      var exitPct = parseInt(dlg.getAttribute('data-exit-pct'), 10) || 0;
      var exitMin = parseInt(dlg.getAttribute('data-exit-min'), 10) || 5;
      var exitPrefix = dlg.getAttribute('data-exit-prefix') || 'BIO';
      var nudgeEnabled = dlg.getAttribute('data-nudge-enabled') === '1';
      var nudgeUnit = dlg.getAttribute('data-nudge-unit') || 'tiras';
      var popupSavings = {};
      (dlg.getAttribute('data-nudge-savings') || '').split(',').forEach(function (pair) {
        var kv = pair.split(':'); if (kv.length === 2) { var q = parseInt(kv[0], 10); var s = parseInt(kv[1], 10); if (q > 0 && s >= 0) popupSavings[q] = s; }
      });
      var offers = {};
      (dlg.getAttribute('data-up-offers') || '').split(',').forEach(function (pair) {
        var kv = pair.split(':'); if (kv.length === 2) { var q = parseInt(kv[0], 10); var pr = parseInt(kv[1], 10); if (q > 0 && pr >= 0) offers[q] = pr; }
      });
      var campaignCodes = {};
      (dlg.getAttribute('data-disc-codes') || '').split(',').forEach(function (pair) {
        var kv = pair.split(':'); if (kv.length === 2) { var c = kv[0].trim().toUpperCase(); var p = parseInt(kv[1], 10); if (c && p > 0 && p <= 90) campaignCodes[c] = p; }
      });
      var pageVariants = [];
      try { pageVariants = JSON.parse(document.getElementById('bo-cod-variants').textContent); } catch (e) {}
      var variants = pageVariants;
      var waNumber = (dlg.getAttribute('data-wa-number') || '').replace(/[\u0300-\u036f]/g, '');
      var waMsg = dlg.getAttribute('data-wa-msg') || '';
      var stUpEnabled = dlg.getAttribute('data-sticker-up-enabled') === '1';
      var stUpLabel = dlg.getAttribute('data-sticker-up-label') || '30 pares de stickers';
      var stUpSub = dlg.getAttribute('data-sticker-up-sub') || '';
      var stUpPrice = parseInt(dlg.getAttribute('data-sticker-up-price'), 10) || 100;
      var stUpSave = parseInt(dlg.getAttribute('data-sticker-up-save'), 10) || 60;
      var st = {};

      /* --- Analíticas del funnel: envía eventos a <endpoint>/track. Todo defensivo: nunca rompe la compra. --- */
      function boSid() {
        try { var k = 'bo_sid', s = sessionStorage.getItem(k);
          if (!s) { s = 's' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8); sessionStorage.setItem(k, s); }
          return s; } catch (e) { return ''; }
      }
      function codIdempotencyKey() {
        try { if (crypto && typeof crypto.randomUUID === 'function') return 'cod_' + crypto.randomUUID().replace(/-/g, ''); } catch (e) {}
        return 'cod_' + Date.now().toString(36) + Math.random().toString(36).slice(2, 14);
      }
      function inferOfferId(detail) {
        if (detail.offerId) return detail.offerId;
        if (detail.stickerVariantId) return 'dilatador-pdp';
        var id = parseInt(detail.variantId, 10) || 0;
        if ([42562312634438, 42562312667206, 42562312699974].indexOf(id) >= 0) return 'tiras-pdp';
        if ([43188148371526, 43208634662982].indexOf(id) >= 0) return 'cinta-pdp';
        if (id === 44452590387270) return 'stickers-pdp';
        if (id === 45182051844166) return 'edicion-tierra-pdp';
        if ([44464796860486, 44464796893254].indexOf(id) >= 0) return 'dilatador-pdp';
        if ([43208698462278, 43208698495046, 43208698527814, 43220991639622, 43220991606854, 43220991672390, 43220992524358, 43220992458822, 43220992491590].indexOf(id) >= 0) return 'combo-pdp';
        return 'standard';
      }
      function boAb() {
        try { var k = 'bo_ab', a = localStorage.getItem(k);
          if (!a) { a = (Math.random() < 0.5 ? 'A' : 'B'); localStorage.setItem(k, a); }
          return a; } catch (e) { return ''; }
      }
      function boSource() {
        try { var k = 'bo_src', s = sessionStorage.getItem(k); if (s) return s;
          var p = new URLSearchParams(location.search); var src = p.get('utm_source') || '';
          if (!src) { var ref = document.referrer || ''; if (ref) { try { src = new URL(ref).hostname.replace(/^www\./, ''); } catch (e) {} } if (!src) src = 'direct'; }
          sessionStorage.setItem(k, src); return src; } catch (e) { return ''; }
      }
      function boEvId() { try { return 'e' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8); } catch (e) { return ''; } }
      function boVid() {
        try { var k = 'bo_vid', v = localStorage.getItem(k);
          if (!v) { v = 'v' + Date.now().toString(36) + Math.random().toString(36).slice(2, 10); localStorage.setItem(k, v); }
          return v; } catch (e) { return ''; }
      }
      function boEntry() {
        var o = { landing: '', path: '', referrer: '', utm_medium: '', utm_campaign: '', utm_content: '', utm_term: '' };
        try {
          o.landing = (location.href || '').slice(0, 500);
          o.path = (location.pathname || '').slice(0, 200);
          o.referrer = (document.referrer || '').slice(0, 500);
          var p = new URLSearchParams(location.search);
          o.utm_medium = (p.get('utm_medium') || '').slice(0, 80);
          o.utm_campaign = (p.get('utm_campaign') || '').slice(0, 120);
          o.utm_content = (p.get('utm_content') || '').slice(0, 120);
          o.utm_term = (p.get('utm_term') || '').slice(0, 120);
        } catch (e) {}
        return o;
      }
      function codCtx() {
        var variantLabel = '', city = '', product = '';
        try { var vid = (st.packColors && st.packColors[0]) || st.defaultVariant;
          var v = variants.filter(function (x) { return String(x.id) === String(vid); })[0]; variantLabel = v ? v.label : ''; } catch (e) {}
        try { var cs = document.getElementById('bo-cod-city-in'); city = (cs && cs.value && cs.value !== '__otra__') ? cs.value : (sharedCity() || ''); } catch (e) {}
        try { var nmEl = document.getElementById('bo-cod-name'); product = nmEl ? (nmEl.textContent || '').trim() : ''; } catch (e) {}
        return { sid: boSid(), ab: boAb(), source: boSource(), product: product, variant: variantLabel, pack: st.qty || 1, city: city, visitor_id: boVid() };
      }
      function codTrack(event, extra) {
        try {
          if (!endpoint) return; // demo (sin servidor) → no se trackea
          var ev = Object.assign({ id: boEvId(), event: event }, codCtx(), extra || {});
          var url = endpoint.replace(/\/+$/, '') + '/track';
          var body = JSON.stringify(ev);
          if (navigator.sendBeacon) { navigator.sendBeacon(url, body); }
          else { fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: body, keepalive: true }).catch(function () {}); }
        } catch (e) {}
      }

      // --- Preselección de ciudad: REUSA la ciudad ya detectada/elegida por el sistema de
      // entregas (snippet bo-delivery-promise → localStorage 'bo_dp_city' + evento 'bo:dp-citychange').
      // NO hace una segunda consulta IP. Prioridad: datos guardados del cliente > ciudad compartida.
      // La ciudad SIEMPRE queda editable; si el usuario la elige a mano, no la pisamos.
      var cityAutoSet = false;
      function sharedCity() { try { return localStorage.getItem('bo_dp_city') || ''; } catch (e) { return ''; } }
      function applyDetectedCity() {
        var sel = document.getElementById('bo-cod-city-in'); if (!sel) return;
        if (sel.value && sel.value !== '' && !cityAutoSet) return; // elegida a mano o guardada → respetar
        var c = sharedCity(); if (!c || sel.value === c) return;
        var has = Array.prototype.some.call(sel.options, function (o) { return o.value === c; });
        if (has) { sel.value = c; cityAutoSet = true; toggleEncomienda(false); renderTotal(); updateCityChange(); }
      }
      // La promesa de entrega y el form comparten la misma ciudad: si cambia allá (o la IP
      // resuelve tarde) lo reflejamos aquí, salvo que el usuario ya la haya elegido a mano.
      document.addEventListener('bo:dp-citychange', function () { applyDetectedCity(); });

      // Localidades de encomienda (fuente: source-bot/delivery.js ENCOMIENDA_ZONES). NO inventar.
      var LOCALITIES = [
        {n:'Viacha',d:'La Paz'},{n:'Caranavi',d:'La Paz'},{n:'Coroico',d:'La Paz'},{n:'Chulumani',d:'La Paz'},{n:'Palos Blancos',d:'La Paz'},{n:'Mapiri',d:'La Paz'},{n:'Achacachi',d:'La Paz'},{n:'Copacabana',d:'La Paz'},{n:'Patacamaya',d:'La Paz'},{n:'Guaqui',d:'La Paz'},{n:'Yungas',d:'La Paz'},{n:'Sorata',d:'La Paz'},{n:'Desaguadero',d:'La Paz'},
        {n:'Villa Tunari',d:'Cochabamba'},{n:'Shinahota',d:'Cochabamba'},{n:'Entre Ríos',d:'Cochabamba'},{n:'Ivirgarzama',d:'Cochabamba'},{n:'Chimoré',d:'Cochabamba'},{n:'Puerto Villarroel',d:'Cochabamba'},{n:'Punata',d:'Cochabamba'},{n:'Arani',d:'Cochabamba'},{n:'Mizque',d:'Cochabamba'},{n:'Aiquile',d:'Cochabamba'},{n:'Capinota',d:'Cochabamba'},{n:'Tiraque',d:'Cochabamba'},{n:'Cliza',d:'Cochabamba'},{n:'Chapare',d:'Cochabamba'},{n:'Bulo Bulo',d:'Cochabamba'},{n:'Isarzama',d:'Cochabamba'},
        {n:'Puerto Quijarro',d:'Santa Cruz'},{n:'Puerto Suárez',d:'Santa Cruz'},{n:'Roboré',d:'Santa Cruz'},{n:'San José de Chiquitos',d:'Santa Cruz'},{n:'Yapacaní',d:'Santa Cruz'},{n:'Camiri',d:'Santa Cruz'},{n:'Montero',d:'Santa Cruz'},{n:'Warnes',d:'Santa Cruz'},{n:'Cotoca',d:'Santa Cruz'},{n:'Mineros',d:'Santa Cruz'},{n:'San Julián',d:'Santa Cruz'},{n:'Ascensión de Guarayos',d:'Santa Cruz'},{n:'Guarayos',d:'Santa Cruz'},{n:'Vallegrande',d:'Santa Cruz'},{n:'San Ramón',d:'Santa Cruz'},{n:'San Ignacio de Velasco',d:'Santa Cruz'},{n:'El Torno',d:'Santa Cruz'},{n:'La Guardia',d:'Santa Cruz'},
        {n:'Yacuiba',d:'Tarija'},{n:'Villamontes',d:'Tarija'},{n:'Caraparí',d:'Tarija'},{n:'Bermejo',d:'Tarija'},
        {n:'Uyuni',d:'Potosí'},{n:'Tupiza',d:'Potosí'},{n:'Villazón',d:'Potosí'},{n:'Uncía',d:'Potosí'},{n:'Llallagua',d:'Potosí'},{n:'Betanzos',d:'Potosí'},
        {n:'Huanuni',d:'Oruro'},{n:'Challapata',d:'Oruro'},{n:'Caracollo',d:'Oruro'},{n:'Sabaya',d:'Oruro'},{n:'Toledo',d:'Oruro'},
        {n:'Riberalta',d:'Beni'},{n:'Trinidad',d:'Beni'},{n:'Guayaramerín',d:'Beni'},{n:'Rurrenabaque',d:'Beni'},{n:'San Borja',d:'Beni'},{n:'Santa Ana',d:'Beni'},{n:'San Ignacio de Moxos',d:'Beni'},{n:'Reyes',d:'Beni'},{n:'San Ramón',d:'Beni'},
        {n:'Cobija',d:'Pando'},{n:'Porvenir',d:'Pando'},{n:'Puerto Rico',d:'Pando'},{n:'Sena',d:'Pando'},
        {n:'Beni',d:''},{n:'Pando',d:''}
      ];
      function acNorm(s) { return (s || '').toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''); }
      function renderAcSuggestions(q) {
        var list = document.getElementById('bo-cod-prov-list'); var input = document.getElementById('bo-cod-prov-in');
        if (!list) return;
        var nq = acNorm((q || '').trim());
        list.innerHTML = '';
        if (nq.length < 1) { list.hidden = true; if (input) input.setAttribute('aria-expanded', 'false'); return; }
        var starts = [], contains = [];
        LOCALITIES.forEach(function (l) { var i = acNorm(l.n).indexOf(nq); if (i === 0) starts.push(l); else if (i > 0) contains.push(l); });
        var matches = starts.concat(contains).slice(0, 8);
        if (!matches.length) { list.hidden = true; if (input) input.setAttribute('aria-expanded', 'false'); return; }
        matches.forEach(function (l) {
          var li = document.createElement('li'); li.className = 'bo-cod__ac-item'; li.setAttribute('role', 'option');
          li.setAttribute('data-val', l.d ? (l.n + ', ' + l.d) : l.n);
          li.textContent = l.n;
          if (l.d) { var sp = document.createElement('span'); sp.className = 'bo-cod__ac-dept'; sp.textContent = l.d; li.appendChild(sp); }
          list.appendChild(li);
        });
        list.hidden = false; if (input) input.setAttribute('aria-expanded', 'true');
      }

      function money(cents) {
        var fmt = st.moneyFormat || '{{amount}}';
        var noDec = /no_decimals/.test(fmt);
        var n = (cents || 0) / 100;
        var s = noDec ? String(Math.round(n)) : n.toFixed(2);
        return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, s);
      }
      function renderTotal() {
        var base = (st.unitPrice * st.qty) - (st.saving * 100);
        if (base < 0) base = st.unitPrice * st.qty;
        var goods = base + st.upsellExtraCents + (st.stickerExtraCents || 0);
        if (st.discountPct > 0) goods = Math.round(goods * (1 - st.discountPct / 100));
        var total = goods + (st.encomienda ? fee * 100 : 0);
        var el = document.getElementById('bo-cod-total'); if (el) el.textContent = money(total);
        var qv = document.getElementById('bo-cod-qtyval'); if (qv) qv.textContent = st.qty;
        var lbl = document.getElementById('bo-cod-total-label');
        if (lbl) lbl.textContent = st.encomienda ? 'Total (pago anticipado por QR)' : 'Total a pagar al recibir';
        var csub = document.getElementById('bo-cod-confirm-sub');
        if (csub) csub.textContent = st.encomienda ? 'Coordinamos el pago por WhatsApp' : 'Pagas al recibir · sin adelantar nada';
        var cp = document.getElementById('bo-cod-coupon');
        if (cp) { if (st.discountPct > 0) { cp.hidden = false; cp.textContent = 'Cupón ' + st.discountCode + ' aplicado: -' + st.discountPct + '%'; } else { cp.hidden = true; } }
        var svc = savingsCents();
        var svEl = document.getElementById('bo-cod-savings'); var svTx = document.getElementById('bo-cod-savings-tx');
        if (svEl && svTx) { if (svc > 0) { svTx.textContent = 'Ahorras ' + money(svc); svEl.hidden = false; } else { svEl.hidden = true; } }
        renderNudge(); buildWaEscape();
      }
      function renderNudge() {
        var el = document.getElementById('bo-cod-nudge');
        if (!el) return;
        if (st.stickerVariantId) { el.hidden = true; return; } // Dilatador: usa el upsell de stickers, no el nudge de packs
        var t = st.savingsByQty || {};
        var nextQty = st.qty + 1;
        // Mostrar solo si hay un tramo siguiente definido (no inventa precios fuera de tabla).
        if (!nudgeEnabled || st.qty !== 1 || t[nextQty] == null) { el.hidden = true; return; }
        var curSaving = (t[st.qty] != null) ? t[st.qty] : 0;
        var nextSaving = t[nextQty];
        var marginal = Math.round((st.unitPrice / 100) - (nextSaving - curSaving));
        var base = (st.unitPrice * nextQty) - (nextSaving * 100);
        if (base < 0) base = st.unitPrice * nextQty;
        if (st.discountPct > 0) base = Math.round(base * (1 - st.discountPct / 100));
        var newTotal = base + (st.encomienda ? fee * 100 : 0);
        var main = document.getElementById('bo-cod-nudge-main');
        var sub = document.getElementById('bo-cod-nudge-sub');
        if (main) main.textContent = 'Lleva ' + nextQty + ' packs y ahorra ' + nextSaving + ' Bs';
        if (sub) sub.textContent = '+' + marginal + ' Bs · ' + (nextQty * 30) + ' ' + nudgeUnit + ' · tu total: ' + money(newTotal);
        el.hidden = false;
      }
      function renderStickerUpsell() {
        var card = document.getElementById('bo-cod-sticker-up');
        if (!card) return;
        // Solo Dilatador (hay variante de stickers) + kit de entrada (0 packs incluidos) + habilitado.
        if (!stUpEnabled || !st.stickerVariantId || st.kitStickerPacks > 0) { card.hidden = true; return; }
        card.hidden = false;
        var added = (st.stickerExtraPacks || 0) > 0;
        card.classList.toggle('is-added', added);
        var title = document.getElementById('bo-cod-sticker-up-title');
        var sub = document.getElementById('bo-cod-sticker-up-sub');
        var btn = document.getElementById('bo-cod-sticker-up-btn');
        if (title) title.textContent = added ? ('✓ Agregaste ' + stUpLabel) : ('Agrega ' + stUpLabel);
        if (sub) sub.textContent = added ? ('Se sumaron a tu pedido (+' + stUpPrice + ' Bs)') : (stUpSub + ' · solo +' + stUpPrice + ' Bs');
        if (btn) { btn.textContent = added ? 'Quitar' : ('+ ' + stUpPrice + ' Bs'); btn.setAttribute('aria-pressed', added ? 'true' : 'false'); }
      }
      function renderIncludes() {
        var inc = document.getElementById('bo-cod-includes');
        var klr = document.getElementById('bo-cod-kitlinkrow');
        if (!st.stickerVariantId) { if (inc) inc.hidden = true; if (klr) klr.hidden = true; return; }
        if (inc) inc.hidden = false;
        if (klr) klr.hidden = !(st.kits && st.kits.length > 1);
        var incS = document.getElementById('bo-cod-inc-stickers');
        if (incS) {
          var basePares = st.days || 0;                      // pares incluidos en el kit
          var extraPares = (st.stickerExtraPacks || 0) * 30; // cada pack extra = 30 pares (30 días)
          if (extraPares > 0) incS.textContent = (basePares + extraPares) + ' pares de stickers (' + basePares + ' + ' + extraPares + ' extra)';
          else incS.textContent = basePares + ' pares de stickers incluidos';
        }
      }
      function updateCityChange() {
        var btn = document.getElementById('bo-cod-city-change');
        var sel = document.getElementById('bo-cod-city-in');
        if (btn && sel) btn.hidden = !(sel.value && sel.value !== '');
      }
      function renderColors() {
        var wrap = document.getElementById('bo-cod-colors'); var list = document.getElementById('bo-cod-colors-list');
        if (!wrap || !list) return;
        for (var j = 0; j < st.qty; j++) { if (st.packColors[j] == null) st.packColors[j] = st.defaultVariant; }
        st.packColors = st.packColors.slice(0, st.qty);
        if (variants.length < 2) { wrap.hidden = true; renderPackStrip(); return; }
        wrap.hidden = false; list.innerHTML = '';
        list.className = 'bo-cod__colors-list' + (st.qty >= 2 ? ' is-grid' : '');
        var clbl = document.getElementById('bo-cod-colors-label'); if (clbl) clbl.textContent = (st.qty === 1 ? 'Elige el color de tu ' : 'Color de cada ') + (st.unitWord || 'pack');
        for (var i = 0; i < st.qty; i++) {
          if (st.packColors[i] == null) st.packColors[i] = st.defaultVariant;
          var row = document.createElement('div'); row.className = 'bo-cod__colorrow';
          var lab = document.createElement('span'); lab.textContent = st.qty > 1 ? ('Pack ' + (i + 1)) : 'Color';
          var sel = document.createElement('select'); sel.className = 'bo-cod__input bo-cod__select'; sel.setAttribute('data-pack', i);
          variants.forEach(function (v) { var o = document.createElement('option'); o.value = v.id; o.textContent = v.label; if (String(v.id) === String(st.packColors[i])) o.selected = true; sel.appendChild(o); });
          row.appendChild(lab); row.appendChild(sel); list.appendChild(row);
        }
        st.packColors = st.packColors.slice(0, st.qty);
        renderPackStrip();
      }
      function renderPackStrip() {
        var strip = document.getElementById('bo-cod-packstrip'); if (!strip) return;
        if (st.qty < 2 || variants.length < 2) { strip.hidden = true; strip.innerHTML = ''; return; }
        strip.innerHTML = '';
        for (var i = 0; i < st.qty; i++) {
          var vid = st.packColors[i] || st.defaultVariant;
          var v = variants.filter(function (x) { return String(x.id) === String(vid); })[0] || variants[0];
          var cell = document.createElement('div'); cell.className = 'bo-cod__packthumb';
          var img = document.createElement('img'); img.src = (v && v.img) ? v.img : ''; img.alt = v ? v.label : ''; img.width = 42; img.height = 42; img.loading = 'lazy';
          cell.appendChild(img); strip.appendChild(cell);
        }
        strip.hidden = false;
      }
      function savingForQty(q) {
        var t = st.savingsByQty || {};
        if (t[q] != null) return t[q];
        var ks = Object.keys(t).map(Number).filter(function (n) { return !isNaN(n); });
        if (!ks.length) return st.saving || 0;
        var maxQ = Math.max.apply(null, ks);
        return q > maxQ ? t[maxQ] : (st.saving || 0);
      }
      function setStep(name) {
        st.step = name;
        dlg.querySelectorAll('.bo-cod__step').forEach(function (s) { s.hidden = s.getAttribute('data-step') !== name; });
      }
      function clearTimers() { if (st.t1) clearInterval(st.t1); if (st.t2) clearInterval(st.t2); }
      function realClose() { clearTimers(); if (typeof dlg.close === 'function') dlg.close(); else dlg.removeAttribute('open'); }
      function filledFields() {
        var ids = ['bo-cod-name-in', 'bo-cod-phone-in', 'bo-cod-city-in', 'bo-cod-addr-in', 'bo-cod-prov-in'];
        var n = 0;
        ids.forEach(function (id) { var el = document.getElementById(id); if (el && el.value && el.value.trim() !== '') n++; });
        return n;
      }
      function exitEligible() {
        try { var t = parseInt(localStorage.getItem('bo_cod_exit_seen') || '0', 10); if (t && (Date.now() - t) < 2592000000) return false; } catch (e) {}
        return true;
      }
      function attemptClose() {
        if (exitEnabled && exitPct > 0 && !st.exitShown && st.step === 'form' && filledFields() >= 2 && exitEligible()) { showExit(); return; }
        realClose();
      }
      function setUpsellPreview(vid) {
        var v = variants.filter(function (x) { return String(x.id) === String(vid); })[0] || variants[0];
        if (!v) return;
        var img = document.getElementById('bo-cod-upimg'); if (img && v.img) img.src = v.img;
        var lab = document.getElementById('bo-cod-upvar'); if (lab) lab.textContent = v.label || '';
      }
      function countdown(elId, secs, onExpire) {
        var left = secs; var el = document.getElementById(elId);
        function fmt() { var m = Math.floor(left / 60), s = left % 60; return m + ':' + (s < 10 ? '0' : '') + s; }
        var iv = setInterval(function () {
          if (left <= 0) { clearInterval(iv); if (onExpire) onExpire(); return; }
          if (el) el.textContent = el.getAttribute('data-prefix') ? (el.getAttribute('data-prefix') + ' ' + fmt()) : fmt();
          left--;
        }, 1000);
        if (el) el.textContent = el.getAttribute('data-prefix') ? (el.getAttribute('data-prefix') + ' ' + fmt()) : fmt();
        return iv;
      }
      function toggleEncomienda(on) {
        st.encomienda = on;
        var prov = document.getElementById('bo-cod-province'); if (prov) prov.hidden = !on;
        var provIn = document.getElementById('bo-cod-prov-in'); if (provIn) provIn.required = on;
        // Encomienda: NO se piden dirección ni ubicación (es por encomienda, no a domicilio).
        var del = document.getElementById('bo-cod-delivery-fields'); if (del) del.hidden = on;
        var addrIn = document.getElementById('bo-cod-addr-in'); if (addrIn) addrIn.required = !on;
        if (!on) { var acl = document.getElementById('bo-cod-prov-list'); if (acl) { acl.hidden = true; acl.innerHTML = ''; } }
        var sub = document.getElementById('bo-cod-sub');
        if (sub) sub.textContent = on ? 'Tu zona es por encomienda (pago anticipado por QR).' : 'Pago contra entrega. No pagas nada por adelantado.';
        dlg.querySelectorAll('[data-trust="cod"]').forEach(function (s) { s.hidden = on; });
        dlg.querySelectorAll('[data-trust="enc"]').forEach(function (s) { s.hidden = !on; });
        renderTotal();
      }

      var SAVE_KEY = 'bo_cod_customer_v1';
      function loadSaved() {
        var data;
        try { data = JSON.parse(localStorage.getItem(SAVE_KEY) || 'null'); } catch (e) { data = null; }
        if (!data) return;
        function setVal(id, v) { var el = document.getElementById(id); if (el && v) el.value = v; }
        setVal('bo-cod-name-in', data.name); setVal('bo-cod-phone-in', data.phone);
        setVal('bo-cod-addr-in', data.address); setVal('bo-cod-loc-in', data.location); if (data.location) markGeoDone();
        var cityEl = document.getElementById('bo-cod-city-in');
        if (cityEl && data.city) {
          var known = Array.prototype.some.call(cityEl.options, function (o) { return o.value === data.city; });
          if (known && data.city !== '__otra__') { cityEl.value = data.city; toggleEncomienda(false); }
          else { cityEl.value = '__otra__'; setVal('bo-cod-prov-in', data.province || (known ? '' : data.city)); toggleEncomienda(true); }
        }
        var hint = document.getElementById('bo-cod-saved-hint'); if (hint) hint.hidden = false;
      }
      function saveCustomer(c) {
        try { localStorage.setItem(SAVE_KEY, JSON.stringify({ name: c.name, phone: c.phone, city: c.city, province: c.province, address: c.address, location: c.location })); } catch (e) {}
      }
      function markGeoDone() {
        var btn = document.getElementById('bo-cod-geo-btn'); if (!btn) return;
        btn.classList.add('is-done');
        var mn = btn.querySelector('.bo-cod__locbtn-tx'); if (mn) mn.textContent = 'Listo';
      }
      function resetLocation() {
        var btn = document.getElementById('bo-cod-geo-btn');
        if (btn) { btn.classList.remove('is-done'); var mn = btn.querySelector('.bo-cod__locbtn-tx'); if (mn) mn.textContent = 'Compartir ubicación'; }
        var note = document.getElementById('bo-cod-loc-note'); if (note) note.hidden = true;
        var hint = document.getElementById('bo-cod-saved-hint'); if (hint) hint.hidden = true;
      }
      function clearSaved() {
        try { localStorage.removeItem(SAVE_KEY); } catch (e) {}
        ['bo-cod-name-in', 'bo-cod-phone-in', 'bo-cod-addr-in', 'bo-cod-loc-in', 'bo-cod-prov-in'].forEach(function (id) { var el = document.getElementById(id); if (el) el.value = ''; });
        var cityEl = document.getElementById('bo-cod-city-in'); if (cityEl) cityEl.selectedIndex = 0;
        toggleEncomienda(false);
        resetLocation();
        var nm = document.getElementById('bo-cod-name-in'); if (nm) { try { nm.focus(); } catch (e) {} }
      }
      function requestGeo() {
        var note = document.getElementById('bo-cod-loc-note'); var input = document.getElementById('bo-cod-loc-in');
        function say(t) { if (note) { note.hidden = false; note.textContent = t; } }
        if (!navigator.geolocation) { say('Tu navegador no permite GPS. Pega tu link de Maps en el campo.'); return; }
        say('Obteniendo tu ubicación...');
        navigator.geolocation.getCurrentPosition(function (pos) {
          var lat = pos.coords.latitude.toFixed(6), lng = pos.coords.longitude.toFixed(6);
          if (input) input.value = 'https://www.google.com/maps?q=' + lat + ',' + lng;
          say('Ubicación capturada. La compartimos con el repartidor.'); markGeoDone();
        }, function () { say('No pudimos obtener tu ubicación. Pega tu link de Maps en el campo.'); },
        { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 });
      }
      function buildWaEscape() {
        var a = document.getElementById('bo-cod-wa-help'); if (!a || !waNumber) return;
        var nm = document.getElementById('bo-cod-name'); var title = nm ? nm.textContent : 'Tiras Nasales';
        var cols = st.packColors.slice(0, st.qty).map(function (vid) { var v = variants.filter(function (x) { return String(x.id) === String(vid || st.defaultVariant); })[0]; return v ? v.label : ''; }).filter(Boolean);
        var msg = 'Hola, quiero pedir ' + st.qty + ' pack(s) de ' + title + (cols.length ? ' (' + cols.join(', ') + ')' : '') + '. Pago contra entrega.';
        a.href = 'https://wa.me/' + waNumber + '?text=' + encodeURIComponent(msg);
      }
      document.addEventListener('bo:open-cod', function (e) {
        var d = e.detail || {};
        clearTimers();
        st = { defaultVariant: d.variantId, qty: d.qty || 1, unitPrice: d.unitPrice || 0, saving: d.saving || 0, savingsByQty: Object.assign({}, popupSavings, (d.savingsByQty || {})),
          moneyFormat: d.moneyFormat || '{{amount}}', packColors: [], encomienda: false, customer: {},
          upsellShown: false, upsellExtraCents: 0, upsellPacks: [], upsellPrice: 0, orderId: '', orderName: '',
          exitShown: false, discountPct: 0, discountCode: '', step: 'form', t1: null, t2: null, paymentInfoSent: false, offerId: inferOfferId(d), idempotencyKey: codIdempotencyKey(), formStartedAt: Date.now(),
          stickerVariantId: d.stickerVariantId || 0, kitStickerPacks: d.stickerPacks || 0, kitSaving: d.kitSaving || 0, unitWord: (d.stickerVariantId ? 'kit' : 'pack'), stickerExtraPacks: 0, stickerExtraCents: 0, days: d.days || 0, kitName: d.kitName || '', kits: (d.kits || []), kitIndex: (d.kitIndex != null ? d.kitIndex : -1) };
        // Popup product-agnostic: el disparador puede sobreescribir variantes/packnote/unidad (ej. el card de Stickers en la PDP del Dilatador).
        variants = (d.variants != null) ? d.variants : pageVariants;
        nudgeUnit = d.nudgeUnit || dlg.getAttribute('data-nudge-unit') || 'tiras';
        var nm = document.getElementById('bo-cod-name'); if (nm && d.title) nm.textContent = d.title;
        var im = document.getElementById('bo-cod-img'); if (im && d.image) im.src = d.image;
        // Dilatador: ocultamos el packnote y mostramos el bloque "incluye" (4 tallas + pares del kit).
        // Tiras/Cinta: packnote normal (texto del setting), sin bloque incluye.
        var pnote = dlg.querySelector('.bo-cod__packnote'); if (pnote) { pnote.hidden = !!d.stickerVariantId; if (d.packNote) pnote.textContent = d.packNote; }
        renderIncludes();
        var cityEl = document.getElementById('bo-cod-city-in'); if (cityEl) cityEl.selectedIndex = 0;
        cityAutoSet = false;
        toggleEncomienda(false);
        var perr = document.getElementById('bo-cod-phone-err'); if (perr) perr.hidden = true;
        var pin = document.getElementById('bo-cod-phone-in'); if (pin) pin.removeAttribute('aria-invalid');
        resetLocation();
        renderColors(); renderTotal(); renderStickerUpsell(); setStep('form');
        loadSaved();
        applyDetectedCity();
        updateCityChange();
        try { if (window.boTrack) boTrack('InitiateCheckout', { content_ids: [String(st.defaultVariant)], content_type: 'product', contents: [{ id: String(st.defaultVariant), quantity: st.qty }], num_items: st.qty, value: orderTotalCents() / 100, currency: 'BOB' }); } catch (e) {}
        codTrack('cod_open', boEntry());
        if (typeof dlg.showModal === 'function') { dlg.showModal(); } else { dlg.setAttribute('open', ''); }
        setTimeout(function () { var h = document.getElementById('bo-cod-formtitle'); if (h) { try { h.focus({ preventScroll: true }); } catch (e) {} } }, 60);
      });

      dlg.addEventListener('input', function (e) {
        if (e.target.id !== 'bo-cod-phone-in' || st.paymentInfoSent) return;
        var raw = (e.target.value || '').replace(/\D/g, '').replace(/^591/, '');
        if (/^[67]\d{7}$/.test(raw)) {
          st.paymentInfoSent = true;
          st.phone = '+591' + raw;
          codTrack('cod_phone', { phone: st.phone });
        }
      });

      // cod_start: primera interacción real del cliente con el formulario (una sola vez por apertura)
      function boMarkStart() { if (st.started) return; st.started = true; codTrack('cod_start'); }
      dlg.addEventListener('input', function (e) { if (e.target.closest('[data-cod-form]')) boMarkStart(); });
      dlg.addEventListener('change', function (e) { if (e.target.closest('[data-cod-form]')) boMarkStart(); });

      dlg.addEventListener('change', function (e) {
        var packSel = e.target.closest('[data-pack]');
        if (packSel) {
          st.packColors[parseInt(packSel.getAttribute('data-pack'), 10)] = packSel.value;
          // La foto del resumen sigue al color elegido (el último que tocaste en multi-pack).
          var pv = variants.filter(function (x) { return String(x.id) === String(packSel.value); })[0];
          var im = document.getElementById('bo-cod-img'); if (im && pv && pv.img) im.src = pv.img;
          renderPackStrip();
          return;
        }
        if (e.target.id === 'bo-cod-city-in') { cityAutoSet = false; updateCityChange(); toggleEncomienda(e.target.value === '__otra__'); return; }
        if (e.target.id === 'bo-cod-upsel') { setUpsellPreview(e.target.value); return; }
      });
      dlg.addEventListener('input', function (e) {
        if (e.target.id === 'bo-cod-prov-in') renderAcSuggestions(e.target.value);
      });
      dlg.addEventListener('mousedown', function (e) {
        var item = e.target.closest('.bo-cod__ac-item');
        if (!item) return;
        e.preventDefault();
        var input = document.getElementById('bo-cod-prov-in'); if (input) input.value = item.getAttribute('data-val');
        var list = document.getElementById('bo-cod-prov-list'); if (list) { list.hidden = true; list.innerHTML = ''; }
      });
      dlg.addEventListener('focusout', function (e) {
        if (e.target.id === 'bo-cod-prov-in') { setTimeout(function () { var list = document.getElementById('bo-cod-prov-list'); if (list) list.hidden = true; }, 150); }
      });
      dlg.addEventListener('cancel', function (e) { e.preventDefault(); attemptClose(); });

      dlg.addEventListener('click', function (e) {
        if (e.target.closest('[data-cod-close]')) { e.preventDefault(); attemptClose(); return; }
        if (e.target === dlg) { attemptClose(); return; }
        if (e.target.closest('[data-cod-exit-apply]')) { e.preventDefault(); applyExit(); return; }
        if (e.target.closest('[data-cod-exit-leave]')) { e.preventDefault(); realClose(); return; }
        if (e.target.closest('[data-cod-copy]')) { e.preventDefault(); var cb = e.target.closest('[data-cod-copy]'); try { navigator.clipboard.writeText(st.discountCode); } catch (er) {} cb.textContent = 'Copiado'; setTimeout(function () { cb.textContent = 'Copiar'; }, 1500); return; }
        var q = e.target.closest('[data-cod-qty]');
        if (q) { st.qty = Math.max(1, st.qty + (parseInt(q.getAttribute('data-cod-qty'), 10) || 0)); st.saving = st.stickerVariantId ? 0 : savingForQty(st.qty); renderColors(); renderTotal(); return; }
        if (e.target.closest('[data-cod-nudge]')) { e.preventDefault(); st.qty += 1; st.saving = savingForQty(st.qty); renderColors(); renderTotal(); return; }
        if (e.target.closest('[data-cod-sticker-add]')) { e.preventDefault(); if ((st.stickerExtraPacks || 0) > 0) { st.stickerExtraPacks = 0; st.stickerExtraCents = 0; } else { st.stickerExtraPacks = 1; st.stickerExtraCents = stUpPrice * 100; } renderTotal(); renderStickerUpsell(); renderIncludes(); return; }
        if (e.target.closest('[data-cod-city-change]')) { e.preventDefault(); var csel = document.getElementById('bo-cod-city-in'); if (csel) { csel.focus(); try { if (csel.showPicker) csel.showPicker(); } catch (er) {} } return; }
        if (e.target.closest('[data-cod-geo]')) { e.preventDefault(); requestGeo(); return; }
        if (e.target.closest('[data-cod-forget]')) { e.preventDefault(); clearSaved(); return; }
        if (e.target.closest('[data-cod-vguide]')) { e.preventDefault(); openVguide(); return; }
        if (e.target.closest('[data-cod-kits]')) { e.preventDefault(); openKitModal(); return; }
        if (e.target.closest('[data-cod-help]')) { e.preventDefault(); openHelp(); return; }
        if (e.target.closest('[data-cod-disc-apply]')) { e.preventDefault(); applyDiscountCode(); return; }
        if (e.target.closest('[data-cod-confirm]')) { e.preventDefault(); submit(); return; }
        if (e.target.closest('[data-cod-upyes]')) { e.preventDefault(); acceptUpsell(); return; }
        if (e.target.closest('[data-cod-upno]')) { e.preventDefault(); declineUpsell(); return; }
      });

      function submit() {
        var form = dlg.querySelector('[data-cod-form]');
        if (form && typeof form.reportValidity === 'function' && !form.reportValidity()) return;
        if (!validatePhone()) return;
        st.customer = {};
        if (form) form.querySelectorAll('input, select').forEach(function (i) { if (i.name) st.customer[i.name] = i.value; });
        saveCustomer(st.customer);
        finalize();
      }
      function validatePhone() {
        var el = document.getElementById('bo-cod-phone-in');
        var err = document.getElementById('bo-cod-phone-err');
        if (!el) return true;
        var raw = (el.value || '').replace(/\D/g, '').replace(/^591/, '');
        var ok = /^[67]\d{7}$/.test(raw);
        if (ok) { if (err) err.hidden = true; el.removeAttribute('aria-invalid'); return true; }
        if (err) { err.hidden = false; err.textContent = 'Ingresa un celular válido: 8 dígitos que empiezan en 6 o 7.'; }
        el.setAttribute('aria-invalid', 'true');
        try { el.focus(); } catch (e) {}
        return false;
      }

      function showExit() {
        st.exitShown = true;
        codTrack('exit_view');
        try { localStorage.setItem('bo_cod_exit_seen', String(Date.now())); } catch (e) {}
        st.discountCode = exitPrefix + exitPct + '-' + Math.random().toString(36).slice(2, 6).toUpperCase();
        try { localStorage.setItem('bo_cod_exit_code', st.discountCode); localStorage.setItem('bo_cod_exit_pct', String(exitPct)); } catch (e) {}
        var pe = document.getElementById('bo-cod-exit-pct'); if (pe) pe.textContent = exitPct;
        var code = document.getElementById('bo-cod-code'); if (code) code.textContent = st.discountCode;
        var ap = document.getElementById('bo-cod-exit-apply'); if (ap) ap.textContent = 'Aplicar ' + exitPct + '% y seguir';
        clearTimers();
        st.t1 = countdown('bo-cod-exit-timer', exitMin * 60, function () { var tm = document.getElementById('bo-cod-exit-timer'); if (tm) tm.textContent = 'vencido'; });
        setStep('exit');
      }
      function applyExit() {
        clearTimers();
        st.discountPct = exitPct;
        codTrack('exit_apply', { value: exitPct });
        renderTotal();
        setStep('form');
      }
      function discMsg(text, ok) {
        var m = document.getElementById('bo-cod-disc-msg'); if (!m) return;
        m.hidden = false; m.textContent = text; m.className = 'bo-cod__disc-msg ' + (ok ? 'is-ok' : 'is-err');
      }
      function applyDiscountCode() {
        var inp = document.getElementById('bo-cod-disc-in');
        var code = (inp ? inp.value : '').trim().toUpperCase();
        if (!code) { discMsg('Escribe un código.', false); return; }
        if (campaignCodes[code] != null) {
          st.discountPct = campaignCodes[code]; st.discountCode = code; renderTotal();
          discMsg('Cupón ' + code + ' aplicado: -' + st.discountPct + '%.', true); return;
        }
        var exCode = '', exPct = 0;
        try { exCode = (localStorage.getItem('bo_cod_exit_code') || '').toUpperCase(); exPct = parseInt(localStorage.getItem('bo_cod_exit_pct') || '0', 10); } catch (e) {}
        if (exCode && code === exCode && exPct > 0) {
          st.discountPct = exPct; st.discountCode = code; renderTotal();
          discMsg('Cupón aplicado: -' + st.discountPct + '%.', true); return;
        }
        discMsg('Ese código no es válido o ya venció.', false);
      }

      function finalize() {
        codTrack('cod_submit');
        var lines = {};
        st.packColors.slice(0, st.qty).forEach(function (vid) { vid = vid || st.defaultVariant; lines[vid] = (lines[vid] || 0) + 1; });
        var items = Object.keys(lines).map(function (vid) { return { variantId: parseInt(vid, 10), quantity: lines[vid] }; });
        var payloadSaving = st.saving;
        // Dilatador: los sticker packs (del kit + del upsell) van como líneas reales de la variante de stickers,
        // con su descuento bundle (160 standalone → precio bundle) para que el total coincida con lo que ve el cliente.
        if (st.stickerVariantId) {
          var totalStickerPacks = (st.kitStickerPacks * st.qty) + (st.stickerExtraPacks || 0);
          if (totalStickerPacks > 0) items.push({ variantId: st.stickerVariantId, quantity: totalStickerPacks });
          payloadSaving += (st.kitSaving * st.qty) + ((st.stickerExtraPacks || 0) * stUpSave);
        }
        var _an = codCtx();
        var website = document.getElementById('bo-cod-page-website');
        var payload = { action: 'create', offerId: st.offerId, idempotencyKey: st.idempotencyKey, formStartedAt: st.formStartedAt, website: website ? website.value : '', items: items, shipping: st.encomienda ? 'encomienda' : 'cod', encomiendaFee: fee, saving: payloadSaving, customer: st.customer, discountPct: st.discountPct, discountCode: st.discountCode, sid: _an.sid, ab: _an.ab, source: _an.source, product: _an.product, variant: _an.variant, pack: _an.pack, visitor_id: _an.visitor_id };
        function done(res) {
          clearTimers();
          try {
            var responseItems = res && Array.isArray(res.items) ? res.items : items;
            var contents = responseItems.map(function (item) { return { id: String(item.variantId), quantity: parseInt(item.quantity, 10) || 1 }; });
            var ids = contents.map(function (item) { return item.id; });
            var count = contents.reduce(function (sum, item) { return sum + item.quantity; }, 0);
            var eventId = st.orderId || ('bo-' + (st.orderName || 'demo') + '-' + new Date().getTime());
            var value = res && Number(res.total) >= 0 ? Number(res.total) : orderTotalCents() / 100;
            if (window.boTrack) boTrack('Purchase', { content_ids: ids, content_type: 'product', contents: contents, num_items: count, value: value, currency: (res && res.currency) || 'BOB' }, eventId);
          } catch (e) {}
          setStep('success');
          var h = document.getElementById('bo-cod-success-title'); if (h) { try { h.focus({ preventScroll: true }); } catch (e) {} }
          renderPostUpsell();
        }
        if (!endpoint) { var _dn = dlg.querySelector('[data-cod-demo-note]'); if (_dn) _dn.hidden = false; done(); return; }
        var btn = dlg.querySelector('[data-cod-confirm]'); if (btn) { btn.disabled = true; btn.style.opacity = '0.7'; }
        fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) })
          .then(function (r) { if (!r.ok) throw new Error('fail'); return r.json(); })
          .then(function (res) { if (res && res.orderId) { st.orderId = res.orderId; st.orderName = res.orderName || ''; } var n = dlg.querySelector('[data-cod-demo-note]'); if (n) n.hidden = true; done(res); })
          .catch(function () { alert('Hubo un problema. Intenta de nuevo o escríbenos por WhatsApp.'); })
          .finally(function () { if (btn) { btn.disabled = false; btn.style.opacity = ''; } });
      }

      function orderTotalCents() {
        var base = (st.unitPrice * st.qty) - (st.saving * 100);
        if (base < 0) base = st.unitPrice * st.qty;
        var goods = base + st.upsellExtraCents + (st.stickerExtraCents || 0);
        if (st.discountPct > 0) goods = Math.round(goods * (1 - st.discountPct / 100));
        return goods + (st.encomienda ? fee * 100 : 0);
      }
      function savingsCents() {
        // Dilatador: ahorro del kit (vs comprar dilatador + stickers por separado) + ahorro del upsell.
        // Tiras/Cinta: descuento por pack. Más el % del cupón exit-intent (si hay).
        var packSaveBs = st.stickerVariantId
          ? (st.kitSaving * st.qty + (st.stickerExtraPacks || 0) * stUpSave)
          : st.saving;
        var base = (st.unitPrice * st.qty) - (st.saving * 100);
        if (base < 0) base = st.unitPrice * st.qty;
        var goodsBefore = base + st.upsellExtraCents + (st.stickerExtraCents || 0);
        var pctSaveCents = st.discountPct > 0 ? Math.round(goodsBefore * st.discountPct / 100) : 0;
        return (packSaveBs * 100) + pctSaveCents;
      }
      function orderSummaryText() {
        var nm = document.getElementById('bo-cod-name');
        var prod = nm && nm.textContent ? nm.textContent.trim() : 'Tiras Nasales';
        var perPack = parseInt(String(upUnit || '').replace(/\D/g, ''), 10);
        var groups = {}, order = [];
        function add(vid) {
          vid = vid || st.defaultVariant;
          var v = variants.filter(function (x) { return String(x.id) === String(vid); })[0];
          var label = v ? v.label : '';
          if (groups[label] == null) { groups[label] = 0; order.push(label); }
          groups[label]++;
        }
        st.packColors.slice(0, st.qty).forEach(add);
        (st.upsellPacks || []).forEach(add);
        return order.map(function (label) {
          var n = groups[label];
          var s = n + ' Pack' + (n > 1 ? 's' : '') + ' ' + prod + (label ? ' ' + label : '');
          if (perPack) s += ' (' + (n * perPack) + ' tiras)';
          return s;
        }).join(', ');
      }
      function buildOrderMessage() {
        var c = st.customer || {};
        var totalBs = Math.round(orderTotalCents() / 100);
        var cityVal = st.encomienda ? (c.province || c.city || '') : (c.city || '');
        var addrVal = st.encomienda ? 'Por encomienda (pago anticipado por QR)' : (c.address || '');
        var payNote = st.encomienda ? ' (pago anticipado por QR)' : ' (contra entrega)';
        var L = [];
        L.push('Hola, me gustaría confirmar mi pedido de biOptimización.');
        L.push('');
        L.push('* *Resumen del pedido:* ' + orderSummaryText());
        L.push('* *Nombre:* ' + (c.name || ''));
        L.push('* *Celular:* ' + (c.phone || ''));
        L.push('* *Ciudad:* ' + cityVal);
        L.push('* *Dirección de entrega:* ' + addrVal);
        if (c.location && String(c.location).trim()) L.push('* *Ubicación:* ' + String(c.location).trim());
        L.push('* *Total a pagar:* ' + totalBs + ' Bs.' + payNote);
        if (st.orderName) { L.push(''); L.push('Pedido ' + st.orderName); }
        return L.join('\n');
      }
      function setWhatsApp() {
        var wa = document.getElementById('bo-cod-wa');
        if (!wa || !waNumber) return;
        wa.href = 'https://wa.me/' + waNumber + '?text=' + encodeURIComponent(buildOrderMessage());
        wa.hidden = false;
      }
      function renderPostUpsell() {
        var pu = document.getElementById('bo-cod-pu');
        // Sin oferta para esta cantidad → ir directo al cierre (Momento B).
        if (!pu || !upEnabled || st.upsellShown || offers[st.qty] == null) { if (pu) pu.hidden = true; showFinal(false); return; }
        st.upsellShown = true; st.upsellPrice = offers[st.qty];
        codTrack('upsell_view', { value: st.upsellPrice });
        var fin = document.getElementById('bo-cod-final'); if (fin) fin.hidden = true; // ocultar el cierre mientras decide
        pu.hidden = false;
        var txt = document.getElementById('bo-cod-uptext'); if (txt) txt.textContent = 'Otro pack (' + upUnit + ') por solo +' + st.upsellPrice + ' Bs, con envío gratis.';
        var yes = document.getElementById('bo-cod-upyes'); if (yes) { yes.textContent = 'Sí, agregar — +' + st.upsellPrice + ' Bs'; yes.disabled = false; yes.style.opacity = ''; }
        var upc = document.getElementById('bo-cod-upcolor'); var upsel = document.getElementById('bo-cod-upsel');
        if (upChoose && variants.length > 1 && upc && upsel) {
          upc.hidden = false; upsel.innerHTML = '';
          variants.forEach(function (v) { var o = document.createElement('option'); o.value = v.id; o.textContent = v.label; if (String(v.id) === String(st.defaultVariant)) o.selected = true; upsel.appendChild(o); });
        } else if (upc) { upc.hidden = true; }
        setUpsellPreview(st.defaultVariant);
        var tEl = document.getElementById('bo-cod-uptimer'); if (tEl) tEl.setAttribute('data-prefix', 'Oferta termina en');
        clearTimers();
        // Al vencer el timer, la oferta desaparece y pasa al cierre (no deja al cliente atrapado).
        st.t2 = countdown('bo-cod-uptimer', upTimer, function () { showFinal(false); });
      }
      function showFinal(added) {
        clearTimers();
        var pu = document.getElementById('bo-cod-pu'); if (pu) pu.hidden = true;
        var fin = document.getElementById('bo-cod-final'); if (fin) fin.hidden = false;
        var ad = document.getElementById('bo-cod-added'); if (ad) ad.hidden = !added;
        setWhatsApp();
      }
      function acceptUpsell() {
        clearTimers();
        var upsel = document.getElementById('bo-cod-upsel'); var upc = document.getElementById('bo-cod-upcolor');
        var extraColor = (upChoose && upsel && upc && !upc.hidden) ? upsel.value : st.defaultVariant;
        var yes = document.getElementById('bo-cod-upyes');
        st.upsellPacks.push(extraColor); st.upsellExtraCents += (st.upsellPrice || 0) * 100;
        codTrack('upsell_accept', { value: st.upsellPrice || 0 });
        // Sin servidor (demo) o sin orden creada → confirmar visual y pasar al cierre.
        if (!endpoint || !st.orderId) { showFinal(true); return; }
        if (yes) { yes.disabled = true; yes.style.opacity = '0.7'; yes.textContent = 'Agregando...'; }
        fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ action: 'upsell', orderId: st.orderId, variantId: parseInt(extraColor, 10), price: st.upsellPrice }) })
          .then(function (r) { if (!r.ok) throw new Error('fail'); return r.json(); })
          .then(function (res) {
            try { if (window.boTrack) boTrack('UpsellPurchase', { content_ids: [String(extraColor)], content_type: 'product', contents: [{ id: String(extraColor), quantity: 1 }], num_items: 1, value: Number(res && res.promoPrice) || st.upsellPrice, currency: 'BOB' }, (st.orderId || 'order') + '-upsell'); } catch (e) {}
            showFinal(true);
          })
          .catch(function () { if (yes) { yes.disabled = false; yes.style.opacity = ''; yes.textContent = 'Sí, agregar — +' + st.upsellPrice + ' Bs'; } alert('No pudimos agregar el pack extra. Escríbenos por WhatsApp y lo sumamos.'); });
      }
      function declineUpsell() { clearTimers(); codTrack('upsell_reject'); showFinal(false); }
      function openVguide() {
        var g = document.querySelector('[data-bo-vguide]');
        if (!g) return;
        try { if (typeof g.showModal === 'function') g.showModal(); else g.setAttribute('open', ''); } catch (e) {}
      }
      // Si el cliente elige una variante DENTRO de la guía con el form abierto, la aplicamos al pack.
      document.addEventListener('click', function (e) {
        var card = e.target.closest('[data-bo-vguide-pick]');
        if (!card || !dlg.open) return;
        var key = acNorm(card.getAttribute('data-bo-vguide-pick') || '');
        var v = variants.filter(function (x) { return acNorm(x.label).indexOf(key) === 0; })[0];
        if (!v) return;
        st.defaultVariant = v.id; st.packColors = [];
        renderColors(); renderTotal();
        var im = document.getElementById('bo-cod-img'); if (im && v.img) im.src = v.img;
      });
      // El link "¿Cuál me conviene?" solo se muestra si la guía existe en la página (la renderiza el buybox).
      if (document.querySelector('[data-bo-vguide]')) { var vgLink = dlg.querySelector('[data-cod-vguide]'); if (vgLink) vgLink.hidden = false; }
      function openHelp() {
        var h = document.querySelector('[data-bo-help]');
        if (!h) return;
        try { var c = localStorage.getItem('bo_dp_city'); if (c) { document.dispatchEvent(new CustomEvent('bo:dp-citychange', { detail: { city: c } })); } } catch (e) {}
        try { if (typeof h.showModal === 'function') h.showModal(); else h.setAttribute('open', ''); } catch (e) {}
      }
      var helpEl = document.querySelector('[data-bo-help]');
      if (helpEl) { helpEl.addEventListener('click', function (e) { if (e.target === helpEl) { try { helpEl.close(); } catch (x) {} } }); }
      function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
      function openKitModal() {
        var modal = document.querySelector('[data-bo-kitmodal]');
        var list = document.getElementById('bo-cod-kitmodal-list');
        if (!modal || !list || !st.kits || !st.kits.length) return;
        list.innerHTML = st.kits.map(function (k, i) {
          var active = (i === st.kitIndex);
          var save = k.saving > 0 ? '<span class="bo-cod__kitcard-save">Ahorras ' + k.saving + ' Bs</span>' : '<span class="bo-cod__kitcard-start">Para empezar</span>';
          var action = active ? '<span class="bo-cod__kitcard-current">Tu elección actual</span>' : '<button type="button" class="bo-cod__kitcard-pick" data-cod-kit-pick="' + i + '">Elegir este kit</button>';
          return '<div class="bo-cod__kitcard' + (active ? ' is-active' : '') + '">' +
            '<div class="bo-cod__kitcard-top"><span class="bo-cod__kitcard-name">' + esc(k.label) + ' de stickers</span><span class="bo-cod__kitcard-price">' + money(k.price) + '</span></div>' +
            '<ul class="bo-cod__kitcard-feats"><li>Dilatador + 4 tallas</li><li>' + k.days + ' pares de stickers</li><li>~' + k.days + ' días de uso</li></ul>' +
            '<div class="bo-cod__kitcard-foot">' + save + action + '</div>' +
          '</div>';
        }).join('');
        try { if (typeof modal.showModal === 'function') modal.showModal(); else modal.setAttribute('open', ''); } catch (e) {}
      }
      function selectKit(i) {
        var k = st.kits && st.kits[i]; if (!k) return;
        st.kitIndex = i; st.days = k.days; st.kitStickerPacks = k.stickerPacks; st.kitSaving = k.saving; st.unitPrice = k.price; st.kitName = k.label;
        st.stickerExtraPacks = 0; st.stickerExtraCents = 0;
        renderTotal(); renderIncludes(); renderStickerUpsell();
        var modal = document.querySelector('[data-bo-kitmodal]'); if (modal) { try { modal.close(); } catch (e) {} }
      }
      var kitModalEl = document.querySelector('[data-bo-kitmodal]');
      if (kitModalEl) { kitModalEl.addEventListener('click', function (e) { if (e.target === kitModalEl) { try { kitModalEl.close(); } catch (x) {} return; } var kp = e.target.closest('[data-cod-kit-pick]'); if (kp) { e.preventDefault(); selectKit(parseInt(kp.getAttribute('data-cod-kit-pick'), 10)); } }); }
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bo-cod-popup"] && !Shopify.designMode) return;
  try {
    
    (function () {
      var dlg = document.getElementById('bo-cod-dialog');
      if (!dlg || dlg.__boCodInit) return;
      dlg.__boCodInit = true;
      var endpoint = (dlg.getAttribute('data-endpoint') || '').trim();
      var fee = parseInt(dlg.getAttribute('data-fee'), 10) || 0;
      var upEnabled = dlg.getAttribute('data-up-enabled') === '1';
      var upChoose = dlg.getAttribute('data-up-choose') === '1';
      var upTimer = parseInt(dlg.getAttribute('data-up-timer'), 10) || 150;
      var upUnit = dlg.getAttribute('data-up-unit') || '30 tiras';
      var exitEnabled = dlg.getAttribute('data-exit-enabled') === '1';
      var exitPct = parseInt(dlg.getAttribute('data-exit-pct'), 10) || 0;
      var exitMin = parseInt(dlg.getAttribute('data-exit-min'), 10) || 5;
      var exitPrefix = dlg.getAttribute('data-exit-prefix') || 'BIO';
      var nudgeEnabled = dlg.getAttribute('data-nudge-enabled') === '1';
      var nudgeUnit = dlg.getAttribute('data-nudge-unit') || 'tiras';
      var popupSavings = {};
      (dlg.getAttribute('data-nudge-savings') || '').split(',').forEach(function (pair) {
        var kv = pair.split(':'); if (kv.length === 2) { var q = parseInt(kv[0], 10); var s = parseInt(kv[1], 10); if (q > 0 && s >= 0) popupSavings[q] = s; }
      });
      var offers = {};
      (dlg.getAttribute('data-up-offers') || '').split(',').forEach(function (pair) {
        var kv = pair.split(':'); if (kv.length === 2) { var q = parseInt(kv[0], 10); var pr = parseInt(kv[1], 10); if (q > 0 && pr >= 0) offers[q] = pr; }
      });
      var campaignCodes = {};
      (dlg.getAttribute('data-disc-codes') || '').split(',').forEach(function (pair) {
        var kv = pair.split(':'); if (kv.length === 2) { var c = kv[0].trim().toUpperCase(); var p = parseInt(kv[1], 10); if (c && p > 0 && p <= 90) campaignCodes[c] = p; }
      });
      var pageVariants = [];
      try { pageVariants = JSON.parse(document.getElementById('bo-cod-variants').textContent); } catch (e) {}
      var variants = pageVariants;
      var waNumber = (dlg.getAttribute('data-wa-number') || '').replace(/[\u0300-\u036f]/g, '');
      var waMsg = dlg.getAttribute('data-wa-msg') || '';
      var stUpEnabled = dlg.getAttribute('data-sticker-up-enabled') === '1';
      var stUpLabel = dlg.getAttribute('data-sticker-up-label') || '30 pares de stickers';
      var stUpSub = dlg.getAttribute('data-sticker-up-sub') || '';
      var stUpPrice = parseInt(dlg.getAttribute('data-sticker-up-price'), 10) || 100;
      var stUpSave = parseInt(dlg.getAttribute('data-sticker-up-save'), 10) || 60;
      var abV2Enabled = dlg.getAttribute('data-ab-v2') === '1';
      var abMsEnabled = dlg.getAttribute('data-ab-ms') === '1';
      var exitMode = dlg.getAttribute('data-exit-mode') || 'cupon';
      var exitWaNumber = dlg.getAttribute('data-exit-wa-number') || '';
      var bumpEnabled = dlg.getAttribute('data-bump-enabled') === '1';
      var bumpVariantId = parseInt(dlg.getAttribute('data-bump-variant') || '0', 10) || 0;
      var bumpPrice = parseInt(dlg.getAttribute('data-bump-price') || '120', 10);
      var bumpSave = Math.max(0, parseInt(dlg.getAttribute('data-bump-save') || '0', 10));
      var bumpTitle = dlg.getAttribute('data-bump-title') || 'Agrega la Cinta Bucal (30 noches)';
      var bumpSub = dlg.getAttribute('data-bump-sub') || '';
      var bumpAddedSub = dlg.getAttribute('data-bump-added-sub') || 'Se sumó a tu pedido';
      var bumpLabel = dlg.getAttribute('data-bump-label') || 'Cinta Bucal';
      var bumpImg = dlg.getAttribute('data-bump-img') || '';
      var st = {};

      /* --- Analíticas del funnel: envía eventos a <endpoint>/track. Todo defensivo: nunca rompe la compra. --- */
      function boSid() {
        try { var k = 'bo_sid', s = sessionStorage.getItem(k);
          if (!s) { s = 's' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8); sessionStorage.setItem(k, s); }
          return s; } catch (e) { return ''; }
      }
      function codIdempotencyKey() {
        try { if (crypto && typeof crypto.randomUUID === 'function') return 'cod_' + crypto.randomUUID().replace(/-/g, ''); } catch (e) {}
        return 'cod_' + Date.now().toString(36) + Math.random().toString(36).slice(2, 14);
      }
      function inferOfferId(detail) {
        if (detail.offerId) return detail.offerId;
        if (detail.stickerVariantId) return 'dilatador-pdp';
        var id = parseInt(detail.variantId, 10) || 0;
        if ([42562312634438, 42562312667206, 42562312699974].indexOf(id) >= 0) return 'tiras-pdp';
        if ([43188148371526, 43208634662982].indexOf(id) >= 0) return 'cinta-pdp';
        if (id === 44452590387270) return 'stickers-pdp';
        if (id === 45182051844166) return 'edicion-tierra-pdp';
        if ([44464796860486, 44464796893254].indexOf(id) >= 0) return 'dilatador-pdp';
        if ([43208698462278, 43208698495046, 43208698527814, 43220991639622, 43220991606854, 43220991672390, 43220992524358, 43220992458822, 43220992491590].indexOf(id) >= 0) return 'combo-pdp';
        return 'standard';
      }
      function boAb() {
        try { var k = 'bo_ab', a = localStorage.getItem(k);
          if (!a) { a = (Math.random() < 0.5 ? 'A' : 'B'); localStorage.setItem(k, a); }
          return a; } catch (e) { return ''; }
      }
      function boSource() {
        try { var k = 'bo_src', s = sessionStorage.getItem(k); if (s) return s;
          var p = new URLSearchParams(location.search); var src = p.get('utm_source') || '';
          if (!src) { var ref = document.referrer || ''; if (ref) { try { src = new URL(ref).hostname.replace(/^www\./, ''); } catch (e) {} } if (!src) src = 'direct'; }
          sessionStorage.setItem(k, src); return src; } catch (e) { return ''; }
      }
      function boEvId() { try { return 'e' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8); } catch (e) { return ''; } }
      function boVid() {
        try { var k = 'bo_vid', v = localStorage.getItem(k);
          if (!v) { v = 'v' + Date.now().toString(36) + Math.random().toString(36).slice(2, 10); localStorage.setItem(k, v); }
          return v; } catch (e) { return ''; }
      }
      function boEntry() {
        var o = { landing: '', path: '', referrer: '', utm_medium: '', utm_campaign: '', utm_content: '', utm_term: '' };
        try {
          o.landing = (location.href || '').slice(0, 500);
          o.path = (location.pathname || '').slice(0, 200);
          o.referrer = (document.referrer || '').slice(0, 500);
          var p = new URLSearchParams(location.search);
          o.utm_medium = (p.get('utm_medium') || '').slice(0, 80);
          o.utm_campaign = (p.get('utm_campaign') || '').slice(0, 120);
          o.utm_content = (p.get('utm_content') || '').slice(0, 120);
          o.utm_term = (p.get('utm_term') || '').slice(0, 120);
        } catch (e) {}
        return o;
      }
      function codCtx() {
        var variantLabel = '', city = '', product = '';
        try { var vid = (st.packColors && st.packColors[0]) || st.defaultVariant;
          var v = variants.filter(function (x) { return String(x.id) === String(vid); })[0]; variantLabel = v ? v.label : ''; } catch (e) {}
        try { var cs = document.getElementById('bo-cod-city-in'); city = (cs && cs.value && cs.value !== '__otra__') ? cs.value : (sharedCity() || ''); } catch (e) {}
        try { var nmEl = document.getElementById('bo-cod-name'); product = nmEl ? (nmEl.textContent || '').trim() : ''; } catch (e) {}
        return { sid: boSid(), ab: boAb(), source: boSource(), product: product, variant: variantLabel, pack: st.qty || 1, city: city, visitor_id: boVid() };
      }
      function codTrack(event, extra) {
        try {
          if (!endpoint) return; // demo (sin servidor) → no se trackea
          var ev = Object.assign({ id: boEvId(), event: event }, codCtx(), extra || {});
          var url = endpoint.replace(/\/+$/, '') + '/track';
          var body = JSON.stringify(ev);
          if (navigator.sendBeacon) { navigator.sendBeacon(url, body); }
          else { fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: body, keepalive: true }).catch(function () {}); }
        } catch (e) {}
      }
      // --- Preselección de ciudad: REUSA la ciudad ya detectada/elegida por el sistema de
      // entregas (snippet bo-delivery-promise → localStorage 'bo_dp_city' + evento 'bo:dp-citychange').
      // NO hace una segunda consulta IP. Prioridad: datos guardados del cliente > ciudad compartida.
      // La ciudad SIEMPRE queda editable; si el usuario la elige a mano, no la pisamos.
      var cityAutoSet = false;
      function sharedCity() { try { return localStorage.getItem('bo_dp_city') || ''; } catch (e) { return ''; } }
      function applyDetectedCity() {
        var sel = document.getElementById('bo-cod-city-in'); if (!sel) return;
        if (sel.value && sel.value !== '' && !cityAutoSet) return; // elegida a mano o guardada → respetar
        var c = sharedCity(); if (!c || sel.value === c) return;
        var has = Array.prototype.some.call(sel.options, function (o) { return o.value === c; });
        if (has) { sel.value = c; cityAutoSet = true; toggleEncomienda(false); renderTotal(); updateCityChange(); }
      }
      // La promesa de entrega y el form comparten la misma ciudad: si cambia allá (o la IP
      // resuelve tarde) lo reflejamos aquí, salvo que el usuario ya la haya elegido a mano.
      document.addEventListener('bo:dp-citychange', function () { applyDetectedCity(); });

      // Localidades de encomienda (fuente: source-bot/delivery.js ENCOMIENDA_ZONES). NO inventar.
      var LOCALITIES = [
        {n:'Viacha',d:'La Paz'},{n:'Caranavi',d:'La Paz'},{n:'Coroico',d:'La Paz'},{n:'Chulumani',d:'La Paz'},{n:'Palos Blancos',d:'La Paz'},{n:'Mapiri',d:'La Paz'},{n:'Achacachi',d:'La Paz'},{n:'Copacabana',d:'La Paz'},{n:'Patacamaya',d:'La Paz'},{n:'Guaqui',d:'La Paz'},{n:'Yungas',d:'La Paz'},{n:'Sorata',d:'La Paz'},{n:'Desaguadero',d:'La Paz'},
        {n:'Villa Tunari',d:'Cochabamba'},{n:'Shinahota',d:'Cochabamba'},{n:'Entre Ríos',d:'Cochabamba'},{n:'Ivirgarzama',d:'Cochabamba'},{n:'Chimoré',d:'Cochabamba'},{n:'Puerto Villarroel',d:'Cochabamba'},{n:'Punata',d:'Cochabamba'},{n:'Arani',d:'Cochabamba'},{n:'Mizque',d:'Cochabamba'},{n:'Aiquile',d:'Cochabamba'},{n:'Capinota',d:'Cochabamba'},{n:'Tiraque',d:'Cochabamba'},{n:'Cliza',d:'Cochabamba'},{n:'Chapare',d:'Cochabamba'},{n:'Bulo Bulo',d:'Cochabamba'},{n:'Isarzama',d:'Cochabamba'},
        {n:'Puerto Quijarro',d:'Santa Cruz'},{n:'Puerto Suárez',d:'Santa Cruz'},{n:'Roboré',d:'Santa Cruz'},{n:'San José de Chiquitos',d:'Santa Cruz'},{n:'Yapacaní',d:'Santa Cruz'},{n:'Camiri',d:'Santa Cruz'},{n:'Montero',d:'Santa Cruz'},{n:'Warnes',d:'Santa Cruz'},{n:'Cotoca',d:'Santa Cruz'},{n:'Mineros',d:'Santa Cruz'},{n:'San Julián',d:'Santa Cruz'},{n:'Ascensión de Guarayos',d:'Santa Cruz'},{n:'Guarayos',d:'Santa Cruz'},{n:'Vallegrande',d:'Santa Cruz'},{n:'San Ramón',d:'Santa Cruz'},{n:'San Ignacio de Velasco',d:'Santa Cruz'},{n:'El Torno',d:'Santa Cruz'},{n:'La Guardia',d:'Santa Cruz'},
        {n:'Yacuiba',d:'Tarija'},{n:'Villamontes',d:'Tarija'},{n:'Caraparí',d:'Tarija'},{n:'Bermejo',d:'Tarija'},
        {n:'Uyuni',d:'Potosí'},{n:'Tupiza',d:'Potosí'},{n:'Villazón',d:'Potosí'},{n:'Uncía',d:'Potosí'},{n:'Llallagua',d:'Potosí'},{n:'Betanzos',d:'Potosí'},
        {n:'Huanuni',d:'Oruro'},{n:'Challapata',d:'Oruro'},{n:'Caracollo',d:'Oruro'},{n:'Sabaya',d:'Oruro'},{n:'Toledo',d:'Oruro'},
        {n:'Riberalta',d:'Beni'},{n:'Trinidad',d:'Beni'},{n:'Guayaramerín',d:'Beni'},{n:'Rurrenabaque',d:'Beni'},{n:'San Borja',d:'Beni'},{n:'Santa Ana',d:'Beni'},{n:'San Ignacio de Moxos',d:'Beni'},{n:'Reyes',d:'Beni'},{n:'San Ramón',d:'Beni'},
        {n:'Cobija',d:'Pando'},{n:'Porvenir',d:'Pando'},{n:'Puerto Rico',d:'Pando'},{n:'Sena',d:'Pando'},
        {n:'Beni',d:''},{n:'Pando',d:''}
      ];
      function acNorm(s) { return (s || '').toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''); }
      function renderAcSuggestions(q) {
        var list = document.getElementById('bo-cod-prov-list'); var input = document.getElementById('bo-cod-prov-in');
        if (!list) return;
        var nq = acNorm((q || '').trim());
        list.innerHTML = '';
        if (nq.length < 1) { list.hidden = true; if (input) input.setAttribute('aria-expanded', 'false'); return; }
        var starts = [], contains = [];
        LOCALITIES.forEach(function (l) { var i = acNorm(l.n).indexOf(nq); if (i === 0) starts.push(l); else if (i > 0) contains.push(l); });
        var matches = starts.concat(contains).slice(0, 8);
        if (!matches.length) { list.hidden = true; if (input) input.setAttribute('aria-expanded', 'false'); return; }
        matches.forEach(function (l) {
          var li = document.createElement('li'); li.className = 'bo-cod__ac-item'; li.setAttribute('role', 'option');
          li.setAttribute('data-val', l.d ? (l.n + ', ' + l.d) : l.n);
          li.textContent = l.n;
          if (l.d) { var sp = document.createElement('span'); sp.className = 'bo-cod__ac-dept'; sp.textContent = l.d; li.appendChild(sp); }
          list.appendChild(li);
        });
        list.hidden = false; if (input) input.setAttribute('aria-expanded', 'true');
      }

      function money(cents) {
        var fmt = st.moneyFormat || '{{amount}}';
        var noDec = /no_decimals/.test(fmt);
        var n = (cents || 0) / 100;
        var s = noDec ? String(Math.round(n)) : n.toFixed(2);
        return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, s);
      }
      function renderTotal() {
        var base = (st.unitPrice * st.qty) - (st.saving * 100);
        if (base < 0) base = st.unitPrice * st.qty;
        var goods = base + st.upsellExtraCents + (st.stickerExtraCents || 0) + (st.bumpCents || 0);
        if (st.discountPct > 0) goods = Math.round(goods * (1 - st.discountPct / 100));
        var total = goods + (st.encomienda ? fee * 100 : 0);
        var el = document.getElementById('bo-cod-total'); if (el) el.textContent = money(total);
        var qv = document.getElementById('bo-cod-qtyval'); if (qv) qv.textContent = st.qty;
        var lbl = document.getElementById('bo-cod-total-label');
        if (lbl) lbl.textContent = st.encomienda ? 'Total (pago anticipado por QR)' : 'Total a pagar al recibir';
        var csub = document.getElementById('bo-cod-confirm-sub');
        if (csub) csub.textContent = st.encomienda ? 'Coordinamos el pago por WhatsApp' : (st.v2 ? 'Al enviar, te escribimos por WhatsApp para coordinar tu entrega' : 'Pagas al recibir · sin adelantar nada');
        var cp = document.getElementById('bo-cod-coupon');
        if (cp) { if (st.discountPct > 0) { cp.hidden = false; cp.textContent = 'Cupón ' + st.discountCode + ' aplicado: -' + st.discountPct + '%'; } else { cp.hidden = true; } }
        var svc = savingsCents();
        var svEl = document.getElementById('bo-cod-savings'); var svTx = document.getElementById('bo-cod-savings-tx');
        if (svEl && svTx) { if (svc > 0) { svTx.textContent = 'Ahorras ' + money(svc); svEl.hidden = false; } else { svEl.hidden = true; } }
        renderV2(goods);
        renderNudge(); buildWaEscape();
      }
      // A/B test oferta v2: bucket B (boAb) ve franja de confianza + precio claro. El bucket ya viaja en todos los eventos y en order_created.
      function applyAbVariant() {
        var on = abV2Enabled && boAb() === 'B';
        st.v2 = on;
        dlg.classList.toggle('bo-cod--v2', on);
        var tr = document.getElementById('bo-cod-v2trust'); if (tr) tr.hidden = !on;
        // Test #2 (jul-2026): bucket B ve el pedido en 2 pasos (gate: ab_ms_enabled).
        st.ms = abMsEnabled && boAb() === 'B';
        dlg.classList.toggle('bo-cod--ms', st.ms);
        msGo(1);
      }
      var msCtaEl = null, msCtaOrig = '';
      function msUi() {
        var bar = document.getElementById('bo-cod-msbar');
        var lab = document.getElementById('bo-cod-msstep');
        var back = dlg.querySelector('[data-ms-back]');
        if (!msCtaEl) { msCtaEl = dlg.querySelector('[data-cod-confirm] .bo-cod__confirm-main > span'); if (msCtaEl) msCtaOrig = msCtaEl.textContent; }
        if (!st.ms) { if (bar) bar.hidden = true; if (msCtaEl && msCtaOrig) msCtaEl.textContent = msCtaOrig; return; }
        if (bar) bar.hidden = false;
        if (lab) lab.textContent = 'Paso ' + (st.msStep || 1) + ' de 2';
        if (back) back.hidden = st.msStep !== 2;
        if (msCtaEl) msCtaEl.textContent = (st.msStep === 1) ? 'Continuar' : msCtaOrig;
      }
      function msGo(n) {
        st.msStep = n;
        dlg.classList.toggle('bo-cod--s1', !!st.ms && n === 1);
        dlg.classList.toggle('bo-cod--s2', !!st.ms && n === 2);
        msUi();
        if (st.ms && n === 2 && !st.msStep2Sent) {
          st.msStep2Sent = true;
          var nmIn = document.getElementById('bo-cod-name-in');
          // Captura temprana para recuperación WhatsApp: al pasar al paso 2 ya viajan nombre + celular a D1.
          codTrack('cod_step2', { phone: st.phone || '', meta: { name: ((nmIn && nmIn.value) || '').trim().slice(0, 120) } });
        }
      }
      function msValidateStep1() {
        var nm = document.getElementById('bo-cod-name-in');
        if (nm && typeof nm.reportValidity === 'function' && !nm.reportValidity()) return false;
        return validatePhone();
      }
      function renderV2(goodsCents) {
        var wrap = document.getElementById('bo-cod-v2price');
        if (!wrap) return;
        var night = document.getElementById('bo-cod-v2night');
        var disc = document.getElementById('bo-cod-v2disc');
        if (!st.v2) { wrap.hidden = true; return; }
        var showNight = false;
        if (night) {
          // Solo Tiras (1 pack = 30 tiras = 30 noches). Dilatador/stickers no se fraccionan (regla banco 07).
          if (!st.stickerVariantId && nudgeUnit === 'tiras' && st.qty > 0 && goodsCents > 0) {
            var per = Math.round((goodsCents / 100 / (st.qty * 30)) * 10) / 10;
            night.textContent = 'Te sale ' + String(per).replace('.', ',') + ' Bs por noche';
            showNight = true;
          }
          night.hidden = !showNight;
        }
        var showDisc = !!(disc && st.saving > 0);
        if (disc) disc.hidden = !showDisc;
        wrap.hidden = !(showNight || showDisc);
      }
      function renderNudge() {
        var el = document.getElementById('bo-cod-nudge');
        if (!el) return;
        if (st.stickerVariantId) { el.hidden = true; return; } // Dilatador: usa el upsell de stickers, no el nudge de packs
        var t = st.savingsByQty || {};
        var nextQty = st.qty + 1;
        // Mostrar solo si hay un tramo siguiente definido (no inventa precios fuera de tabla).
        if (!nudgeEnabled || st.qty !== 1 || t[nextQty] == null) { el.hidden = true; return; }
        var curSaving = (t[st.qty] != null) ? t[st.qty] : 0;
        var nextSaving = t[nextQty];
        var marginal = Math.round((st.unitPrice / 100) - (nextSaving - curSaving));
        var base = (st.unitPrice * nextQty) - (nextSaving * 100);
        if (base < 0) base = st.unitPrice * nextQty;
        if (st.discountPct > 0) base = Math.round(base * (1 - st.discountPct / 100));
        var newTotal = base + (st.encomienda ? fee * 100 : 0);
        var main = document.getElementById('bo-cod-nudge-main');
        var sub = document.getElementById('bo-cod-nudge-sub');
        if (main) main.textContent = 'Lleva ' + nextQty + ' packs y ahorra ' + nextSaving + ' Bs';
        if (sub) sub.textContent = '+' + marginal + ' Bs · ' + (nextQty * 30) + ' ' + nudgeUnit + ' · tu total: ' + money(newTotal);
        el.hidden = false;
      }
      function renderStickerUpsell() {
        var card = document.getElementById('bo-cod-sticker-up');
        if (!card) return;
        // Solo Dilatador (hay variante de stickers) + kit de entrada (0 packs incluidos) + habilitado.
        if (!stUpEnabled || !st.stickerVariantId || st.kitStickerPacks > 0) { card.hidden = true; return; }
        card.hidden = false;
        var added = (st.stickerExtraPacks || 0) > 0;
        card.classList.toggle('is-added', added);
        var title = document.getElementById('bo-cod-sticker-up-title');
        var sub = document.getElementById('bo-cod-sticker-up-sub');
        var btn = document.getElementById('bo-cod-sticker-up-btn');
        if (title) title.textContent = added ? ('✓ Agregaste ' + stUpLabel) : ('Agrega ' + stUpLabel);
        if (sub) sub.textContent = added ? ('Se sumaron a tu pedido (+' + stUpPrice + ' Bs)') : (stUpSub + ' · solo +' + stUpPrice + ' Bs');
        if (btn) { btn.textContent = added ? 'Quitar' : ('+ ' + stUpPrice + ' Bs'); btn.setAttribute('aria-pressed', added ? 'true' : 'false'); }
      }
      function renderBump() {
        var card = document.getElementById('bo-cod-bump');
        if (!card) return;
        // Solo Tiras/Cinta (el Dilatador ya tiene su oferta de stickers) y con bump configurado.
        if (!bumpEnabled || !bumpVariantId || st.stickerVariantId) { card.hidden = true; return; }
        card.hidden = false;
        if (!st.bumpViewed) { st.bumpViewed = true; codTrack('bump_view', { value: bumpPrice }); }
        var added = !!st.bumpAdded;
        card.classList.toggle('is-added', added);
        var tw = document.getElementById('bo-cod-bump-thumbwrap'); var img = document.getElementById('bo-cod-bump-img');
        if (tw && img) { if (bumpImg) { img.src = bumpImg; tw.hidden = false; } else { tw.hidden = true; } }
        var title = document.getElementById('bo-cod-bump-title');
        var sub = document.getElementById('bo-cod-bump-sub');
        var btn = document.getElementById('bo-cod-bump-btn');
        if (title) title.textContent = added ? ('\u2713 Agregaste ' + bumpLabel) : bumpTitle;
        if (sub) sub.textContent = added ? (bumpAddedSub + ' (+' + bumpPrice + ' Bs)') : (bumpSub + ' \u00b7 solo +' + bumpPrice + ' Bs');
        if (btn) { btn.textContent = added ? 'Quitar' : ('+ ' + bumpPrice + ' Bs'); btn.setAttribute('aria-pressed', added ? 'true' : 'false'); }
      }
      function renderIncludes() {
        var inc = document.getElementById('bo-cod-includes');
        var klr = document.getElementById('bo-cod-kitlinkrow');
        if (!st.stickerVariantId) { if (inc) inc.hidden = true; if (klr) klr.hidden = true; return; }
        if (inc) inc.hidden = false;
        if (klr) klr.hidden = !(st.kits && st.kits.length > 1);
        var incS = document.getElementById('bo-cod-inc-stickers');
        if (incS) {
          var basePares = st.days || 0;                      // pares incluidos en el kit
          var extraPares = (st.stickerExtraPacks || 0) * 30; // cada pack extra = 30 pares (30 días)
          if (extraPares > 0) incS.textContent = (basePares + extraPares) + ' pares de stickers (' + basePares + ' + ' + extraPares + ' extra)';
          else incS.textContent = basePares + ' pares de stickers incluidos';
        }
      }
      function updateCityChange() {
        var btn = document.getElementById('bo-cod-city-change');
        var sel = document.getElementById('bo-cod-city-in');
        if (btn && sel) btn.hidden = !(sel.value && sel.value !== '');
      }
      function renderColors() {
        var wrap = document.getElementById('bo-cod-colors'); var list = document.getElementById('bo-cod-colors-list');
        if (!wrap || !list) return;
        for (var j = 0; j < st.qty; j++) { if (st.packColors[j] == null) st.packColors[j] = st.defaultVariant; }
        st.packColors = st.packColors.slice(0, st.qty);
        if (variants.length < 2) { wrap.hidden = true; renderPackStrip(); return; }
        wrap.hidden = false; list.innerHTML = '';
        list.className = 'bo-cod__colors-list' + (st.qty >= 2 ? ' is-grid' : '');
        var clbl = document.getElementById('bo-cod-colors-label'); if (clbl) clbl.textContent = (st.qty === 1 ? 'Elige el color de tu ' : 'Color de cada ') + (st.unitWord || 'pack');
        for (var i = 0; i < st.qty; i++) {
          if (st.packColors[i] == null) st.packColors[i] = st.defaultVariant;
          var row = document.createElement('div'); row.className = 'bo-cod__colorrow';
          var lab = document.createElement('span'); lab.textContent = st.qty > 1 ? ('Pack ' + (i + 1)) : 'Color';
          var sel = document.createElement('select'); sel.className = 'bo-cod__input bo-cod__select'; sel.setAttribute('data-pack', i);
          variants.forEach(function (v) { var o = document.createElement('option'); o.value = v.id; o.textContent = v.label; if (String(v.id) === String(st.packColors[i])) o.selected = true; sel.appendChild(o); });
          row.appendChild(lab); row.appendChild(sel); list.appendChild(row);
        }
        st.packColors = st.packColors.slice(0, st.qty);
        renderPackStrip();
      }
      function renderPackStrip() {
        var strip = document.getElementById('bo-cod-packstrip'); if (!strip) return;
        if (st.qty < 2 || variants.length < 2) { strip.hidden = true; strip.innerHTML = ''; return; }
        strip.innerHTML = '';
        for (var i = 0; i < st.qty; i++) {
          var vid = st.packColors[i] || st.defaultVariant;
          var v = variants.filter(function (x) { return String(x.id) === String(vid); })[0] || variants[0];
          var cell = document.createElement('div'); cell.className = 'bo-cod__packthumb';
          var img = document.createElement('img'); img.src = (v && v.img) ? v.img : ''; img.alt = v ? v.label : ''; img.width = 42; img.height = 42; img.loading = 'lazy';
          cell.appendChild(img); strip.appendChild(cell);
        }
        strip.hidden = false;
      }
      function savingForQty(q) {
        var t = st.savingsByQty || {};
        if (t[q] != null) return t[q];
        var ks = Object.keys(t).map(Number).filter(function (n) { return !isNaN(n); });
        if (!ks.length) return st.saving || 0;
        var maxQ = Math.max.apply(null, ks);
        return q > maxQ ? t[maxQ] : (st.saving || 0);
      }
      function setStep(name) {
        st.step = name;
        dlg.querySelectorAll('.bo-cod__step').forEach(function (s) { s.hidden = s.getAttribute('data-step') !== name; });
      }
      function clearTimers() { if (st.t1) clearInterval(st.t1); if (st.t2) clearInterval(st.t2); }
      function realClose() { clearTimers(); if (typeof dlg.close === 'function') dlg.close(); else dlg.removeAttribute('open'); }
      function filledFields() {
        var ids = ['bo-cod-name-in', 'bo-cod-phone-in', 'bo-cod-city-in', 'bo-cod-addr-in', 'bo-cod-prov-in'];
        var n = 0;
        ids.forEach(function (id) { var el = document.getElementById(id); if (el && el.value && el.value.trim() !== '') n++; });
        return n;
      }
      function exitEligible() {
        try { var t = parseInt(localStorage.getItem('bo_cod_exit_seen') || '0', 10); if (t && (Date.now() - t) < 2592000000) return false; } catch (e) {}
        return true;
      }
      // Exit-intent: TODOS los cierres del paso "form" pasan por aquí — X, ESC/gesto atrás
      // de Android (evento cancel del dialog) y clic en el fondo. origin ('x'|'cancel'|'fondo')
      // viaja en exit_view meta para medir cobertura. Cupón: cap 1 vez/30 días (exitEligible);
      // whatsapp: sin cap. No exige campos llenos.
      function attemptCloseX(origin) {
        var exitOk = exitMode === 'whatsapp' ? true : (exitPct > 0 && exitEligible());
        if (exitEnabled && !st.exitShown && st.step === 'form' && exitOk) { showExit(origin); return; }
        realClose();
      }
      function setUpsellPreview(vid) {
        var v = variants.filter(function (x) { return String(x.id) === String(vid); })[0] || variants[0];
        if (!v) return;
        var img = document.getElementById('bo-cod-upimg'); if (img && v.img) img.src = v.img;
        var lab = document.getElementById('bo-cod-upvar'); if (lab) lab.textContent = v.label || '';
      }
      function countdown(elId, secs, onExpire) {
        var left = secs; var el = document.getElementById(elId);
        function fmt() { var m = Math.floor(left / 60), s = left % 60; return m + ':' + (s < 10 ? '0' : '') + s; }
        var iv = setInterval(function () {
          if (left <= 0) { clearInterval(iv); if (onExpire) onExpire(); return; }
          if (el) el.textContent = el.getAttribute('data-prefix') ? (el.getAttribute('data-prefix') + ' ' + fmt()) : fmt();
          left--;
        }, 1000);
        if (el) el.textContent = el.getAttribute('data-prefix') ? (el.getAttribute('data-prefix') + ' ' + fmt()) : fmt();
        return iv;
      }
      function toggleEncomienda(on) {
        st.encomienda = on;
        var prov = document.getElementById('bo-cod-province'); if (prov) prov.hidden = !on;
        var provIn = document.getElementById('bo-cod-prov-in'); if (provIn) provIn.required = on;
        // Encomienda: NO se piden dirección ni ubicación (es por encomienda, no a domicilio).
        var del = document.getElementById('bo-cod-delivery-fields'); if (del) del.hidden = on;
        var addrIn = document.getElementById('bo-cod-addr-in'); if (addrIn) addrIn.required = !on;
        if (!on) { var acl = document.getElementById('bo-cod-prov-list'); if (acl) { acl.hidden = true; acl.innerHTML = ''; } }
        var sub = document.getElementById('bo-cod-sub');
        if (sub) sub.textContent = on ? 'Tu zona es por encomienda (pago anticipado por QR).' : 'Pago contra entrega. No pagas nada por adelantado.';
        dlg.querySelectorAll('[data-trust="cod"]').forEach(function (s) { s.hidden = on; });
        dlg.querySelectorAll('[data-trust="enc"]').forEach(function (s) { s.hidden = !on; });
        dlg.querySelectorAll('#bo-cod-v2trust [data-v2t="cod"]').forEach(function (s) { s.hidden = on; });
        dlg.querySelectorAll('#bo-cod-v2trust [data-v2t="enc"]').forEach(function (s) { s.hidden = !on; });
        renderTotal();
      }

      var SAVE_KEY = 'bo_cod_customer_v1';
      function loadSaved() {
        var data;
        try { data = JSON.parse(localStorage.getItem(SAVE_KEY) || 'null'); } catch (e) { data = null; }
        if (!data) return;
        function setVal(id, v) { var el = document.getElementById(id); if (el && v) el.value = v; }
        setVal('bo-cod-name-in', data.name); setVal('bo-cod-phone-in', data.phone);
        setVal('bo-cod-addr-in', data.address); setVal('bo-cod-loc-in', data.location); if (data.location) markGeoDone();
        var cityEl = document.getElementById('bo-cod-city-in');
        if (cityEl && data.city) {
          var known = Array.prototype.some.call(cityEl.options, function (o) { return o.value === data.city; });
          if (known && data.city !== '__otra__') { cityEl.value = data.city; toggleEncomienda(false); }
          else { cityEl.value = '__otra__'; setVal('bo-cod-prov-in', data.province || (known ? '' : data.city)); toggleEncomienda(true); }
        }
        var hint = document.getElementById('bo-cod-saved-hint'); if (hint) hint.hidden = false;
      }
      function saveCustomer(c) {
        try { localStorage.setItem(SAVE_KEY, JSON.stringify({ name: c.name, phone: c.phone, city: c.city, province: c.province, address: c.address, location: c.location })); } catch (e) {}
      }
      function markGeoDone() {
        var btn = document.getElementById('bo-cod-geo-btn'); if (!btn) return;
        btn.classList.add('is-done');
        var mn = btn.querySelector('.bo-cod__locbtn-tx'); if (mn) mn.textContent = 'Listo';
      }
      function resetLocation() {
        var btn = document.getElementById('bo-cod-geo-btn');
        if (btn) { btn.classList.remove('is-done'); var mn = btn.querySelector('.bo-cod__locbtn-tx'); if (mn) mn.textContent = 'Compartir ubicación'; }
        var note = document.getElementById('bo-cod-loc-note'); if (note) note.hidden = true;
        var hint = document.getElementById('bo-cod-saved-hint'); if (hint) hint.hidden = true;
      }
      function clearSaved() {
        try { localStorage.removeItem(SAVE_KEY); } catch (e) {}
        ['bo-cod-name-in', 'bo-cod-phone-in', 'bo-cod-addr-in', 'bo-cod-loc-in', 'bo-cod-prov-in'].forEach(function (id) { var el = document.getElementById(id); if (el) el.value = ''; });
        var cityEl = document.getElementById('bo-cod-city-in'); if (cityEl) cityEl.selectedIndex = 0;
        toggleEncomienda(false);
        resetLocation();
        var nm = document.getElementById('bo-cod-name-in'); if (nm) { try { nm.focus(); } catch (e) {} }
      }
      function requestGeo() {
        var note = document.getElementById('bo-cod-loc-note'); var input = document.getElementById('bo-cod-loc-in');
        function say(t) { if (note) { note.hidden = false; note.textContent = t; } }
        if (!navigator.geolocation) { say('Tu navegador no permite GPS. Pega tu link de Maps en el campo.'); return; }
        say('Obteniendo tu ubicación...');
        navigator.geolocation.getCurrentPosition(function (pos) {
          var lat = pos.coords.latitude.toFixed(6), lng = pos.coords.longitude.toFixed(6);
          if (input) input.value = 'https://www.google.com/maps?q=' + lat + ',' + lng;
          say('Ubicación capturada. La compartimos con el repartidor.'); markGeoDone();
        }, function () { say('No pudimos obtener tu ubicación. Pega tu link de Maps en el campo.'); },
        { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 });
      }
      function buildWaEscape() {
        var a = document.getElementById('bo-cod-wa-help'); if (!a || !waNumber) return;
        var nm = document.getElementById('bo-cod-name'); var title = nm ? nm.textContent : 'Tiras Nasales';
        var cols = st.packColors.slice(0, st.qty).map(function (vid) { var v = variants.filter(function (x) { return String(x.id) === String(vid || st.defaultVariant); })[0]; return v ? v.label : ''; }).filter(Boolean);
        var msg = 'Hola, quiero pedir ' + st.qty + ' pack(s) de ' + title + (cols.length ? ' (' + cols.join(', ') + ')' : '') + '. Pago contra entrega.';
        a.href = 'https://wa.me/' + waNumber + '?text=' + encodeURIComponent(msg);
      }
      document.addEventListener('bo:open-cod', function (e) {
        var d = e.detail || {};
        clearTimers();
        st = { defaultVariant: d.variantId, qty: d.qty || 1, unitPrice: d.unitPrice || 0, saving: d.saving || 0, savingsByQty: Object.assign({}, popupSavings, (d.savingsByQty || {})),
          moneyFormat: d.moneyFormat || '{{amount}}', packColors: [], encomienda: false, customer: {},
          upsellShown: false, upsellExtraCents: 0, upsellPacks: [], upsellPrice: 0, orderId: '', orderName: '',
          exitShown: false, discountPct: 0, discountCode: '', step: 'form', t1: null, t2: null, paymentInfoSent: false, ms: false, msStep: 1, msStep2Sent: false, offerId: inferOfferId(d), idempotencyKey: codIdempotencyKey(), formStartedAt: Date.now(),
          stickerVariantId: d.stickerVariantId || 0, kitStickerPacks: d.stickerPacks || 0, kitSaving: d.kitSaving || 0, unitWord: (d.stickerVariantId ? 'kit' : 'pack'), stickerExtraPacks: 0, stickerExtraCents: 0, bumpAdded: false, bumpCents: 0, bumpViewed: false, days: d.days || 0, kitName: d.kitName || '', kits: (d.kits || []), kitIndex: (d.kitIndex != null ? d.kitIndex : -1) };
        // Popup product-agnostic: el disparador puede sobreescribir variantes/packnote/unidad (ej. el card de Stickers en la PDP del Dilatador).
        variants = (d.variants != null) ? d.variants : pageVariants;
        nudgeUnit = d.nudgeUnit || dlg.getAttribute('data-nudge-unit') || 'tiras';
        var nm = document.getElementById('bo-cod-name'); if (nm && d.title) nm.textContent = d.title;
        var im = document.getElementById('bo-cod-img'); if (im && d.image) im.src = d.image;
        // Dilatador: ocultamos el packnote y mostramos el bloque "incluye" (4 tallas + pares del kit).
        // Tiras/Cinta: packnote normal (texto del setting), sin bloque incluye.
        var pnote = dlg.querySelector('.bo-cod__packnote'); if (pnote) { pnote.hidden = !!d.stickerVariantId; if (d.packNote) pnote.textContent = d.packNote; }
        renderIncludes();
        var cityEl = document.getElementById('bo-cod-city-in'); if (cityEl) cityEl.selectedIndex = 0;
        cityAutoSet = false;
        toggleEncomienda(false);
        var perr = document.getElementById('bo-cod-phone-err'); if (perr) perr.hidden = true;
        var pin = document.getElementById('bo-cod-phone-in'); if (pin) pin.removeAttribute('aria-invalid');
        resetLocation();
        applyAbVariant();
        renderColors(); renderTotal(); renderStickerUpsell(); renderBump(); setStep('form');
        loadSaved();
        applyDetectedCity();
        updateCityChange();
        try { if (window.boTrack) boTrack('InitiateCheckout', { content_ids: [String(st.defaultVariant)], content_type: 'product', contents: [{ id: String(st.defaultVariant), quantity: st.qty }], num_items: st.qty, value: orderTotalCents() / 100, currency: 'BOB' }); } catch (e) {}
        codTrack('cod_open', boEntry());
        if (typeof dlg.showModal === 'function') { dlg.showModal(); } else { dlg.setAttribute('open', ''); }
        setTimeout(function () { var h = document.getElementById('bo-cod-formtitle'); if (h) { try { h.focus({ preventScroll: true }); } catch (e) {} } }, 60);
      });

      dlg.addEventListener('input', function (e) {
        if (e.target.id !== 'bo-cod-phone-in' || st.paymentInfoSent) return;
        var raw = (e.target.value || '').replace(/\D/g, '').replace(/^591/, '');
        if (/^[67]\d{7}$/.test(raw)) {
          st.paymentInfoSent = true;
          st.phone = '+591' + raw;
          codTrack('cod_phone', { phone: st.phone });
        }
      });

      // cod_start: primera interacción real del cliente con el formulario (una sola vez por apertura)
      function boMarkStart() { if (st.started) return; st.started = true; codTrack('cod_start'); }
      dlg.addEventListener('input', function (e) { if (e.target.closest('[data-cod-form]')) boMarkStart(); });
      dlg.addEventListener('change', function (e) { if (e.target.closest('[data-cod-form]')) boMarkStart(); });

      dlg.addEventListener('change', function (e) {
        var packSel = e.target.closest('[data-pack]');
        if (packSel) {
          st.packColors[parseInt(packSel.getAttribute('data-pack'), 10)] = packSel.value;
          // La foto del resumen sigue al color elegido (el último que tocaste en multi-pack).
          var pv = variants.filter(function (x) { return String(x.id) === String(packSel.value); })[0];
          var im = document.getElementById('bo-cod-img'); if (im && pv && pv.img) im.src = pv.img;
          renderPackStrip();
          return;
        }
        if (e.target.id === 'bo-cod-city-in') { cityAutoSet = false; updateCityChange(); toggleEncomienda(e.target.value === '__otra__'); return; }
        if (e.target.id === 'bo-cod-upsel') { setUpsellPreview(e.target.value); return; }
      });
      dlg.addEventListener('input', function (e) {
        if (e.target.id === 'bo-cod-prov-in') renderAcSuggestions(e.target.value);
      });
      dlg.addEventListener('mousedown', function (e) {
        var item = e.target.closest('.bo-cod__ac-item');
        if (!item) return;
        e.preventDefault();
        var input = document.getElementById('bo-cod-prov-in'); if (input) input.value = item.getAttribute('data-val');
        var list = document.getElementById('bo-cod-prov-list'); if (list) { list.hidden = true; list.innerHTML = ''; }
      });
      dlg.addEventListener('focusout', function (e) {
        if (e.target.id === 'bo-cod-prov-in') { setTimeout(function () { var list = document.getElementById('bo-cod-prov-list'); if (list) list.hidden = true; }, 150); }
      });
      dlg.addEventListener('cancel', function (e) { e.preventDefault(); attemptCloseX('cancel'); });

      dlg.addEventListener('click', function (e) {
        if (e.target.closest('[data-cod-close]')) { e.preventDefault(); attemptCloseX('x'); return; }
        if (e.target === dlg) { attemptCloseX('fondo'); return; }
        if (e.target.closest('[data-cod-exit-apply]')) { e.preventDefault(); applyExit(); return; }
        if (e.target.closest('[data-cod-exit-back]')) { e.preventDefault(); setStep('form'); return; }
        if (e.target.closest('[data-cod-exit-wa]')) { codTrack('exit_wa_click'); realClose(); return; }
        if (e.target.closest('[data-cod-exit-leave]')) { e.preventDefault(); realClose(); return; }
        if (e.target.closest('[data-cod-copy]')) { e.preventDefault(); var cb = e.target.closest('[data-cod-copy]'); try { navigator.clipboard.writeText(st.discountCode); } catch (er) {} cb.textContent = 'Copiado'; setTimeout(function () { cb.textContent = 'Copiar'; }, 1500); return; }
        var q = e.target.closest('[data-cod-qty]');
        if (q) { st.qty = Math.max(1, st.qty + (parseInt(q.getAttribute('data-cod-qty'), 10) || 0)); st.saving = st.stickerVariantId ? 0 : savingForQty(st.qty); renderColors(); renderTotal(); return; }
        if (e.target.closest('[data-cod-nudge]')) { e.preventDefault(); st.qty += 1; st.saving = savingForQty(st.qty); renderColors(); renderTotal(); return; }
        if (e.target.closest('[data-cod-sticker-add]')) { e.preventDefault(); if ((st.stickerExtraPacks || 0) > 0) { st.stickerExtraPacks = 0; st.stickerExtraCents = 0; } else { st.stickerExtraPacks = 1; st.stickerExtraCents = stUpPrice * 100; } renderTotal(); renderStickerUpsell(); renderIncludes(); return; }
        if (e.target.closest('[data-cod-bump-add]')) { e.preventDefault(); if (st.bumpAdded) { st.bumpAdded = false; st.bumpCents = 0; codTrack('bump_remove'); } else { st.bumpAdded = true; st.bumpCents = bumpPrice * 100; codTrack('bump_accept', { value: bumpPrice }); } renderTotal(); renderBump(); return; }
        if (e.target.closest('[data-cod-city-change]')) { e.preventDefault(); var csel = document.getElementById('bo-cod-city-in'); if (csel) { csel.focus(); try { if (csel.showPicker) csel.showPicker(); } catch (er) {} } return; }
        if (e.target.closest('[data-cod-geo]')) { e.preventDefault(); requestGeo(); return; }
        if (e.target.closest('[data-cod-forget]')) { e.preventDefault(); clearSaved(); return; }
        if (e.target.closest('[data-cod-vguide]')) { e.preventDefault(); openVguide(); return; }
        if (e.target.closest('[data-cod-kits]')) { e.preventDefault(); openKitModal(); return; }
        if (e.target.closest('[data-cod-help]')) { e.preventDefault(); openHelp(); return; }
        if (e.target.closest('[data-ms-back]')) { e.preventDefault(); msGo(1); return; }
        if (e.target.closest('[data-cod-disc-apply]')) { e.preventDefault(); applyDiscountCode(); return; }
        if (e.target.closest('[data-cod-confirm]')) { e.preventDefault(); submit(); return; }
        if (e.target.closest('[data-cod-upyes]')) { e.preventDefault(); acceptUpsell(); return; }
        if (e.target.closest('[data-cod-upno]')) { e.preventDefault(); declineUpsell(); return; }
      });

      function submit() {
        var form = dlg.querySelector('[data-cod-form]');
        if (st.ms && st.msStep === 1) {
          // Paso 1 -> 2: valida solo nombre + celular; la entrega se pide en el paso 2.
          if (!msValidateStep1()) return;
          msGo(2);
          try { var inner = dlg.querySelector('.bo-cod__inner'); if (inner) inner.scrollTop = 0; } catch (e) {}
          setTimeout(function () { var h = document.getElementById('bo-cod-formtitle'); if (h) { try { h.focus({ preventScroll: true }); } catch (e) {} } }, 40);
          return;
        }
        if (st.ms && form && typeof form.checkValidity === 'function' && !form.checkValidity()) {
          var inv = form.querySelector(':invalid');
          // Si lo inválido quedó en el paso 1 (oculto por CSS), volvemos ahí para que el aviso se vea.
          if (inv && inv.closest('[data-ms-group="1"]')) { msGo(1); setTimeout(function () { try { form.reportValidity(); } catch (e) {} }, 60); return; }
        }
        if (form && typeof form.reportValidity === 'function' && !form.reportValidity()) return;
        if (!validatePhone()) return;
        st.customer = {};
        if (form) form.querySelectorAll('input, select').forEach(function (i) { if (i.name) st.customer[i.name] = i.value; });
        saveCustomer(st.customer);
        finalize();
      }
      function validatePhone() {
        var el = document.getElementById('bo-cod-phone-in');
        var err = document.getElementById('bo-cod-phone-err');
        if (!el) return true;
        var raw = (el.value || '').replace(/\D/g, '').replace(/^591/, '');
        var ok = /^[67]\d{7}$/.test(raw);
        if (ok) { if (err) err.hidden = true; el.removeAttribute('aria-invalid'); return true; }
        if (err) { err.hidden = false; err.textContent = 'Ingresa un celular válido: 8 dígitos que empiezan en 6 o 7.'; }
        el.setAttribute('aria-invalid', 'true');
        try { el.focus(); } catch (e) {}
        return false;
      }

      function showExit(origin) {
        st.exitShown = true;
        codTrack('exit_view', { meta: { origin: origin || 'x' } });
        var waCard = document.getElementById('bo-cod-exit-wa');
        var cupCard = document.getElementById('bo-cod-exit-cupon');
        if (exitMode === 'whatsapp') {
          if (waCard) waCard.hidden = false;
          if (cupCard) cupCard.hidden = true;
          var wa = document.getElementById('bo-cod-exitwa-btn');
          var waNum = exitWaNumber || waNumber;
          if (wa && waNum) {
            var nmEl = document.getElementById('bo-cod-name');
            var title = nmEl ? (nmEl.textContent || '').trim() : 'Tiras Nasales';
            var cols = st.packColors.slice(0, st.qty).map(function (vid) { var v = variants.filter(function (x) { return String(x.id) === String(vid || st.defaultVariant); })[0]; return v ? v.label : ''; }).filter(Boolean);
            var msg = 'Hola, quiero terminar mi pedido: ' + st.qty + ' pack(s) de ' + title + (cols.length ? ' (' + cols.join(', ') + ')' : '');
            if (st.bumpAdded && bumpVariantId) msg += ' + 1 ' + bumpLabel;
            var cityV = '';
            try { var cs = document.getElementById('bo-cod-city-in'); if (cs && cs.value && cs.value !== '__otra__') { cityV = cs.value; } else { var pvIn = document.getElementById('bo-cod-prov-in'); if (pvIn && pvIn.value) cityV = pvIn.value; } } catch (er) {}
            if (cityV) msg += '. Estoy en ' + cityV;
            msg += st.encomienda ? '. Quiero coordinar el envío.' : '. Pago contra entrega.';
            wa.href = 'https://wa.me/' + waNum + '?text=' + encodeURIComponent(msg);
          }
          clearTimers();
          setStep('exit');
          return;
        }
        if (waCard) waCard.hidden = true;
        if (cupCard) cupCard.hidden = false;
        try { localStorage.setItem('bo_cod_exit_seen', String(Date.now())); } catch (e) {}
        st.discountCode = exitPrefix + exitPct + '-' + Math.random().toString(36).slice(2, 6).toUpperCase();
        try { localStorage.setItem('bo_cod_exit_code', st.discountCode); localStorage.setItem('bo_cod_exit_pct', String(exitPct)); } catch (e) {}
        var pe = document.getElementById('bo-cod-exit-pct'); if (pe) pe.textContent = exitPct;
        var code = document.getElementById('bo-cod-code'); if (code) code.textContent = st.discountCode;
        var ap = document.getElementById('bo-cod-exit-apply'); if (ap) ap.textContent = 'Aplicar ' + exitPct + '% y seguir';
        clearTimers();
        st.t1 = countdown('bo-cod-exit-timer', exitMin * 60, function () { var tm = document.getElementById('bo-cod-exit-timer'); if (tm) tm.textContent = 'vencido'; });
        setStep('exit');
      }
      function applyExit() {
        clearTimers();
        st.discountPct = exitPct;
        codTrack('exit_apply', { value: exitPct });
        renderTotal();
        setStep('form');
      }
      function discMsg(text, ok) {
        var m = document.getElementById('bo-cod-disc-msg'); if (!m) return;
        m.hidden = false; m.textContent = text; m.className = 'bo-cod__disc-msg ' + (ok ? 'is-ok' : 'is-err');
      }
      function applyDiscountCode() {
        var inp = document.getElementById('bo-cod-disc-in');
        var code = (inp ? inp.value : '').trim().toUpperCase();
        if (!code) { discMsg('Escribe un código.', false); return; }
        if (campaignCodes[code] != null) {
          st.discountPct = campaignCodes[code]; st.discountCode = code; renderTotal();
          discMsg('Cupón ' + code + ' aplicado: -' + st.discountPct + '%.', true); return;
        }
        var exCode = '', exPct = 0;
        try { exCode = (localStorage.getItem('bo_cod_exit_code') || '').toUpperCase(); exPct = parseInt(localStorage.getItem('bo_cod_exit_pct') || '0', 10); } catch (e) {}
        if (exCode && code === exCode && exPct > 0) {
          st.discountPct = exPct; st.discountCode = code; renderTotal();
          discMsg('Cupón aplicado: -' + st.discountPct + '%.', true); return;
        }
        discMsg('Ese código no es válido o ya venció.', false);
      }

      function finalize() {
        codTrack('cod_submit');
        var lines = {};
        st.packColors.slice(0, st.qty).forEach(function (vid) { vid = vid || st.defaultVariant; lines[vid] = (lines[vid] || 0) + 1; });
        var items = Object.keys(lines).map(function (vid) { return { variantId: parseInt(vid, 10), quantity: lines[vid] }; });
        var payloadSaving = st.saving;
        // Dilatador: los sticker packs (del kit + del upsell) van como líneas reales de la variante de stickers,
        // con su descuento bundle (160 standalone → precio bundle) para que el total coincida con lo que ve el cliente.
        if (st.stickerVariantId) {
          var totalStickerPacks = (st.kitStickerPacks * st.qty) + (st.stickerExtraPacks || 0);
          if (totalStickerPacks > 0) items.push({ variantId: st.stickerVariantId, quantity: totalStickerPacks });
          payloadSaving += (st.kitSaving * st.qty) + ((st.stickerExtraPacks || 0) * stUpSave);
        }
        // Order bump (Tiras/Cinta): línea real del complemento con su descuento bundle —
        // mismo patrón que los stickers del dilatador (precio Shopify − save = precio bump).
        if (st.bumpAdded && bumpVariantId) { items.push({ variantId: bumpVariantId, quantity: 1 }); payloadSaving += bumpSave; }
        var _an = codCtx();
        var website = document.getElementById('bo-cod-website');
        var payload = { action: 'create', offerId: st.offerId, idempotencyKey: st.idempotencyKey, formStartedAt: st.formStartedAt, website: website ? website.value : '', items: items, shipping: st.encomienda ? 'encomienda' : 'cod', encomiendaFee: fee, saving: payloadSaving, customer: st.customer, discountPct: st.discountPct, discountCode: st.discountCode, sid: _an.sid, ab: _an.ab, source: _an.source, product: _an.product, variant: _an.variant, pack: _an.pack, visitor_id: _an.visitor_id };
        function done(res) {
          clearTimers();
          try {
            var responseItems = res && Array.isArray(res.items) ? res.items : items;
            var contents = responseItems.map(function (item) { return { id: String(item.variantId), quantity: parseInt(item.quantity, 10) || 1 }; });
            var ids = contents.map(function (item) { return item.id; });
            var count = contents.reduce(function (sum, item) { return sum + item.quantity; }, 0);
            var eventId = st.orderId || ('bo-' + (st.orderName || 'demo') + '-' + new Date().getTime());
            var value = res && Number(res.total) >= 0 ? Number(res.total) : orderTotalCents() / 100;
            if (window.boTrack) boTrack('Purchase', { content_ids: ids, content_type: 'product', contents: contents, num_items: count, value: value, currency: (res && res.currency) || 'BOB' }, eventId);
          } catch (e) {}
          setStep('success');
          var h = document.getElementById('bo-cod-success-title'); if (h) { try { h.focus({ preventScroll: true }); } catch (e) {} }
          renderPostUpsell();
        }
        if (!endpoint) { var _dn = dlg.querySelector('[data-cod-demo-note]'); if (_dn) _dn.hidden = false; done(); return; }
        var btn = dlg.querySelector('[data-cod-confirm]'); if (btn) { btn.disabled = true; btn.style.opacity = '0.7'; }
        fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) })
          .then(function (r) { if (!r.ok) throw new Error('fail'); return r.json(); })
          .then(function (res) { if (res && res.orderId) { st.orderId = res.orderId; st.orderName = res.orderName || ''; } var n = dlg.querySelector('[data-cod-demo-note]'); if (n) n.hidden = true; done(res); })
          .catch(function () { alert('Hubo un problema. Intenta de nuevo o escríbenos por WhatsApp.'); })
          .finally(function () { if (btn) { btn.disabled = false; btn.style.opacity = ''; } });
      }

      function orderTotalCents() {
        var base = (st.unitPrice * st.qty) - (st.saving * 100);
        if (base < 0) base = st.unitPrice * st.qty;
        var goods = base + st.upsellExtraCents + (st.stickerExtraCents || 0) + (st.bumpCents || 0);
        if (st.discountPct > 0) goods = Math.round(goods * (1 - st.discountPct / 100));
        return goods + (st.encomienda ? fee * 100 : 0);
      }
      function savingsCents() {
        // Dilatador: ahorro del kit (vs comprar dilatador + stickers por separado) + ahorro del upsell.
        // Tiras/Cinta: descuento por pack. Más el % del cupón exit-intent (si hay).
        var packSaveBs = st.stickerVariantId
          ? (st.kitSaving * st.qty + (st.stickerExtraPacks || 0) * stUpSave)
          : st.saving;
        if (st.bumpAdded) packSaveBs += bumpSave;
        var base = (st.unitPrice * st.qty) - (st.saving * 100);
        if (base < 0) base = st.unitPrice * st.qty;
        var goodsBefore = base + st.upsellExtraCents + (st.stickerExtraCents || 0) + (st.bumpCents || 0);
        var pctSaveCents = st.discountPct > 0 ? Math.round(goodsBefore * st.discountPct / 100) : 0;
        return (packSaveBs * 100) + pctSaveCents;
      }
      function orderSummaryText() {
        var nm = document.getElementById('bo-cod-name');
        var prod = nm && nm.textContent ? nm.textContent.trim() : 'Tiras Nasales';
        var perPack = parseInt(String(upUnit || '').replace(/\D/g, ''), 10);
        var groups = {}, order = [];
        function add(vid) {
          vid = vid || st.defaultVariant;
          var v = variants.filter(function (x) { return String(x.id) === String(vid); })[0];
          var label = v ? v.label : '';
          if (groups[label] == null) { groups[label] = 0; order.push(label); }
          groups[label]++;
        }
        st.packColors.slice(0, st.qty).forEach(add);
        (st.upsellPacks || []).forEach(add);
        var parts = order.map(function (label) {
          var n = groups[label];
          var s = n + ' Pack' + (n > 1 ? 's' : '') + ' ' + prod + (label ? ' ' + label : '');
          if (perPack) s += ' (' + (n * perPack) + ' tiras)';
          return s;
        });
        if (st.bumpAdded && bumpVariantId) parts.push('1 ' + bumpLabel);
        return parts.join(', ');
      }
      function buildOrderMessage() {
        var c = st.customer || {};
        var totalBs = Math.round(orderTotalCents() / 100);
        var cityVal = st.encomienda ? (c.province || c.city || '') : (c.city || '');
        var addrVal = st.encomienda ? 'Por encomienda (pago anticipado por QR)' : (c.address || '');
        var payNote = st.encomienda ? ' (pago anticipado por QR)' : ' (contra entrega)';
        var L = [];
        L.push('Hola, me gustaría confirmar mi pedido de biOptimización.');
        L.push('');
        L.push('* *Resumen del pedido:* ' + orderSummaryText());
        L.push('* *Nombre:* ' + (c.name || ''));
        L.push('* *Celular:* ' + (c.phone || ''));
        L.push('* *Ciudad:* ' + cityVal);
        L.push('* *Dirección de entrega:* ' + addrVal);
        if (c.location && String(c.location).trim()) L.push('* *Ubicación:* ' + String(c.location).trim());
        L.push('* *Total a pagar:* ' + totalBs + ' Bs.' + payNote);
        if (st.orderName) { L.push(''); L.push('Pedido ' + st.orderName); }
        return L.join('\n');
      }
      function setWhatsApp() {
        var wa = document.getElementById('bo-cod-wa');
        if (!wa || !waNumber) return;
        wa.href = 'https://wa.me/' + waNumber + '?text=' + encodeURIComponent(buildOrderMessage());
        wa.hidden = false;
      }
      function renderPostUpsell() {
        var pu = document.getElementById('bo-cod-pu');
        // Dilatador: upsell post-compra de STICKERS de repuesto (todos los kits y ambos colores).
        // Tiras/Cinta: upsell de "otro pack" según la tabla 'offers'.
        var isStickerUp = !!st.stickerVariantId;
        var price = isStickerUp ? stUpPrice : offers[st.qty];
        if (!pu || !upEnabled || st.upsellShown || price == null) { if (pu) pu.hidden = true; showFinal(false); return; }
        st.upsellShown = true; st.upsellPrice = price; st.upsellIsSticker = isStickerUp;
        codTrack('upsell_view', { value: price });
        var fin = document.getElementById('bo-cod-final'); if (fin) fin.hidden = true; // ocultar el cierre mientras decide
        pu.hidden = false;
        var puTitle = pu.querySelector('.bo-cod__putitle');
        var puName = pu.querySelector('.bo-cod__name');
        var txt = document.getElementById('bo-cod-uptext');
        if (isStickerUp) {
          if (puTitle) puTitle.textContent = 'Suma stickers de repuesto y ahorra';
          if (puName) puName.textContent = '1 pack · ' + stUpLabel;
          if (txt) txt.textContent = 'Agregá ' + stUpLabel + ' por solo +' + price + ' Bs, con envío gratis.';
        } else {
          if (puName) puName.textContent = '1 pack más · ' + upUnit;
          if (txt) txt.textContent = 'Otro pack (' + upUnit + ') por solo +' + price + ' Bs, con envío gratis.';
        }
        var yes = document.getElementById('bo-cod-upyes'); if (yes) { yes.textContent = 'Sí, agregar — +' + price + ' Bs'; yes.disabled = false; yes.style.opacity = ''; }
        var upc = document.getElementById('bo-cod-upcolor'); var upsel = document.getElementById('bo-cod-upsel');
        if (!isStickerUp && upChoose && variants.length > 1 && upc && upsel) {
          upc.hidden = false; upsel.innerHTML = '';
          variants.forEach(function (v) { var o = document.createElement('option'); o.value = v.id; o.textContent = v.label; if (String(v.id) === String(st.defaultVariant)) o.selected = true; upsel.appendChild(o); });
        } else if (upc) { upc.hidden = true; }
        setUpsellPreview(st.defaultVariant);
        var tEl = document.getElementById('bo-cod-uptimer'); if (tEl) tEl.setAttribute('data-prefix', 'Oferta termina en');
        clearTimers();
        // Al vencer el timer, la oferta desaparece y pasa al cierre (no deja al cliente atrapado).
        st.t2 = countdown('bo-cod-uptimer', upTimer, function () { showFinal(false); });
      }
      function showFinal(added) {
        clearTimers();
        var pu = document.getElementById('bo-cod-pu'); if (pu) pu.hidden = true;
        var fin = document.getElementById('bo-cod-final'); if (fin) fin.hidden = false;
        var ad = document.getElementById('bo-cod-added'); if (ad) ad.hidden = !added;
        setWhatsApp();
      }
      function acceptUpsell() {
        clearTimers();
        var upsel = document.getElementById('bo-cod-upsel'); var upc = document.getElementById('bo-cod-upcolor');
        var extraVariant = st.upsellIsSticker ? st.stickerVariantId
          : ((upChoose && upsel && upc && !upc.hidden) ? upsel.value : st.defaultVariant);
        var yes = document.getElementById('bo-cod-upyes');
        st.upsellPacks.push(extraVariant); st.upsellExtraCents += (st.upsellPrice || 0) * 100;
        codTrack('upsell_accept', { value: st.upsellPrice || 0 });
        // Sin servidor (demo) o sin orden creada → confirmar visual y pasar al cierre.
        if (!endpoint || !st.orderId) { showFinal(true); return; }
        if (yes) { yes.disabled = true; yes.style.opacity = '0.7'; yes.textContent = 'Agregando...'; }
        fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ action: 'upsell', orderId: st.orderId, variantId: parseInt(extraVariant, 10), price: st.upsellPrice }) })
          .then(function (r) { if (!r.ok) throw new Error('fail'); return r.json(); })
          .then(function (res) {
            try { if (window.boTrack) boTrack('UpsellPurchase', { content_ids: [String(extraVariant)], content_type: 'product', contents: [{ id: String(extraVariant), quantity: 1 }], num_items: 1, value: Number(res && res.promoPrice) || st.upsellPrice, currency: 'BOB' }, (st.orderId || 'order') + '-upsell'); } catch (e) {}
            showFinal(true);
          })
          .catch(function () { if (yes) { yes.disabled = false; yes.style.opacity = ''; yes.textContent = 'Sí, agregar — +' + st.upsellPrice + ' Bs'; } alert('No pudimos agregar el pack extra. Escríbenos por WhatsApp y lo sumamos.'); });
      }
      function declineUpsell() { clearTimers(); codTrack('upsell_reject'); showFinal(false); }
      function openVguide() {
        var g = document.querySelector('[data-bo-vguide]');
        if (!g) return;
        try { if (typeof g.showModal === 'function') g.showModal(); else g.setAttribute('open', ''); } catch (e) {}
      }
      // Si el cliente elige una variante DENTRO de la guía con el form abierto, la aplicamos al pack.
      document.addEventListener('click', function (e) {
        var card = e.target.closest('[data-bo-vguide-pick]');
        if (!card || !dlg.open) return;
        var key = acNorm(card.getAttribute('data-bo-vguide-pick') || '');
        var v = variants.filter(function (x) { return acNorm(x.label).indexOf(key) === 0; })[0];
        if (!v) return;
        st.defaultVariant = v.id; st.packColors = [];
        renderColors(); renderTotal();
        var im = document.getElementById('bo-cod-img'); if (im && v.img) im.src = v.img;
      });
      // El link "¿Cuál me conviene?" solo se muestra si la guía existe en la página (la renderiza el buybox).
      if (document.querySelector('[data-bo-vguide]')) { var vgLink = dlg.querySelector('[data-cod-vguide]'); if (vgLink) vgLink.hidden = false; }
      function openHelp() {
        var h = document.querySelector('[data-bo-help]');
        if (!h) return;
        try { var c = localStorage.getItem('bo_dp_city'); if (c) { document.dispatchEvent(new CustomEvent('bo:dp-citychange', { detail: { city: c } })); } } catch (e) {}
        try { if (typeof h.showModal === 'function') h.showModal(); else h.setAttribute('open', ''); } catch (e) {}
      }
      var helpEl = document.querySelector('[data-bo-help]');
      if (helpEl) { helpEl.addEventListener('click', function (e) { if (e.target === helpEl) { try { helpEl.close(); } catch (x) {} } }); }
      function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
      function openKitModal() {
        var modal = document.querySelector('[data-bo-kitmodal]');
        var list = document.getElementById('bo-cod-kitmodal-list');
        if (!modal || !list || !st.kits || !st.kits.length) return;
        list.innerHTML = st.kits.map(function (k, i) {
          var active = (i === st.kitIndex);
          var save = k.saving > 0 ? '<span class="bo-cod__kitcard-save">Ahorras ' + k.saving + ' Bs</span>' : '<span class="bo-cod__kitcard-start">Para empezar</span>';
          var action = active ? '<span class="bo-cod__kitcard-current">Tu elección actual</span>' : '<button type="button" class="bo-cod__kitcard-pick" data-cod-kit-pick="' + i + '">Elegir este kit</button>';
          return '<div class="bo-cod__kitcard' + (active ? ' is-active' : '') + '">' +
            '<div class="bo-cod__kitcard-top"><span class="bo-cod__kitcard-name">' + esc(k.label) + ' de stickers</span><span class="bo-cod__kitcard-price">' + money(k.price) + '</span></div>' +
            '<ul class="bo-cod__kitcard-feats"><li>Dilatador + 4 tallas</li><li>' + k.days + ' pares de stickers</li><li>~' + k.days + ' días de uso</li></ul>' +
            '<div class="bo-cod__kitcard-foot">' + save + action + '</div>' +
          '</div>';
        }).join('');
        try { if (typeof modal.showModal === 'function') modal.showModal(); else modal.setAttribute('open', ''); } catch (e) {}
      }
      function selectKit(i) {
        var k = st.kits && st.kits[i]; if (!k) return;
        st.kitIndex = i; st.days = k.days; st.kitStickerPacks = k.stickerPacks; st.kitSaving = k.saving; st.unitPrice = k.price; st.kitName = k.label;
        st.stickerExtraPacks = 0; st.stickerExtraCents = 0;
        renderTotal(); renderIncludes(); renderStickerUpsell();
        var modal = document.querySelector('[data-bo-kitmodal]'); if (modal) { try { modal.close(); } catch (e) {} }
      }
      var kitModalEl = document.querySelector('[data-bo-kitmodal]');
      if (kitModalEl) { kitModalEl.addEventListener('click', function (e) { if (e.target === kitModalEl) { try { kitModalEl.close(); } catch (x) {} return; } var kp = e.target.closest('[data-cod-kit-pick]'); if (kp) { e.preventDefault(); selectKit(parseInt(kp.getAttribute('data-cod-kit-pick'), 10)); } }); }
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bo-dl-reviews"] && !Shopify.designMode) return;
  try {
    
    (function () {
      document.querySelectorAll('[data-bo-dlr]').forEach(function (root) {
        if (root.__boDlrInit) return;
        root.__boDlrInit = true;
        var track = root.querySelector('.bo-dlr__track'); if (!track) return;
        var prev = root.querySelector('[data-bo-dlr-prev]'), next = root.querySelector('[data-bo-dlr-next]');
        function step(dir) { var c = track.querySelector('.bo-dlr__card'); var w = c ? c.offsetWidth + 16 : Math.round(track.clientWidth * 0.85); track.scrollBy({ left: dir * w, behavior: 'smooth' }); }
        if (prev) prev.addEventListener('click', function () { step(-1); });
        if (next) next.addEventListener('click', function () { step(1); });
        function update() { var max = track.scrollWidth - track.clientWidth; if (max <= 4) { if (prev) prev.style.display = 'none'; if (next) next.style.display = 'none'; return; } if (prev) prev.style.display = track.scrollLeft <= 4 ? 'none' : ''; if (next) next.style.display = track.scrollLeft >= max - 4 ? 'none' : ''; }
        track.addEventListener('scroll', update, { passive: true }); window.addEventListener('resize', update); update();
      });
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bo-et-videos"] && !Shopify.designMode) return;
  try {
    
  (function(){
    document.querySelectorAll('.bo-etv').forEach(function(root){
      var cards = Array.prototype.slice.call(root.querySelectorAll('[data-etv-card]'));
      function reset(card){
        var v = card.querySelector('[data-etv-video]');
        card.classList.remove('is-playing');
        if (v && !v.paused) { v.pause(); }
        var t = card.querySelector('[data-etv-toggle]');
        if (t) { t.setAttribute('aria-label','Reproducir video'); }
      }
      function ensureSrc(v){
        if (v.dataset.loaded) return;
        var s = v.querySelector('source[data-src]');
        if (s){ s.src = s.getAttribute('data-src'); v.load(); }
        v.dataset.loaded = '1';
      }
      cards.forEach(function(card){
        var video = card.querySelector('[data-etv-video]');
        var toggle = card.querySelector('[data-etv-toggle]');
        if(!video || !toggle) return;
        toggle.addEventListener('click', function(){
          if (video.paused){
            cards.forEach(function(c){ if(c!==card) reset(c); });
            ensureSrc(video);
            video.muted = false;
            var p = video.play();
            if (p && p.catch){ p.catch(function(){ video.muted = true; video.play(); }); }
          } else {
            video.pause();
          }
        });
        video.addEventListener('play', function(){ card.classList.add('is-playing'); toggle.setAttribute('aria-label','Pausar video'); });
        video.addEventListener('pause', function(){ card.classList.remove('is-playing'); toggle.setAttribute('aria-label','Reproducir video'); });
        video.addEventListener('ended', function(){ card.classList.remove('is-playing'); video.currentTime = 0; toggle.setAttribute('aria-label','Reproducir video'); });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bo-lp-altura"] && !Shopify.designMode) return;
  try {
    
(function () {
  "use strict";
  function getCfg(){ try { return JSON.parse(document.getElementById('bo-lpa-cfg').textContent); } catch(e){ return { endpoint:'', variants:{} }; } }
  var C = getCfg();
  var SAVINGS = { 1: 0, 2: 60, 3: 140, 4: 220 };
  var TOTALS = { 1: 180, 2: 300, 3: 400, 4: 500 };
  function sid(){ try{ var k='bo_sid', s=sessionStorage.getItem(k); if(!s){ s='s'+Date.now().toString(36)+Math.random().toString(36).slice(2,8); sessionStorage.setItem(k,s);} return s; }catch(e){ return ''; } }
  function codIdempotencyKey(){ try{ if(crypto && typeof crypto.randomUUID==='function') return 'cod_'+crypto.randomUUID().replace(/-/g,''); }catch(e){} return 'cod_'+Date.now().toString(36)+Math.random().toString(36).slice(2,14); }
  function ab(){ try{ var k='bo_ab', a=localStorage.getItem(k); if(!a){ a=Math.random()<0.5?'A':'B'; localStorage.setItem(k,a);} return a; }catch(e){ return ''; } }
  function src(){ try{ var k='bo_src', s=sessionStorage.getItem(k); if(s) return s; var p=new URLSearchParams(location.search), v=p.get('utm_source')||''; if(!v){ var r=document.referrer||''; if(r){ try{ v=new URL(r).hostname.replace(/^www\./,''); }catch(e){} } if(!v) v='direct'; } sessionStorage.setItem(k,v); return v; }catch(e){ return ''; } }
  function track(ev, extra){ try{ if(!C.endpoint) return; var d=Object.assign({ id:'e'+Date.now().toString(36)+Math.random().toString(36).slice(2,8), event:ev, sid:sid(), ab:ab(), source:src(), product:'Tiras Nasales' }, extra||{}); var u=C.endpoint.replace(/\/+$/,'')+'/track'; if(navigator.sendBeacon){ navigator.sendBeacon(u, JSON.stringify(d)); } else { fetch(u,{method:'POST',headers:{'Content-Type':'text/plain'},body:JSON.stringify(d),keepalive:true}).catch(function(){}); } }catch(e){} }

  var reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }); }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    reveals.forEach(function (el) { io.observe(el); });
  } else { reveals.forEach(function (el) { el.classList.add('in'); }); }

  var sticky = document.getElementById('stickyCta');
  var hero = document.querySelector("section[data-screen-label^='01']");
  if (sticky && hero && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) sticky.classList.remove('show'); else sticky.classList.add('show'); }); }, { threshold: 0 }).observe(hero);
  }

  var modal = document.getElementById('formModal'), mbody = document.getElementById('modalBody'), closeBtn = document.getElementById('closeModal');
  var lastFocus = null, started = false, originalBody = mbody ? mbody.innerHTML : '', orderIdempotencyKey = '', formStartedAt = 0, orderDone = false;
  function openModal(){ if(!orderIdempotencyKey) orderIdempotencyKey=codIdempotencyKey(); if(!formStartedAt) formStartedAt=Date.now(); lastFocus=document.activeElement; modal.classList.add('open'); modal.setAttribute('aria-hidden','false'); document.body.style.overflow='hidden'; var f=modal.querySelector('input,select,textarea,button'); if(f) setTimeout(function(){ f.focus(); },60); track('cod_open'); }
  function closeModal(){ modal.classList.remove('open'); modal.setAttribute('aria-hidden','true'); document.body.style.overflow=''; if(mbody && mbody.querySelector('.thanks')){ mbody.innerHTML=originalBody; started=false; bindForm(); } if(lastFocus) lastFocus.focus(); if(!orderDone) maybeExitIntent(); }
  document.querySelectorAll('[data-open-form]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); openModal(); }); });
  if (closeBtn) closeBtn.addEventListener('click', closeModal);
  if (modal) modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal && modal.classList.contains('open')) closeModal(); });

  function esc(s){ return String(s).replace(/[&<>"']/g, function (c) { return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c]; }); }
  function showThanks(data){
    orderDone=true;
    var nombre=(data.get('nombre')||'').toString().trim(), first=nombre.split(' ')[0]||'Listo';
    var variante=(data.get('variante')||'Negro · Menta').toString(), qty=parseInt((data.get('cantidad')||'1'),10)||1;
    var cant=qty===1?'1 pack':qty+' packs';
    mbody.innerHTML='<div class="thanks"><div class="big-check">✓</div><h3 style="font-family:var(--font-display);font-weight:800;font-size:22px;margin-bottom:8px;color:var(--fg);">¡Pedido confirmado, '+esc(first)+'!</h3><p class="body" style="margin-bottom:18px;">Apartamos tu <strong>'+esc(cant)+'</strong> en variante <strong>'+esc(variante)+'</strong>. Te escribimos por WhatsApp para coordinar la entrega. <strong>Pagas cuando lo recibas.</strong></p><div class="mtrust" style="justify-content:center;"><span><span class="d"></span> Pagas al recibir</span><span><span class="d"></span> Envío a toda Bolivia</span><span><span class="d"></span> Garantía 30 días</span></div></div>';
  }
  function bindForm(){
    var form=document.getElementById('codForm'); if(!form) return;
    var cant=form.querySelector('#f-cant'), sum=document.getElementById('sumPrice');
    if(cant && sum){ cant.addEventListener('change', function(){ var q=parseInt(cant.value,10)||1; sum.textContent=(TOTALS[q]||180)+' Bs'; }); }
    form.addEventListener('input', function(){ if(!started){ started=true; track('cod_start'); } });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!form.checkValidity()) { form.reportValidity(); return; }
      var data=new FormData(form);
      var variante=(data.get('variante')||'Negro · Menta').toString();
      var qty=parseInt((data.get('cantidad')||'1'),10)||1;
      var saving=SAVINGS[qty]||0;
      var vid=C.variants[variante]||C.variants['Negro · Menta'];
      var payload={ action:'create', offerId:'tiras-pdp', idempotencyKey:orderIdempotencyKey, formStartedAt:formStartedAt, website:(data.get('website')||'').toString(), items:[{ variantId:vid, quantity:qty }], shipping:'cod', saving:saving, discountPct:0, discountCode:'', customer:{ name:(data.get('nombre')||'').toString().trim(), phone:(data.get('telefono')||'').toString(), city:(data.get('ciudad')||'').toString(), address:(data.get('direccion')||'').toString() }, sid:sid(), ab:ab(), source:src(), product:'Tiras Nasales', variant:variante, pack:qty };
      var btn=form.querySelector('.submit'); if(btn){ btn.disabled=true; btn.textContent='Enviando...'; }
      track('cod_submit',{ variant:variante, pack:qty });
      if(!C.endpoint){ showThanks(data); return; }
      fetch(C.endpoint,{ method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify(payload) })
        .then(function(r){ if(!r.ok) throw new Error('fail'); return r.json(); })
        .then(function(res){ if(res && res.ok){ showThanks(data); } else { throw new Error('nok'); } })
        .catch(function(){ if(btn){ btn.disabled=false; btn.textContent='Confirmar pedido — pago al recibir'; } alert('Hubo un problema. Intenta de nuevo o escríbenos por WhatsApp.'); });
    });
  }
  bindForm();

  var exitShown=false;
  var exitOv=document.getElementById('boExitOv');
  function exitSeen(){ try{ var t=parseInt(localStorage.getItem('bo_exit_lpa')||'0',10); return t>0 && (Date.now()-t) < 30*24*3600*1000; }catch(e){ return false; } }
  function markExitSeen(){ try{ localStorage.setItem('bo_exit_lpa', String(Date.now())); }catch(e){} }
  function maybeExitIntent(){ if(exitShown||orderDone||exitSeen()||!exitOv) return; exitShown=true; markExitSeen(); exitOv.classList.add('open'); document.body.style.overflow='hidden'; track('exit_intent'); }
  function closeExit(){ if(!exitOv) return; exitOv.classList.remove('open'); if(!modal.classList.contains('open')) document.body.style.overflow=''; }
  if(exitOv){
    document.addEventListener('mouseout', function(e){ if(e.relatedTarget||e.clientY>12) return; if(modal.classList.contains('open')||exitOv.classList.contains('open')) return; maybeExitIntent(); });
    document.getElementById('boExitClaim').addEventListener('click', function(){ track('exit_claim',{ meta:{ to:'whatsapp' } }); closeExit(); });
    document.getElementById('boExitClose').addEventListener('click', closeExit);
    exitOv.addEventListener('click', function(e){ if(e.target===exitOv) closeExit(); });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bo-lp-dormir"] && !Shopify.designMode) return;
  try {
    
(function () {
  "use strict";
  function getCfg(){ try { return JSON.parse(document.getElementById('bo-lpd2-cfg').textContent); } catch(e){ return { endpoint:'', variants:{} }; } }
  var C = getCfg();
  function sid(){ try{ var k='bo_sid', s=sessionStorage.getItem(k); if(!s){ s='s'+Date.now().toString(36)+Math.random().toString(36).slice(2,8); sessionStorage.setItem(k,s);} return s; }catch(e){ return ''; } }
  function codIdempotencyKey(){ try{ if(crypto && typeof crypto.randomUUID==='function') return 'cod_'+crypto.randomUUID().replace(/-/g,''); }catch(e){} return 'cod_'+Date.now().toString(36)+Math.random().toString(36).slice(2,14); }
  function ab(){ try{ var k='bo_ab', a=localStorage.getItem(k); if(!a){ a=Math.random()<0.5?'A':'B'; localStorage.setItem(k,a);} return a; }catch(e){ return ''; } }
  function src(){ try{ var k='bo_src', s=sessionStorage.getItem(k); if(s) return s; var p=new URLSearchParams(location.search), v=p.get('utm_source')||''; if(!v){ var r=document.referrer||''; if(r){ try{ v=new URL(r).hostname.replace(/^www\./,''); }catch(e){} } if(!v) v='direct'; } sessionStorage.setItem(k,v); return v; }catch(e){ return ''; } }
  function track(ev, extra){ try{ if(!C.endpoint) return; var d=Object.assign({ id:'e'+Date.now().toString(36)+Math.random().toString(36).slice(2,8), event:ev, sid:sid(), ab:ab(), source:src(), product:'Tiras Nasales' }, extra||{}); var u=C.endpoint.replace(/\/+$/,'')+'/track'; if(navigator.sendBeacon){ navigator.sendBeacon(u, JSON.stringify(d)); } else { fetch(u,{method:'POST',headers:{'Content-Type':'text/plain'},body:JSON.stringify(d),keepalive:true}).catch(function(){}); } }catch(e){} }

  var reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }); }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    reveals.forEach(function (el) { io.observe(el); });
  } else { reveals.forEach(function (el) { el.classList.add('in'); }); }

  var sticky = document.getElementById('stickyCta');
  var hero = document.querySelector("section[data-screen-label^='01']");
  if (sticky && hero && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) sticky.classList.remove('show'); else sticky.classList.add('show'); }); }, { threshold: 0 }).observe(hero);
  }

  var modal = document.getElementById('formModal'), mbody = document.getElementById('modalBody'), closeBtn = document.getElementById('closeModal');
  var lastFocus = null, started = false, originalBody = mbody ? mbody.innerHTML : '', orderIdempotencyKey = '', formStartedAt = 0;
  function openModal(){ if(!orderIdempotencyKey) orderIdempotencyKey=codIdempotencyKey(); if(!formStartedAt) formStartedAt=Date.now(); lastFocus=document.activeElement; modal.classList.add('open'); modal.setAttribute('aria-hidden','false'); document.body.style.overflow='hidden'; var f=modal.querySelector('input,select,textarea,button'); if(f) setTimeout(function(){ f.focus(); },60); track('cod_open'); }
  function closeModal(){ modal.classList.remove('open'); modal.setAttribute('aria-hidden','true'); document.body.style.overflow=''; if(mbody && mbody.querySelector('.thanks')){ mbody.innerHTML=originalBody; started=false; bindForm(); } if(lastFocus) lastFocus.focus(); if(!orderDone) maybeExitIntent(); }
  document.querySelectorAll('[data-open-form]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); openModal(); }); });
  if (closeBtn) closeBtn.addEventListener('click', closeModal);
  if (modal) modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal && modal.classList.contains('open')) closeModal(); });

  function esc(s){ return String(s).replace(/[&<>"']/g, function (c) { return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c]; }); }
  function showThanks(data){
    orderDone=true;
    var nombre=(data.get('nombre')||'').toString().trim(), first=nombre.split(' ')[0]||'Listo';
    var variante=data.get('variante')||'Negro', cant=data.get('cantidad')==='3'?'3 packs':'1 pack';
    mbody.innerHTML='<div class="thanks"><div class="big-check">✓</div><h3 style="font-family:var(--font-display);font-weight:800;font-size:22px;margin-bottom:8px;color:var(--fg);">¡Pedido confirmado, '+esc(first)+'!</h3><p class="body" style="margin-bottom:18px;">Apartamos tu <strong>'+esc(cant)+'</strong> en variante <strong>'+esc(variante.toString())+'</strong>. Te escribimos por WhatsApp para coordinar la entrega. <strong>Pagas cuando lo recibas.</strong></p><div class="mtrust" style="justify-content:center;"><span><span class="d"></span> Pagas al recibir</span><span><span class="d"></span> Envío a toda Bolivia</span><span><span class="d"></span> Garantía 30 días</span></div></div>';
  }
  function bindForm(){
    var form=document.getElementById('codForm'); if(!form) return;
    form.addEventListener('input', function(){ if(!started){ started=true; track('cod_start'); } });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!form.checkValidity()) { form.reportValidity(); return; }
      var data=new FormData(form);
      var variante=(data.get('variante')||'Negro · Menta').toString();
      var qty=data.get('cantidad')==='3'?3:1;
      var saving=qty===3?140:0;
      var vid=C.variants[variante]||C.variants['Negro · Menta'];
      var payload={ action:'create', offerId:'tiras-lp-dormir', idempotencyKey:orderIdempotencyKey, formStartedAt:formStartedAt, website:(data.get('website')||'').toString(), items:[{ variantId:vid, quantity:qty }], shipping:'cod', saving:saving, discountPct:(exitDiscount?15:0), discountCode:(exitDiscount?'DORMIR15':''), customer:{ name:(data.get('nombre')||'').toString().trim(), phone:(data.get('telefono')||'').toString(), city:(data.get('ciudad')||'').toString(), address:(data.get('direccion')||'').toString() }, sid:sid(), ab:ab(), source:src(), product:'Tiras Nasales', variant:variante, pack:qty };
      var btn=form.querySelector('.submit'); if(btn){ btn.disabled=true; btn.textContent='Enviando...'; }
      track('cod_submit',{ variant:variante, pack:qty });
      if(!C.endpoint){ showThanks(data); return; }
      fetch(C.endpoint,{ method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify(payload) })
        .then(function(r){ if(!r.ok) throw new Error('fail'); return r.json(); })
        .then(function(res){ if(res && res.ok){ showThanks(data); } else { throw new Error('nok'); } })
        .catch(function(){ if(btn){ btn.disabled=false; btn.textContent='Confirmar pedido — pago al recibir'; } alert('Hubo un problema. Intenta de nuevo o escríbenos por WhatsApp.'); });
    });
  }
  bindForm();

  /* ---- exit-intent (porteado de LP Rinitis): 1 vez, recordado 30 dias, timer 10 min ---- */
  var exitDiscount=false, exitShown=false, orderDone=false;
  var exitOv=document.getElementById('boExitOv'), exitNum=document.getElementById('boExitNum');
  var exitDeadline=null, exitInt=null;
  function exitSeen(){ try{ var t=parseInt(localStorage.getItem('bo_exit_lpd')||'0',10); return t>0 && (Date.now()-t) < 30*24*3600*1000; }catch(e){ return false; } }
  function markExitSeen(){ try{ localStorage.setItem('bo_exit_lpd', String(Date.now())); }catch(e){} }
  function maybeExitIntent(){ if(exitShown||orderDone||exitSeen()||!exitOv) return; exitShown=true; markExitSeen(); exitOv.classList.add('open'); document.body.style.overflow='hidden'; exitDeadline=Date.now()+600000; exitInt=setInterval(tickExit,250); tickExit(); track('exit_intent'); }
  function tickExit(){ var ms=Math.max(0,exitDeadline-Date.now()); var m=Math.floor(ms/60000), s2=Math.floor((ms%60000)/1000); if(exitNum) exitNum.textContent=m+':'+(s2<10?'0':'')+s2; if(ms<=0){ clearInterval(exitInt); exitDiscount=false; var p=document.getElementById('bo-exit-pill'); if(p) p.style.display='none'; closeExit(); } }
  function closeExit(){ if(!exitOv) return; exitOv.classList.remove('open'); if(!modal.classList.contains('open')) document.body.style.overflow=''; }
  if(exitOv){
    document.addEventListener('mouseout', function(e){ if(e.relatedTarget||e.clientY>12) return; if(modal.classList.contains('open')||exitOv.classList.contains('open')) return; maybeExitIntent(); });
    document.getElementById('boExitClaim').addEventListener('click', function(){ exitDiscount=true; track('exit_claim'); closeExit(); var p=document.getElementById('bo-exit-pill'); if(p) p.style.display='block'; openModal(); });
    document.getElementById('boExitClose').addEventListener('click', closeExit);
    exitOv.addEventListener('click', function(e){ if(e.target===exitOv) closeExit(); });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bo-lp-recomendador"] && !Shopify.designMode) return;
  try {
    
(function () {
  "use strict";
  function getCfg(){ try { return JSON.parse(document.getElementById('bo-lpr-cfg').textContent); } catch(e){ return { endpoint:'', products:{} }; } }
  var C = getCfg();
  function sid(){ try{ var k='bo_sid', s=sessionStorage.getItem(k); if(!s){ s='s'+Date.now().toString(36)+Math.random().toString(36).slice(2,8); sessionStorage.setItem(k,s);} return s; }catch(e){ return ''; } }
  function codIdempotencyKey(){ try{ if(crypto && typeof crypto.randomUUID==='function') return 'cod_'+crypto.randomUUID().replace(/-/g,''); }catch(e){} return 'cod_'+Date.now().toString(36)+Math.random().toString(36).slice(2,14); }
  function ab(){ try{ var k='bo_ab', a=localStorage.getItem(k); if(!a){ a=Math.random()<0.5?'A':'B'; localStorage.setItem(k,a);} return a; }catch(e){ return ''; } }
  function src(){ try{ var k='bo_src', s=sessionStorage.getItem(k); if(s) return s; var p=new URLSearchParams(location.search), v=p.get('utm_source')||''; if(!v){ var r=document.referrer||''; if(r){ try{ v=new URL(r).hostname.replace(/^www\./,''); }catch(e){} } if(!v) v='direct'; } sessionStorage.setItem(k,v); return v; }catch(e){ return ''; } }
  var currentKey = 'tiras';
  function track(ev, extra){ try{ if(!C.endpoint) return; var prod=(C.products[currentKey]||{}).product||'Recomendador'; var d=Object.assign({ id:'e'+Date.now().toString(36)+Math.random().toString(36).slice(2,8), event:ev, sid:sid(), ab:ab(), source:src(), product:prod }, extra||{}); var u=C.endpoint.replace(/\/+$/,'')+'/track'; if(navigator.sendBeacon){ navigator.sendBeacon(u, JSON.stringify(d)); } else { fetch(u,{method:'POST',headers:{'Content-Type':'text/plain'},body:JSON.stringify(d),keepalive:true}).catch(function(){}); } }catch(e){} }

  var reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }); }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    reveals.forEach(function (el) { io.observe(el); });
  } else { reveals.forEach(function (el) { el.classList.add('in'); }); }

  var sticky = document.getElementById('stickyCta');
  var hero = document.querySelector("section[data-screen-label^='01']");
  if (sticky && hero && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) sticky.classList.remove('show'); else sticky.classList.add('show'); }); }, { threshold: 0 }).observe(hero);
  }

  /* ============ MINI CARRUSELES ============ */
  document.querySelectorAll('[data-carousel]').forEach(function(car){
    var track = car.querySelector('.pmedia__track');
    if(!track) return;
    var slides = track.children;
    var dotsBox = car.querySelector('.pmedia__dots');
    var prev = car.querySelector('.pmedia__nav--prev'), next = car.querySelector('.pmedia__nav--next');
    if(slides.length < 2){ if(prev) prev.style.display='none'; if(next) next.style.display='none'; return; }
    var dots = [];
    for(var i=0;i<slides.length;i++){
      var d=document.createElement('button'); d.type='button';
      d.className='pmedia__dot'+(i===0?' on':''); d.setAttribute('data-i', String(i));
      dotsBox.appendChild(d); dots.push(d);
    }
    function cur(){ return Math.max(0, Math.min(slides.length-1, Math.round(track.scrollLeft / track.clientWidth))); }
    function goTo(i){ track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' }); }
    dotsBox.addEventListener('click', function(e){ var b=e.target.closest('.pmedia__dot'); if(b) goTo(parseInt(b.getAttribute('data-i'),10)); });
    if(prev) prev.addEventListener('click', function(){ goTo(Math.max(0, cur()-1)); });
    if(next) next.addEventListener('click', function(){ goTo(Math.min(slides.length-1, cur()+1)); });
    var st=null;
    track.addEventListener('scroll', function(){ if(st) clearTimeout(st); st=setTimeout(function(){ var c=cur(); dots.forEach(function(d,j){ d.classList.toggle('on', j===c); }); }, 80); }, { passive: true });
  });

  /* ============ QUIZ ============ */
  var ICONS = {
    moon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.5 13.5A8.5 8.5 0 1 1 10.5 3.5a7 7 0 0 0 10 10Z"/></svg>',
    gym: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M7 8v8M17 8v8M3.5 10v4M20.5 10v4M7 12h10"/></svg>',
    waves: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M3.5 12h1.5M7.5 8.5v7M11.5 5.5v13M15.5 8.5v7M19.5 10.5v3"/></svg>',
    drop: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3.5s5.5 6.6 5.5 10.2a5.5 5.5 0 1 1-11 0C6.5 10.1 12 3.5 12 3.5Z"/></svg>',
    nose: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M13.5 3.5c0 4.5 2.5 6.3 2.5 9.3a4.6 4.6 0 0 1-8.2 2.9"/><path d="M9.4 18.6h.01M14 18.6h.01" stroke-width="2.4"/></svg>',
    mouth: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4.5 12c2.5-3.2 5-4.5 7.5-4.5s5 1.3 7.5 4.5c-2.5 3.2-5 4.5-7.5 4.5S7 15.2 4.5 12Z"/><path d="M4.5 12h15"/></svg>',
    target: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><circle cx="12" cy="12" r="8"/><circle cx="12" cy="12" r="3"/></svg>',
    check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4.5 12.5l5 5 10-11"/></svg>',
    minus: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 12h12"/></svg>'
  };
  var QUESTIONS = {
    q1: { step: 1, title: '¿Para qué lo necesitas principalmente?', opts: [
      { label: 'Dormir mejor / descansar', ic: 'moon', next: 'q2', ctx: 'dormir' },
      { label: 'Deporte / entrenar', ic: 'gym', next: 'q3', ctx: 'deporte' },
      { label: 'Ronquidos (míos o de mi pareja)', ic: 'waves', next: 'q2', ctx: 'ronquido' },
      { label: 'Nariz tapada / rinitis', ic: 'drop', next: 'q2', ctx: 'rinitis' },
      { label: 'Tabique desviado', ic: 'nose', result: 'r_tabique' }
    ]},
    q2: { step: 2, title: '¿Duermes con la boca abierta o amaneces con la boca seca?', opts: [
      { label: 'Sí, casi siempre', ic: 'mouth', resultByCtx: { dormir: 'r_combo_dormir', ronquido: 'r_combo_ronquido', rinitis: 'r_combo_rinitis' } },
      { label: 'No / no sé', ic: 'minus', resultByCtx: { dormir: 'r_tiras_dormir', ronquido: 'r_tiras_ronquido', rinitis: 'r_tiras_rinitis' } }
    ]},
    q3: { step: 2, title: '¿Practicas deportes de contacto (boxeo, MMA)?', opts: [
      { label: 'Sí', ic: 'target', result: 'r_tiras_contacto' },
      { label: 'No', ic: 'minus', next: 'q4' }
    ]},
    q4: { step: 3, title: '¿Sudas mucho, tienes piel grasa o prefieres algo reutilizable?', opts: [
      { label: 'Sí', ic: 'drop', result: 'r_dilatador_deporte' },
      { label: 'No', ic: 'minus', result: 'r_tiras_deporte' }
    ]}
  };
  var RESULTS = {
    r_tabique: { key: 'dilatador', variant: 'Negro', name: 'Dilatador Nasal Magnético', price: '300 Bs · kit con las 4 tallas', why: 'Para tabique desviado es el indicado: abre la fosa estrecha 60 a 80% desde afuera (el doble que una tira) y el kit trae las 4 tallas para que encuentres la que mejor te abre. Es 100% externo: nada entra en la nariz.', note: 'Honesto: no corrige el tabique ni reemplaza al especialista; te ayuda a respirar mejor mientras tanto.' },
    r_dilatador_deporte: { key: 'dilatador', variant: 'Negro', name: 'Dilatador Nasal Magnético', price: '300 Bs · kit con las 4 tallas', why: 'El sudor y la piel grasa despegan cualquier adhesivo. La banda magnética no depende del adhesivo para abrir, se reutiliza indefinidamente y abre 60 a 80%. Solo se reponen los stickers (8-12 h cada par).', note: 'Si algún día haces deporte de contacto, ese día usa tiras: la banda se puede salir con golpes.' },
    r_tiras_contacto: { key: 'tiras', variant: 'Negro · Menta', name: 'Tiras Nasales · Negro Menta', price: '180 Bs · 30 tiras (1 mes)', why: 'En deportes de contacto la banda magnética del dilatador se puede salir con los golpes, así que para ti son las tiras: la variante Negro · Menta tiene la máxima adherencia (14-24 h) y resiste el sudor.', note: 'Ponla sobre piel limpia y seca, presionando 30 segundos.' },
    r_tiras_deporte: { key: 'tiras', variant: 'Negro · Menta', name: 'Tiras Nasales · Negro Menta', price: '180 Bs · 30 tiras (1 mes)', why: 'Para entrenar, la Negro · Menta es la más usada: máxima adherencia (14-24 h), resiste el sudor y la menta refresca. Abre tu nariz 30-40% al instante, sin curva de aprendizaje.', note: 'Si más adelante quieres más apertura o algo reutilizable, el dilatador es el upgrade natural.' },
    r_tiras_dormir: { key: 'tiras', variant: 'Piel · Lavanda', name: 'Tiras Nasales · Piel Lavanda', price: '180 Bs · 30 tiras (1 mes)', why: 'Para dormir, la Piel · Lavanda es la favorita: suave con la piel y con esencia relajante. Abre tu nariz 30-40% en 1 a 3 segundos para que duermas respirando por la nariz.', note: 'Si tu boca se abre sola de noche, considera sumar la cinta bucal después.' },
    r_tiras_ronquido: { key: 'tiras', variant: 'Negro · Menta', name: 'Tiras Nasales', price: '180 Bs · 30 tiras (1 mes)', why: 'Si tu boca se queda cerrada al dormir, tu ronquido probablemente nace en la nariz: la tira la abre 30-40% y reduce esa causa desde la primera noche.', note: 'Honesto: si el ronquido viene de la garganta, la nariz sola no lo arregla del todo.' },
    r_tiras_rinitis: { key: 'tiras', variant: 'Negro · Menta', name: 'Tiras Nasales · Negro Menta', price: '180 Bs · 30 tiras (1 mes)', why: 'Para la nariz tapada, la tira abre mecánicamente 30-40%, sin gotas y sin rebote. La Negro · Menta suma el frescor de la menta; si tu piel es sensible, elige la Transparente sin esencia en el pedido.', note: 'Complementa lo que te indique tu médico; no lo reemplaza.' },
    r_combo_dormir: { key: 'combo', variant: 'Piel · Lavanda', name: 'Combo Cinta + Tiras', price: '300 Bs (antes 360)', why: 'Tu caso pide el dúo: la tira abre la nariz (elige Piel · Lavanda, con esencia relajante) y la cinta bucal mantiene la boca cerrada. Duermes respirando por la nariz y amaneces sin la boca seca.', note: 'La cinta es transpirable: permite que entre aire si lo necesitas.' },
    r_combo_ronquido: { key: 'combo', variant: 'Negro · Menta', name: 'Combo Cinta + Tiras', price: '300 Bs (antes 360)', why: 'El ronquido suele tener dos causas a la vez: nariz cerrada y boca abierta. El combo ataca las dos: la tira abre tu nariz y la cinta evita que la boca se abra. Por eso es lo que más recomendamos para roncadores.', note: 'Honesto: reduce el ronquido de origen nasal y bucal; si viene de la garganta, puede no bastar.' },
    r_combo_rinitis: { key: 'combo', variant: 'Negro · Menta', name: 'Combo Cinta + Tiras', price: '300 Bs (antes 360)', why: 'Para rinitis con boca abierta recomendamos tiras y cinta juntas: la tira abre las fosas y la cinta te mantiene respirando por la nariz toda la noche.', note: 'Complementa lo que te indique tu médico; no lo reemplaza.' }
  };
  var qBody = document.getElementById('quizBody');
  var qDots = document.querySelectorAll('.q-dot');
  var history = [];
  var quizStarted = false;
  function setStep(n){ qDots.forEach(function(d,i){ d.classList.toggle('on', i < n); }); }
  function esc(s){ return String(s).replace(/[&<>"']/g, function (c) { return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c]; }); }
  function renderQuestion(id, ctx){
    var q = QUESTIONS[id]; if(!q || !qBody) return;
    if(!quizStarted){ quizStarted = true; track('quiz_start'); }
    setStep(q.step);
    var html = '<div class="q-title">'+esc(q.title)+'</div><div class="q-opts">';
    q.opts.forEach(function(o, i){ html += '<button type="button" class="q-opt" data-i="'+i+'"><span class="q-ic">'+(ICONS[o.ic]||'')+'</span><span class="q-lb">'+esc(o.label)+'</span><span class="q-arrow">→</span></button>'; });
    html += '</div>';
    if(history.length){ html += '<div style="text-align:center;"><button type="button" class="q-back" id="qBack">← Volver</button></div>'; }
    qBody.innerHTML = html;
    qBody.querySelectorAll('.q-opt').forEach(function(btn){
      btn.addEventListener('click', function(){
        var o = q.opts[parseInt(btn.getAttribute('data-i'),10)];
        var nextCtx = o.ctx || ctx;
        history.push({ id: id, ctx: ctx });
        if(o.result){ renderResult(o.result); }
        else if(o.resultByCtx){ renderResult(o.resultByCtx[nextCtx] || 'r_tiras_dormir'); }
        else if(o.next){ renderQuestion(o.next, nextCtx); }
      });
    });
    var back = document.getElementById('qBack');
    if(back){ back.addEventListener('click', function(){ var prev = history.pop(); if(prev){ renderQuestion(prev.id, prev.ctx); history.pop(); } }); }
  }
  function renderResult(rid){
    var r = RESULTS[rid]; if(!r || !qBody) return;
    var p = C.products[r.key] || {};
    setStep(3);
    currentKey = r.key;
    track('quiz_result', { meta: { result: rid } });
    var mediaHtml = p.img ? '<img src="'+esc(p.img)+'" alt="'+esc(r.name)+'">' : '';
    if (r.key === 'dilatador') {
      mediaHtml = '<video src="https://cdn.shopify.com/videos/c/vp/4e3d4f5e66814b7ca22ee76be0ff2370/4e3d4f5e66814b7ca22ee76be0ff2370.SD-480p-0.9Mbps-61887126.mp4" poster="https://cdn.shopify.com/s/files/1/0583/2966/1510/files/preview_images/4e3d4f5e66814b7ca22ee76be0ff2370.thumbnail.0000000000.jpg" autoplay muted loop playsinline preload="metadata" aria-label="Video del dilatador nasal magnético en uso"></video>';
    }
    qBody.innerHTML = '<div class="q-result">'
      + '<span class="r-kicker">Tu recomendación</span>'
      + mediaHtml
      + '<h3>'+esc(r.name)+'</h3>'
      + '<div class="r-price">'+esc(r.price)+'</div>'
      + '<div class="r-why">'+esc(r.why)+'</div>'
      + '<div class="r-note">'+esc(r.note)+' Pagas al recibir y tienes garantía de 30 días.</div>'
      + '<button type="button" class="r-cta" id="rBuy">Pedir — pago al recibir</button>'
      + '<div class="r-links">'
      + '<button type="button" id="rRestart">Volver a empezar</button>'
      + '<a href="#comparar">Ver la comparación</a>'
      + '<a href="https://wa.me/59176757500?text=Hola%2C%20hice%20el%20test%20y%20me%20recomend%C3%B3%20'+encodeURIComponent(r.name)+'.%20Tengo%20una%20duda" target="_blank" rel="noopener">Preguntar por WhatsApp</a>'
      + '</div></div>';
    document.getElementById('rBuy').addEventListener('click', function(){ openModal(r.key, r.variant); });
    document.getElementById('rRestart').addEventListener('click', function(){ history = []; renderQuestion('q1', ''); });
  }
  if(qBody){ renderQuestion('q1', ''); }
  document.querySelectorAll('[data-goto-quiz]').forEach(function(b){
    b.addEventListener('click', function(e){ e.preventDefault(); var el=document.getElementById('quiz'); if(el){ el.scrollIntoView({ behavior:'smooth' }); } });
  });

  /* ============ MODAL DINÁMICO ============ */
  var modal = document.getElementById('formModal'), mbody = document.getElementById('modalBody'), closeBtn = document.getElementById('closeModal');
  var lastFocus = null, started = false, originalBody = mbody ? mbody.innerHTML : '', orderIdempotencyKey = '', formStartedAt = 0, orderDone = false;
  function configureModal(key, preVariant){
    var p = C.products[key]; if(!p) return;
    currentKey = key;
    document.getElementById('formTitle').textContent = 'Pide tu ' + p.product.toLowerCase().replace('cinta bucal + tiras nasales','combo');
    document.getElementById('sumTitle').textContent = p.title;
    var cant = document.getElementById('f-cant');
    cant.innerHTML = p.qtyOpts.map(function(o,i){ return '<option value="'+esc(o.v)+'"'+(i===0?' selected':'')+'>'+esc(o.label)+'</option>'; }).join('');
    var chips = document.getElementById('varChips');
    var names = Object.keys(p.variants);
    document.getElementById('varLabel').textContent = key==='dilatador' ? 'Color' : 'Variante';
    chips.innerHTML = names.map(function(n,i){
      var id='vv'+i, checked=(preVariant && n===preVariant) || (!preVariant && i===0);
      return '<span class="vchip"><input type="radio" id="'+id+'" name="variante" value="'+esc(n)+'"'+(checked?' checked':'')+'><label for="'+id+'">'+esc(n)+'</label></span>';
    }).join('');
    updateSum();
  }
  function currentQtyOpt(){
    var p = C.products[currentKey]; var v = document.getElementById('f-cant').value;
    for(var i=0;i<p.qtyOpts.length;i++){ if(p.qtyOpts[i].v===v) return p.qtyOpts[i]; }
    return p.qtyOpts[0];
  }
  function updateSum(){ var o=currentQtyOpt(); document.getElementById('sumPrice').textContent = o.total + ' Bs'; }
  function openModal(key, preVariant){
    configureModal(key || 'tiras', preVariant);
    if(!orderIdempotencyKey) orderIdempotencyKey=codIdempotencyKey();
    if(!formStartedAt) formStartedAt=Date.now();
    lastFocus=document.activeElement; modal.classList.add('open'); modal.setAttribute('aria-hidden','false'); document.body.style.overflow='hidden';
    var f=modal.querySelector('input,select,textarea,button'); if(f) setTimeout(function(){ f.focus(); },60);
    track('cod_open');
  }
  function closeModal(){ modal.classList.remove('open'); modal.setAttribute('aria-hidden','true'); document.body.style.overflow=''; if(mbody && mbody.querySelector('.thanks')){ mbody.innerHTML=originalBody; started=false; bindForm(); } if(lastFocus) lastFocus.focus(); }
  document.querySelectorAll('[data-buy]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); openModal(b.getAttribute('data-buy')); }); });
  if (closeBtn) closeBtn.addEventListener('click', closeModal);
  if (modal) modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal && modal.classList.contains('open')) closeModal(); });

  function showThanks(data){
    orderDone=true;
    var p = C.products[currentKey];
    var nombre=(data.get('nombre')||'').toString().trim(), first=nombre.split(' ')[0]||'Listo';
    var variante=(data.get('variante')||'').toString();
    mbody.innerHTML='<div class="thanks"><div class="big-check">✓</div><h3 style="font-family:var(--font-display);font-weight:800;font-size:22px;margin-bottom:8px;color:var(--fg);">¡Pedido confirmado, '+esc(first)+'!</h3><p class="body" style="margin-bottom:18px;">Apartamos tu <strong>'+esc(p.title)+'</strong>'+(variante?' en <strong>'+esc(variante)+'</strong>':'')+'. Te escribimos por WhatsApp para coordinar la entrega. <strong>Pagas cuando lo recibas.</strong></p><div class="mtrust" style="justify-content:center;"><span><span class="d"></span> Pagas al recibir</span><span><span class="d"></span> Envío a toda Bolivia</span><span><span class="d"></span> Garantía 30 días</span></div></div>';
  }
  function bindForm(){
    var form=document.getElementById('codForm'); if(!form) return;
    var cant=form.querySelector('#f-cant');
    if(cant){ cant.addEventListener('change', updateSum); }
    form.addEventListener('input', function(){ if(!started){ started=true; track('cod_start'); } });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!form.checkValidity()) { form.reportValidity(); return; }
      var p = C.products[currentKey];
      var data=new FormData(form);
      var variante=(data.get('variante')||'').toString();
      var opt=currentQtyOpt();
      var vid=p.variants[variante] || p.variants[Object.keys(p.variants)[0]];
      var items=[{ variantId: vid, quantity: opt.qty }];
      if(currentKey==='dilatador' && opt.extraStickers > 0){ items.push({ variantId: p.stickers, quantity: opt.extraStickers }); }
      var payload={ action:'create', offerId:p.offerId, idempotencyKey:orderIdempotencyKey, formStartedAt:formStartedAt, website:(data.get('website')||'').toString(), items:items, shipping:'cod', saving:opt.saving, discountPct:0, discountCode:'', customer:{ name:(data.get('nombre')||'').toString().trim(), phone:(data.get('telefono')||'').toString(), city:(data.get('ciudad')||'').toString(), address:(data.get('direccion')||'').toString() }, sid:sid(), ab:ab(), source:src(), product:p.product, variant:variante, pack:opt.v };
      var btn=form.querySelector('.submit'); if(btn){ btn.disabled=true; btn.textContent='Enviando...'; }
      track('cod_submit',{ variant:variante, pack:opt.v });
      if(!C.endpoint){ showThanks(data); return; }
      fetch(C.endpoint,{ method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify(payload) })
        .then(function(r){ if(!r.ok) throw new Error('fail'); return r.json(); })
        .then(function(res){ if(res && res.ok){ showThanks(data); } else { throw new Error('nok'); } })
        .catch(function(){ if(btn){ btn.disabled=false; btn.textContent='Confirmar pedido — pago al recibir'; } alert('Hubo un problema. Intenta de nuevo o escríbenos por WhatsApp.'); });
    });
  }
  bindForm();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bo-lp-rinitis"] && !Shopify.designMode) return;
  try {
    
(function () {
  "use strict";

  function getCfg() { try { return JSON.parse(document.getElementById("bo-lpr-cfg").textContent); } catch (e) { return { endpoint: "", variants: {}, cintaVariant: 0 }; } }
  var C = getCfg();
  var ENDPOINT = (C.endpoint || "").replace(/\/+$/, "");

  function sid() { try { var k = "bo_sid", s = sessionStorage.getItem(k); if (!s) { s = "s" + Date.now().toString(36) + Math.random().toString(36).slice(2, 8); sessionStorage.setItem(k, s); } return s; } catch (e) { return ""; } }
  function ab() { try { var k = "bo_ab", a = localStorage.getItem(k); if (!a) { a = Math.random() < 0.5 ? "A" : "B"; localStorage.setItem(k, a); } return a; } catch (e) { return ""; } }
  function src() { try { var k = "bo_src", s = sessionStorage.getItem(k); if (s) return s; var p = new URLSearchParams(location.search), v = p.get("utm_source") || ""; if (!v) { var r = document.referrer || ""; if (r) { try { v = new URL(r).hostname.replace(/^www\./, ""); } catch (e2) {} } if (!v) v = "direct"; } sessionStorage.setItem(k, v); return v; } catch (e) { return ""; } }
  function track(ev, extra) { try { if (!ENDPOINT) return; var d = Object.assign({ id: "e" + Date.now().toString(36) + Math.random().toString(36).slice(2, 8), event: ev, sid: sid(), ab: ab(), source: src(), product: "Tiras Nasales" }, extra || {}); var u = ENDPOINT + "/track"; if (navigator.sendBeacon) { navigator.sendBeacon(u, JSON.stringify(d)); } else { fetch(u, { method: "POST", headers: { "Content-Type": "text/plain" }, body: JSON.stringify(d), keepalive: true }).catch(function () {}); } } catch (e) {} }

  var PACKS = {
    1: { price: 180, perNight: "6,0", save: 0 },
    2: { price: 300, perNight: "5,0", save: 60 },
    3: { price: 400, perNight: "4,4", save: 140 },
    4: { price: 500, perNight: "4,2", save: 220 }
  };
  var ADDON_PRICE = 120;
  var ENCOMIENDA_FEE = 10;

  var state = {
    qty: 3,
    variant: "Negro · Menta",
    discount: false,
    addon: null,
    name: "",
    submitted: false,
    started: false,
    sending: false,
    orderId: "",
    encomienda: false,
    exitShown: false,
    idempotencyKey: "",
    formStartedAt: 0
  };

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function codIdempotencyKey() {
    try { if (crypto && typeof crypto.randomUUID === "function") return "cod_" + crypto.randomUUID().replace(/-/g, ""); } catch (e) {}
    return "cod_" + Date.now().toString(36) + Math.random().toString(36).slice(2, 14);
  }

  function packTotal() {
    var base = PACKS[state.qty].price;
    if (state.discount) base = Math.round(base * 0.85);
    return base;
  }
  function orderTotal() {
    return packTotal() + (state.addon ? ADDON_PRICE : 0) + (state.encomienda ? ENCOMIENDA_FEE : 0);
  }

  /* ---------- modal ---------- */
  var overlay = $("#lp-modal-overlay");
  var modal = $("#lp-modal");

  function showState(id) {
    $all(".lp-state", modal).forEach(function (el) { el.classList.toggle("lp-active", el.id === id); });
    modal.scrollTop = 0;
  }
  function openModal(qty) {
    if (qty) selectQty(qty);
    if (!state.idempotencyKey) state.idempotencyKey = codIdempotencyKey();
    if (!state.formStartedAt) state.formStartedAt = Date.now();
    showState("lp-state-form");
    overlay.classList.add("lp-open");
    document.body.style.overflow = "hidden";
    syncSummary();
    track("cod_open");
  }
  function closeModal() {
    overlay.classList.remove("lp-open");
    document.body.style.overflow = "";
    if (!state.submitted) maybeExitIntent();
  }
  $all("[data-open-modal]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var qty = btn.getAttribute("data-qty");
      openModal(qty ? parseInt(qty, 10) : null);
    });
  });
  $("#lp-modal-close").addEventListener("click", closeModal);
  overlay.addEventListener("click", function (e) { if (e.target === overlay) closeModal(); });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape" && overlay.classList.contains("lp-open")) closeModal(); });

  /* ---------- qty + variante ---------- */
  function selectQty(qty) {
    state.qty = qty;
    $all("[data-pack-qty]").forEach(function (btn) {
      btn.setAttribute("aria-pressed", String(parseInt(btn.getAttribute("data-pack-qty"), 10) === qty));
    });
    syncSummary();
  }
  $all("[data-pack-qty]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      selectQty(parseInt(btn.getAttribute("data-pack-qty"), 10));
      if (btn.hasAttribute("data-open-after")) openModal();
    });
  });
  $all("[data-variant]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      state.variant = btn.getAttribute("data-variant");
      $all("[data-variant]").forEach(function (b) { b.setAttribute("aria-pressed", String(b === btn)); });
    });
  });

  /* ---------- ciudad / encomienda ---------- */
  var citySel = $("#lp-f-ciudad");
  var locField = $("#lp-field-localidad");
  function syncCity() {
    state.encomienda = citySel.value === "Otra ciudad";
    if (locField) locField.style.display = state.encomienda ? "" : "none";
    syncSummary();
  }
  citySel.addEventListener("change", syncCity);

  function syncSummary() {
    var p = PACKS[state.qty];
    $("#lp-summary-qty").textContent = state.qty === 1 ? "Pack Respira Libre · 30 noches" : state.qty + " packs · " + state.qty * 30 + " noches";
    $("#lp-summary-price").textContent = packTotal() + " Bs";
    var save = p.save + (state.discount ? p.price - packTotal() : 0);
    $("#lp-summary-save").textContent = save > 0 ? "Ahorras " + save + " Bs" : "Pagas al recibir · Garantía 30 días";
    modal.classList.toggle("lp-discount-active", state.discount);
  }

  /* ---------- submit: crea la orden real en el Worker ---------- */
  var form = $("#lp-cod-form");
  form.addEventListener("input", function () { if (!state.started) { state.started = true; track("cod_start"); } });
  form.addEventListener("submit", function (e) {
    e.preventDefault();
    if (state.sending) return;
    var valid = true;
    var required = ["lp-f-nombre", "lp-f-celular", "lp-f-ciudad"];
    if (!state.encomienda) required.push("lp-f-direccion");
    else required.push("lp-f-localidad");
    required.forEach(function (id) {
      var f = $("#" + id);
      var ok = f && f.value.trim().length > 0;
      if (f) f.classList.toggle("lp-field-error", !ok);
      if (!ok) valid = false;
    });
    if (!valid) return;

    state.name = $("#lp-f-nombre").value.trim().split(/\s+/)[0];
    state.name = state.name.charAt(0).toUpperCase() + state.name.slice(1);
    track("cod_submit", { variant: state.variant, pack: state.qty });

    var goOto = function () {
      state.submitted = true;
      $all(".lp-oto-name").forEach(function (el) { el.textContent = state.name; });
      showState("lp-state-oto");
    };
    if (!ENDPOINT) { goOto(); return; }

    var btn = $(".lp-submit", $("#lp-state-form"));
    state.sending = true;
    if (btn) { btn.disabled = true; btn.textContent = "Enviando…"; }
    var payload = {
      action: "create",
      offerId: "tiras-lp-rinitis",
      idempotencyKey: state.idempotencyKey,
      formStartedAt: state.formStartedAt,
      website: $("#lp-f-website").value,
      items: [{ variantId: C.variants[state.variant] || C.variants["Negro · Menta"], quantity: state.qty }],
      shipping: state.encomienda ? "encomienda" : "cod",
      saving: PACKS[state.qty].save,
      discountPct: state.discount ? 15 : 0,
      discountCode: state.discount ? "RINITIS15" : "",
      encomiendaFee: ENCOMIENDA_FEE,
      customer: {
        name: $("#lp-f-nombre").value.trim(),
        phone: $("#lp-f-celular").value.trim(),
        city: state.encomienda ? "__otra__" : citySel.value,
        province: state.encomienda ? $("#lp-f-localidad").value.trim() : "",
        address: $("#lp-f-direccion").value.trim()
      },
      sid: sid(), ab: ab(), source: src(),
      product: "Tiras Nasales", variant: state.variant, pack: state.qty
    };
    fetch(ENDPOINT, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        state.sending = false;
        if (btn) { btn.disabled = false; btn.textContent = "Confirmar pedido — pago al recibir"; }
        if (res && res.ok) { state.orderId = res.orderId || ""; goOto(); }
        else { throw new Error((res && res.error) || "nok"); }
      })
      .catch(function () {
        state.sending = false;
        if (btn) { btn.disabled = false; btn.textContent = "Confirmar pedido — pago al recibir"; }
        alert("Hubo un problema al registrar tu pedido. Intenta de nuevo, por favor.");
      });
  });

  /* ---------- OTO / downsell: agregan a la orden ya creada ---------- */
  function addUpsell(variantId, kind, btn, fallbackState) {
    if (state.sending) return;
    if (!ENDPOINT || !state.orderId) { state.addon = kind; confirmOrder(); return; }
    state.sending = true;
    var orig = btn.textContent;
    btn.disabled = true; btn.textContent = "Agregando…";
    fetch(ENDPOINT, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ action: "upsell", orderId: state.orderId, variantId: variantId, price: ADDON_PRICE }) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        state.sending = false; btn.disabled = false; btn.textContent = orig;
        if (res && res.ok) { state.addon = kind; track("cod_upsell", { kind: kind }); confirmOrder(); }
        else { throw new Error("nok"); }
      })
      .catch(function () {
        state.sending = false; btn.disabled = false; btn.textContent = orig;
        state.addon = null;
        alert("No pudimos agregarlo, pero tu pedido principal ya está confirmado.");
        if (fallbackState) confirmOrder();
      });
  }
  $("#lp-oto-yes").addEventListener("click", function () { addUpsell(C.cintaVariant, "cinta", this, true); });
  $("#lp-oto-no").addEventListener("click", function () { track("cod_oto_no"); showState("lp-state-downsell"); });
  $("#lp-down-yes").addEventListener("click", function () { addUpsell(C.variants[state.variant] || C.variants["Negro · Menta"], "pack2", this, true); });
  $("#lp-down-no").addEventListener("click", function () { state.addon = null; confirmOrder(); });

  function confirmOrder() {
    $("#lp-confirm-name").textContent = state.name;
    var rows = "";
    if (state.discount) {
      rows += row(state.qty + " × Pack Tiras Nasales (" + state.variant + ")", PACKS[state.qty].price + " Bs");
      rows += row("Descuento 15% aplicado", "−" + (PACKS[state.qty].price - packTotal()) + " Bs");
    } else {
      rows += row(state.qty + " × Pack Tiras Nasales (" + state.variant + ")", packTotal() + " Bs");
    }
    if (state.addon === "cinta") rows += row("Cinta Bucal · 30 cintas", "+" + ADDON_PRICE + " Bs");
    if (state.addon === "pack2") rows += row("2º pack de tiras (mismo color)", "+" + ADDON_PRICE + " Bs");
    if (state.encomienda) rows += row("Envío por encomienda", "+" + ENCOMIENDA_FEE + " Bs");
    rows += '<div class="lp-row lp-total"><span>Total — pagas al recibir</span><span>' + orderTotal() + " Bs</span></div>";
    $("#lp-confirm-rows").innerHTML = rows;
    showState("lp-state-confirm");
  }
  function row(label, val) { return '<div class="lp-row"><span>' + label + "</span><span>" + val + "</span></div>"; }
  $("#lp-confirm-done").addEventListener("click", function () {
    overlay.classList.remove("lp-open");
    document.body.style.overflow = "";
  });

  /* ---------- sticky CTA ---------- */
  var sticky = $("#lp-sticky");
  var hero = $("#hero");
  var closing = $("#cierre");
  var stickyTick = false;
  function syncSticky() {
    var heroBottom = hero.getBoundingClientRect().bottom;
    var closeTop = closing.getBoundingClientRect().top;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    sticky.classList.toggle("lp-visible", heroBottom < 0 && closeTop >= vh * 0.75 && !overlay.classList.contains("lp-open"));
  }
  function onStickyScroll() {
    if (stickyTick) return;
    stickyTick = true;
    requestAnimationFrame(function () { stickyTick = false; syncSticky(); });
  }
  window.addEventListener("scroll", onStickyScroll, { passive: true });
  window.addEventListener("resize", onStickyScroll);
  new MutationObserver(syncSticky).observe(overlay, { attributes: true, attributeFilter: ["class"] });
  syncSticky();

  /* ---------- exit intent: 1 vez, recordado 30 días ---------- */
  var exitOverlay = $("#lp-exit-overlay");
  var exitTimerEl = $("#lp-exit-timer-num");
  var exitDeadline = null;
  var exitInterval = null;
  var EXIT_KEY = "bo_exit_lpr";
  function exitSeen() {
    try {
      var t = parseInt(localStorage.getItem(EXIT_KEY) || "0", 10);
      return t > 0 && Date.now() - t < 30 * 24 * 3600 * 1000;
    } catch (e) { return false; }
  }
  function markExitSeen() { try { localStorage.setItem(EXIT_KEY, String(Date.now())); } catch (e) {} }

  function maybeExitIntent() {
    if (state.exitShown || state.submitted || exitSeen()) return;
    state.exitShown = true;
    markExitSeen();
    exitOverlay.classList.add("lp-open");
    document.body.style.overflow = "hidden";
    exitDeadline = Date.now() + 10 * 60 * 1000;
    exitInterval = setInterval(tickExit, 250);
    tickExit();
    track("exit_intent");
  }
  function tickExit() {
    var ms = Math.max(0, exitDeadline - Date.now());
    var m = Math.floor(ms / 60000);
    var s = Math.floor((ms % 60000) / 1000);
    exitTimerEl.textContent = m + ":" + (s < 10 ? "0" : "") + s;
    if (ms <= 0) {
      clearInterval(exitInterval);
      state.discount = false;
      syncSummary();
      closeExit();
    }
  }
  function closeExit() {
    exitOverlay.classList.remove("lp-open");
    if (!overlay.classList.contains("lp-open")) document.body.style.overflow = "";
  }
  document.addEventListener("mouseout", function (e) {
    if (e.relatedTarget || e.clientY > 12) return;
    if (overlay.classList.contains("lp-open") || exitOverlay.classList.contains("lp-open")) return;
    maybeExitIntent();
  });
  $("#lp-exit-claim").addEventListener("click", function () {
    state.discount = true;
    track("exit_claim");
    closeExit();
    openModal();
  });
  $("#lp-exit-close").addEventListener("click", closeExit);
  exitOverlay.addEventListener("click", function (e) { if (e.target === exitOverlay) closeExit(); });

  /* ---------- reveals con fail-safe ---------- */
  function revealAll() { $all(".lp-reveal").forEach(function (el) { el.classList.add("lp-in"); }); }
  if ("IntersectionObserver" in window) {
    var ioFired = false;
    var ro = new IntersectionObserver(function (entries) {
      ioFired = true;
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add("lp-in"); ro.unobserve(en.target); } });
    }, { threshold: 0.12 });
    $all(".lp-reveal").forEach(function (el) { ro.observe(el); });
    setTimeout(function () { if (!ioFired) { ro.disconnect(); revealAll(); } }, 900);
  } else {
    revealAll();
  }

  /* ---------- init ---------- */
  selectQty(state.qty);
  syncCity();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bo-lp-tabique"] && !Shopify.designMode) return;
  try {
    
(function () {
  "use strict";
  function getCfg(){ try { return JSON.parse(document.getElementById('bo-lpt-cfg').textContent); } catch(e){ return { endpoint:'', variants:{}, stickers:0 }; } }
  var C = getCfg();
  var PRICES = { 'kit': { total: 300, saving: 0, extraStickers: 0, label: 'Kit completo' }, 'kit-st': { total: 400, saving: 60, extraStickers: 1, label: 'Kit + 30 pares extra' } };
  function sid(){ try{ var k='bo_sid', s=sessionStorage.getItem(k); if(!s){ s='s'+Date.now().toString(36)+Math.random().toString(36).slice(2,8); sessionStorage.setItem(k,s);} return s; }catch(e){ return ''; } }
  function codIdempotencyKey(){ try{ if(crypto && typeof crypto.randomUUID==='function') return 'cod_'+crypto.randomUUID().replace(/-/g,''); }catch(e){} return 'cod_'+Date.now().toString(36)+Math.random().toString(36).slice(2,14); }
  function ab(){ try{ var k='bo_ab', a=localStorage.getItem(k); if(!a){ a=Math.random()<0.5?'A':'B'; localStorage.setItem(k,a);} return a; }catch(e){ return ''; } }
  function src(){ try{ var k='bo_src', s=sessionStorage.getItem(k); if(s) return s; var p=new URLSearchParams(location.search), v=p.get('utm_source')||''; if(!v){ var r=document.referrer||''; if(r){ try{ v=new URL(r).hostname.replace(/^www\./,''); }catch(e){} } if(!v) v='direct'; } sessionStorage.setItem(k,v); return v; }catch(e){ return ''; } }
  function track(ev, extra){ try{ if(!C.endpoint) return; var d=Object.assign({ id:'e'+Date.now().toString(36)+Math.random().toString(36).slice(2,8), event:ev, sid:sid(), ab:ab(), source:src(), product:'Dilatador Nasal Magnético' }, extra||{}); var u=C.endpoint.replace(/\/+$/,'')+'/track'; if(navigator.sendBeacon){ navigator.sendBeacon(u, JSON.stringify(d)); } else { fetch(u,{method:'POST',headers:{'Content-Type':'text/plain'},body:JSON.stringify(d),keepalive:true}).catch(function(){}); } }catch(e){} }

  var reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }); }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    reveals.forEach(function (el) { io.observe(el); });
  } else { reveals.forEach(function (el) { el.classList.add('in'); }); }

  var sticky = document.getElementById('stickyCta');
  var hero = document.querySelector("section[data-screen-label^='01']");
  if (sticky && hero && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) sticky.classList.remove('show'); else sticky.classList.add('show'); }); }, { threshold: 0 }).observe(hero);
  }

  var modal = document.getElementById('formModal'), mbody = document.getElementById('modalBody'), closeBtn = document.getElementById('closeModal');
  var lastFocus = null, started = false, originalBody = mbody ? mbody.innerHTML : '', orderIdempotencyKey = '', formStartedAt = 0, orderDone = false;
  function openModal(){ if(!orderIdempotencyKey) orderIdempotencyKey=codIdempotencyKey(); if(!formStartedAt) formStartedAt=Date.now(); lastFocus=document.activeElement; modal.classList.add('open'); modal.setAttribute('aria-hidden','false'); document.body.style.overflow='hidden'; var f=modal.querySelector('input,select,textarea,button'); if(f) setTimeout(function(){ f.focus(); },60); track('cod_open'); }
  function closeModal(){ modal.classList.remove('open'); modal.setAttribute('aria-hidden','true'); document.body.style.overflow=''; if(mbody && mbody.querySelector('.thanks')){ mbody.innerHTML=originalBody; started=false; bindForm(); } if(lastFocus) lastFocus.focus(); if(!orderDone) maybeExitIntent(); }
  document.querySelectorAll('[data-open-form]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); openModal(); }); });
  if (closeBtn) closeBtn.addEventListener('click', closeModal);
  if (modal) modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal && modal.classList.contains('open')) closeModal(); });

  function esc(s){ return String(s).replace(/[&<>"']/g, function (c) { return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c]; }); }
  function showThanks(data){
    orderDone=true;
    var nombre=(data.get('nombre')||'').toString().trim(), first=nombre.split(' ')[0]||'Listo';
    var variante=(data.get('variante')||'Negro').toString(), kitKey=(data.get('cantidad')||'kit').toString();
    var kit=PRICES[kitKey]||PRICES['kit'];
    mbody.innerHTML='<div class="thanks"><div class="big-check">✓</div><h3 style="font-family:var(--font-display);font-weight:800;font-size:22px;margin-bottom:8px;color:var(--fg);">¡Pedido confirmado, '+esc(first)+'!</h3><p class="body" style="margin-bottom:18px;">Apartamos tu <strong>'+esc(kit.label)+'</strong> en color <strong>'+esc(variante)+'</strong>. Te escribimos por WhatsApp para coordinar la entrega. <strong>Pagas cuando lo recibas.</strong></p><div class="mtrust" style="justify-content:center;"><span><span class="d"></span> Pagas al recibir</span><span><span class="d"></span> Envío a toda Bolivia</span><span><span class="d"></span> Garantía 30 días</span></div></div>';
  }
  function bindForm(){
    var form=document.getElementById('codForm'); if(!form) return;
    var cant=form.querySelector('#f-cant'), sum=document.getElementById('sumPrice');
    if(cant && sum){ cant.addEventListener('change', function(){ var k=PRICES[cant.value]||PRICES['kit']; sum.textContent=k.total+' Bs'; }); }
    form.addEventListener('input', function(){ if(!started){ started=true; track('cod_start'); } });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!form.checkValidity()) { form.reportValidity(); return; }
      var data=new FormData(form);
      var variante=(data.get('variante')||'Negro').toString();
      var kitKey=(data.get('cantidad')||'kit').toString();
      var kit=PRICES[kitKey]||PRICES['kit'];
      var vid=C.variants[variante]||C.variants['Negro'];
      var items=[{ variantId:vid, quantity:1 }];
      if(kit.extraStickers>0){ items.push({ variantId:C.stickers, quantity:kit.extraStickers }); }
      var payload={ action:'create', offerId:'dilatador-pdp', idempotencyKey:orderIdempotencyKey, formStartedAt:formStartedAt, website:(data.get('website')||'').toString(), items:items, shipping:'cod', saving:kit.saving, discountPct:0, discountCode:'', customer:{ name:(data.get('nombre')||'').toString().trim(), phone:(data.get('telefono')||'').toString(), city:(data.get('ciudad')||'').toString(), address:(data.get('direccion')||'').toString() }, sid:sid(), ab:ab(), source:src(), product:'Dilatador Nasal Magnético', variant:variante, pack:kitKey };
      var btn=form.querySelector('.submit'); if(btn){ btn.disabled=true; btn.textContent='Enviando...'; }
      track('cod_submit',{ variant:variante, pack:kitKey });
      if(!C.endpoint){ showThanks(data); return; }
      fetch(C.endpoint,{ method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify(payload) })
        .then(function(r){ if(!r.ok) throw new Error('fail'); return r.json(); })
        .then(function(res){ if(res && res.ok){ showThanks(data); } else { throw new Error('nok'); } })
        .catch(function(){ if(btn){ btn.disabled=false; btn.textContent='Confirmar pedido — pago al recibir'; } alert('Hubo un problema. Intenta de nuevo o escríbenos por WhatsApp.'); });
    });
  }
  bindForm();

  var exitShown=false;
  var exitOv=document.getElementById('boExitOv');
  function exitSeen(){ try{ var t=parseInt(localStorage.getItem('bo_exit_lpt')||'0',10); return t>0 && (Date.now()-t) < 30*24*3600*1000; }catch(e){ return false; } }
  function markExitSeen(){ try{ localStorage.setItem('bo_exit_lpt', String(Date.now())); }catch(e){} }
  function maybeExitIntent(){ if(exitShown||orderDone||exitSeen()||!exitOv) return; exitShown=true; markExitSeen(); exitOv.classList.add('open'); document.body.style.overflow='hidden'; track('exit_intent'); }
  function closeExit(){ if(!exitOv) return; exitOv.classList.remove('open'); if(!modal.classList.contains('open')) document.body.style.overflow=''; }
  if(exitOv){
    document.addEventListener('mouseout', function(e){ if(e.relatedTarget||e.clientY>12) return; if(modal.classList.contains('open')||exitOv.classList.contains('open')) return; maybeExitIntent(); });
    document.getElementById('boExitClaim').addEventListener('click', function(){ track('exit_claim',{ meta:{ to:'whatsapp' } }); closeExit(); });
    document.getElementById('boExitClose').addEventListener('click', closeExit);
    exitOv.addEventListener('click', function(e){ if(e.target===exitOv) closeExit(); });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bo-lpd-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function getCod() {
      try {
        var el = document.getElementById('bo-lpd-cod');
        return el ? JSON.parse(el.textContent) : null;
      } catch (e) { return null; }
    }
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-bo-lp-cta]');
      if (!btn) return;
      e.preventDefault();
      var d = getCod();
      if (!d) return;
      document.dispatchEvent(new CustomEvent('bo:open-cod', {
        detail: {
          variantId: d.variantId, qty: d.qty || 1, unitPrice: d.unitPrice || 0,
          saving: 0, savingsByQty: {}, title: d.title || '', variantTitle: d.variantTitle || '',
          image: d.image || '', moneyFormat: d.moneyFormat || ''
        }
      }));
    });
    var sticky = document.querySelector('[data-bo-lpd-sticky]');
    var anchor = document.querySelector('.bo-lpd-hero .bo-lpd-btn');
    if (sticky && anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        en.forEach(function (x) { sticky.hidden = x.isIntersecting; });
      }, { threshold: 0 }).observe(anchor);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bo-pdp-audios"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var cards = document.querySelectorAll('.bo-aud__card');
    if (!cards.length) return;
    function fmt(s) {
      if (!isFinite(s)) return '';
      var m = Math.floor(s / 60), r = Math.floor(s % 60);
      return m + ':' + (r < 10 ? '0' : '') + r;
    }
    cards.forEach(function (card) {
      var audio = card.querySelector('[data-bo-aud]');
      var btn = card.querySelector('[data-bo-aud-play]');
      var fill = card.querySelector('[data-bo-aud-fill]');
      var bar = card.querySelector('[data-bo-aud-bar]');
      var time = card.querySelector('[data-bo-aud-time]');
      if (!audio || !btn) return;
      var base = time ? time.textContent : '';
      btn.addEventListener('click', function () {
        if (audio.paused) {
          document.querySelectorAll('.bo-aud__card.is-playing [data-bo-aud]').forEach(function (a) {
            if (a !== audio) { a.pause(); }
          });
          audio.play();
        } else {
          audio.pause();
        }
      });
      audio.addEventListener('play', function () { card.classList.add('is-playing'); });
      audio.addEventListener('pause', function () { card.classList.remove('is-playing'); });
      audio.addEventListener('ended', function () {
        card.classList.remove('is-playing');
        if (fill) fill.style.width = '0%';
        if (time) time.textContent = base;
      });
      audio.addEventListener('timeupdate', function () {
        if (fill && audio.duration) fill.style.width = (100 * audio.currentTime / audio.duration) + '%';
        if (time && audio.duration) time.textContent = fmt(audio.duration - audio.currentTime);
      });
      if (bar) {
        bar.addEventListener('click', function (e) {
          if (!audio.duration) return;
          var r = bar.getBoundingClientRect();
          audio.currentTime = audio.duration * Math.min(1, Math.max(0, (e.clientX - r.left) / r.width));
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bo-pdp-cta-v2"] && !Shopify.designMode) return;
  try {
    
    document.querySelectorAll('[data-bo-cta-buy]').forEach(function (el) {
      if (el.__boCtaBound) return;
      el.__boCtaBound = true;
      el.addEventListener('click', function (e) {
        var atc = document.querySelector('[data-bo-buybox] [data-bo-atc]');
        if (atc) { e.preventDefault(); atc.click(); }
        // Si no hay buy box en la página, el href (#comprar) actúa como respaldo.
      });
    });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bo-pdp-videos"] && !Shopify.designMode) return;
  try {
    
  (function(){
    document.querySelectorAll('.bo-pv').forEach(function(root){
      var cards = Array.prototype.slice.call(root.querySelectorAll('[data-pv-card]'));
      function reset(card){
        var v = card.querySelector('[data-pv-video]');
        card.classList.remove('is-playing');
        if (v && !v.paused) { v.pause(); }
        var t = card.querySelector('[data-pv-toggle]');
        if (t) { t.setAttribute('aria-label','Reproducir video'); }
      }
      function ensureSrc(v){
        if (v.dataset.loaded) return;
        var s = v.querySelector('source[data-src]');
        if (s){ s.src = s.getAttribute('data-src'); v.load(); }
        v.dataset.loaded = '1';
      }
      cards.forEach(function(card){
        var video = card.querySelector('[data-pv-video]');
        var toggle = card.querySelector('[data-pv-toggle]');
        if(!video || !toggle) return;
        toggle.addEventListener('click', function(){
          if (video.paused){
            cards.forEach(function(c){ if(c!==card) reset(c); });
            ensureSrc(video);
            video.muted = false;
            var p = video.play();
            if (p && p.catch){ p.catch(function(){ video.muted = true; video.play(); }); }
          } else {
            video.pause();
          }
        });
        video.addEventListener('play', function(){ card.classList.add('is-playing'); toggle.setAttribute('aria-label','Pausar video'); });
        video.addEventListener('pause', function(){ card.classList.remove('is-playing'); toggle.setAttribute('aria-label','Reproducir video'); });
        video.addEventListener('ended', function(){ card.classList.remove('is-playing'); video.currentTime = 0; toggle.setAttribute('aria-label','Reproducir video'); });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bo-quiz-popup"] && !Shopify.designMode) return;
  try {
    
(function () {
  "use strict";
  var root = document.querySelector('[data-bo-qz]');
  if (!root) return;
  var body = root.querySelector('[data-bo-qz-body]');
  var dots = root.querySelectorAll('.bo-qz__dot');
  function cfg(){ try { return JSON.parse(document.getElementById('bo-qz-cfg').textContent); } catch(e){ return { endpoint:'' }; } }
  var C = cfg();
  function sid(){ try{ var k='bo_sid', s=sessionStorage.getItem(k); if(!s){ s='s'+Date.now().toString(36)+Math.random().toString(36).slice(2,8); sessionStorage.setItem(k,s);} return s; }catch(e){ return ''; } }
  function track(ev, extra){ try{ if(!C.endpoint) return; var d=Object.assign({ id:'e'+Date.now().toString(36)+Math.random().toString(36).slice(2,8), event:ev, sid:sid(), source:'quiz-popup', product:'Recomendador' }, extra||{}); var u=C.endpoint.replace(/\/+$/,'')+'/track'; if(navigator.sendBeacon){ navigator.sendBeacon(u, JSON.stringify(d)); } else { fetch(u,{method:'POST',headers:{'Content-Type':'text/plain'},body:JSON.stringify(d),keepalive:true}).catch(function(){}); } }catch(e){} }
  function esc(s){ return String(s).replace(/[&<>"']/g, function (c) { return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c]; }); }

  var ICONS = {
    moon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.5 13.5A8.5 8.5 0 1 1 10.5 3.5a7 7 0 0 0 10 10Z"/></svg>',
    gym: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M7 8v8M17 8v8M3.5 10v4M20.5 10v4M7 12h10"/></svg>',
    waves: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M3.5 12h1.5M7.5 8.5v7M11.5 5.5v13M15.5 8.5v7M19.5 10.5v3"/></svg>',
    drop: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3.5s5.5 6.6 5.5 10.2a5.5 5.5 0 1 1-11 0C6.5 10.1 12 3.5 12 3.5Z"/></svg>',
    nose: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M13.5 3.5c0 4.5 2.5 6.3 2.5 9.3a4.6 4.6 0 0 1-8.2 2.9"/><path d="M9.4 18.6h.01M14 18.6h.01" stroke-width="2.4"/></svg>',
    mouth: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4.5 12c2.5-3.2 5-4.5 7.5-4.5s5 1.3 7.5 4.5c-2.5 3.2-5 4.5-7.5 4.5S7 15.2 4.5 12Z"/><path d="M4.5 12h15"/></svg>',
    target: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><circle cx="12" cy="12" r="8"/><circle cx="12" cy="12" r="3"/></svg>',
    minus: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 12h12"/></svg>'
  };
  var QUESTIONS = {
    q1: { step: 1, title: '¿Para qué lo necesitas principalmente?', opts: [
      { label: 'Dormir mejor / descansar', ic: 'moon', next: 'q2', ctx: 'dormir' },
      { label: 'Deporte / entrenar', ic: 'gym', next: 'q3', ctx: 'deporte' },
      { label: 'Ronquidos (míos o de mi pareja)', ic: 'waves', next: 'q2', ctx: 'ronquido' },
      { label: 'Nariz tapada / rinitis', ic: 'drop', next: 'q2', ctx: 'rinitis' },
      { label: 'Tabique desviado', ic: 'nose', result: 'r_tabique' }
    ]},
    q2: { step: 2, title: '¿Duermes con la boca abierta o amaneces con la boca seca?', opts: [
      { label: 'Sí, casi siempre', ic: 'mouth', resultByCtx: { dormir: 'r_combo_dormir', ronquido: 'r_combo_ronquido', rinitis: 'r_combo_rinitis' } },
      { label: 'No / no sé', ic: 'minus', resultByCtx: { dormir: 'r_tiras_dormir', ronquido: 'r_tiras_ronquido', rinitis: 'r_tiras_rinitis' } }
    ]},
    q3: { step: 2, title: '¿Practicas deportes de contacto (boxeo, MMA)?', opts: [
      { label: 'Sí', ic: 'target', result: 'r_tiras_contacto' },
      { label: 'No', ic: 'minus', next: 'q4' }
    ]},
    q4: { step: 3, title: '¿Sudas mucho, tienes piel grasa o prefieres algo reutilizable?', opts: [
      { label: 'Sí', ic: 'drop', result: 'r_dilatador' },
      { label: 'No', ic: 'minus', result: 'r_tiras_deporte' }
    ]}
  };
  var IMG = {
    tiras: 'https://cdn.shopify.com/s/files/1/0583/2966/1510/files/tiras-3variantes-paga-al-recibir.jpg',
    dilatador: 'https://cdn.shopify.com/s/files/1/0583/2966/1510/files/bo-dl-hero-externo.jpg',
    combo: 'https://cdn.shopify.com/s/files/1/0583/2966/1510/files/69_dc821760-fec8-4088-92bb-00dcffcf9203.jpg'
  };
  var URLS = { tiras: '/products/tiras-nasales?ref=quiz', dilatador: '/products/dilatador-nasal-magnetico?ref=quiz', combo: '/products/combo?ref=quiz' };
  var RESULTS = {
    r_tabique: { key: 'dilatador', name: 'Dilatador Nasal Magnético', price: '300 Bs · kit con las 4 tallas', why: 'Para tabique desviado es el indicado: abre la fosa estrecha 60 a 80% desde afuera (el doble que una tira) y el kit trae las 4 tallas. 100% externo: nada entra en la nariz.', note: 'Honesto: no corrige el tabique ni reemplaza al especialista; te ayuda a respirar mejor mientras tanto.' },
    r_dilatador: { key: 'dilatador', name: 'Dilatador Nasal Magnético', price: '300 Bs · kit con las 4 tallas', why: 'El sudor y la piel grasa despegan cualquier adhesivo. La banda magnética no depende del adhesivo, se reutiliza indefinidamente y abre 60 a 80%. Solo se reponen los stickers.', note: 'Para deportes de contacto, ese día usa tiras: la banda se puede salir con golpes.' },
    r_tiras_contacto: { key: 'tiras', name: 'Tiras Nasales · Negro Menta', price: '180 Bs · 30 tiras (1 mes)', why: 'En deportes de contacto la banda magnética se puede salir con los golpes: para ti son las tiras. La Negro · Menta tiene la máxima adherencia (14-24 h) y resiste el sudor.', note: 'Ponla sobre piel limpia y seca, presionando 30 segundos.' },
    r_tiras_deporte: { key: 'tiras', name: 'Tiras Nasales · Negro Menta', price: '180 Bs · 30 tiras (1 mes)', why: 'Para entrenar, la Negro · Menta es la más usada: máxima adherencia (14-24 h), resiste el sudor y abre tu nariz 30-40% al instante, sin curva de aprendizaje.', note: 'Si después quieres más apertura o algo reutilizable, el dilatador es el upgrade natural.' },
    r_tiras_dormir: { key: 'tiras', name: 'Tiras Nasales · Piel Lavanda', price: '180 Bs · 30 tiras (1 mes)', why: 'Para dormir, la Piel · Lavanda es la favorita: suave con la piel y con esencia relajante. Abre tu nariz 30-40% en 1 a 3 segundos.', note: 'Si tu boca se abre sola de noche, considera sumar la cinta bucal después.' },
    r_tiras_ronquido: { key: 'tiras', name: 'Tiras Nasales', price: '180 Bs · 30 tiras (1 mes)', why: 'Si tu boca se queda cerrada al dormir, tu ronquido probablemente nace en la nariz: la tira la abre 30-40% desde la primera noche.', note: 'Honesto: si el ronquido viene de la garganta, la nariz sola no lo arregla del todo.' },
    r_tiras_rinitis: { key: 'tiras', name: 'Tiras Nasales · Negro Menta', price: '180 Bs · 30 tiras (1 mes)', why: 'Para la nariz tapada, la tira abre mecánicamente 30-40%, sin gotas y sin rebote. Si tu piel es sensible, elige la Transparente sin esencia.', note: 'Complementa lo que te indique tu médico; no lo reemplaza.' },
    r_combo_dormir: { key: 'combo', name: 'Combo Cinta + Tiras', price: '300 Bs (antes 360)', why: 'Tu caso pide el dúo: la tira abre la nariz y la cinta bucal mantiene la boca cerrada. Duermes respirando por la nariz y amaneces sin la boca seca.', note: 'La cinta es transpirable: permite que entre aire si lo necesitas.' },
    r_combo_ronquido: { key: 'combo', name: 'Combo Cinta + Tiras', price: '300 Bs (antes 360)', why: 'El ronquido suele tener dos causas a la vez: nariz cerrada y boca abierta. El combo ataca las dos. Es lo que más recomendamos para roncadores.', note: 'Honesto: reduce el ronquido nasal y bucal; si viene de la garganta, puede no bastar.' },
    r_combo_rinitis: { key: 'combo', name: 'Combo Cinta + Tiras', price: '300 Bs (antes 360)', why: 'Para rinitis con boca abierta: la tira abre las fosas y la cinta te mantiene respirando por la nariz toda la noche.', note: 'Complementa lo que te indique tu médico; no lo reemplaza.' }
  };

  var history = [], quizStarted = false, lastFocus = null;
  function setStep(n){ dots.forEach(function(d,i){ d.classList.toggle('on', i < n); }); }
  function renderQuestion(id, ctx){
    var q = QUESTIONS[id]; if(!q) return;
    if(!quizStarted){ quizStarted = true; track('quiz_start'); }
    setStep(q.step);
    var html = '<p class="bo-qz__q">'+esc(q.title)+'</p><div class="bo-qz__opts">';
    q.opts.forEach(function(o, i){ html += '<button type="button" class="bo-qz__opt" data-i="'+i+'"><span class="bo-qz__ic">'+(ICONS[o.ic]||'')+'</span><span>'+esc(o.label)+'</span></button>'; });
    html += '</div>';
    if(history.length){ html += '<button type="button" class="bo-qz__back" data-qz-back>← Volver</button>'; }
    body.innerHTML = html;
    body.querySelectorAll('.bo-qz__opt').forEach(function(btn){
      btn.addEventListener('click', function(){
        var o = q.opts[parseInt(btn.getAttribute('data-i'),10)];
        var nextCtx = o.ctx || ctx;
        history.push({ id: id, ctx: ctx });
        if(o.result){ renderResult(o.result); }
        else if(o.resultByCtx){ renderResult(o.resultByCtx[nextCtx] || 'r_tiras_dormir'); }
        else if(o.next){ renderQuestion(o.next, nextCtx); }
      });
    });
    var back = body.querySelector('[data-qz-back]');
    if(back){ back.addEventListener('click', function(){ var prev = history.pop(); if(prev){ renderQuestion(prev.id, prev.ctx); history.pop(); } }); }
  }
  function renderResult(rid){
    var r = RESULTS[rid]; if(!r) return;
    setStep(3);
    track('quiz_result', { meta: { result: rid } });
    body.innerHTML = '<div class="bo-qz__res">'
      + '<p class="bo-qz__res-k">Tu recomendación</p>'
      + '<img src="'+esc(IMG[r.key])+'" alt="'+esc(r.name)+'" loading="lazy">'
      + '<h4>'+esc(r.name)+'</h4>'
      + '<p class="bo-qz__res-price">'+esc(r.price)+'</p>'
      + '<div class="bo-qz__res-why">'+esc(r.why)+'</div>'
      + '<p class="bo-qz__res-note">'+esc(r.note)+' Pagas al recibir y tienes garantía de 30 días.</p>'
      + '<a class="bo-qz__res-cta" href="'+esc(URLS[r.key])+'">Ver y pedir — pago al recibir</a>'
      + '<div class="bo-qz__res-links">'
      + '<button type="button" data-qz-restart>Volver a empezar</button>'
      + '<a href="/pages/tiras-o-dilatador">Comparar los 3</a>'
      + '</div></div>';
    var rs = body.querySelector('[data-qz-restart]');
    if(rs){ rs.addEventListener('click', function(){ history = []; renderQuestion('q1', ''); }); }
  }
  function openQz(){
    lastFocus = document.activeElement;
    history = []; renderQuestion('q1', '');
    root.hidden = false; document.body.style.overflow = 'hidden';
    track('quiz_open');
    var x = root.querySelector('.bo-qz__x'); if(x) setTimeout(function(){ x.focus(); }, 60);
  }
  function closeQz(){ root.hidden = true; document.body.style.overflow = ''; if(lastFocus && lastFocus.focus) lastFocus.focus(); }
  document.addEventListener('click', function(e){
    var opener = e.target.closest ? e.target.closest('[data-bo-quiz-open]') : null;
    if(opener){ e.preventDefault(); openQz(); return; }
    var closer = e.target.closest ? e.target.closest('[data-bo-qz-close]') : null;
    if(closer && !root.hidden){ closeQz(); }
  });
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && !root.hidden) closeQz(); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bo-segments"] && !Shopify.designMode) return;
  try {
    
    (function () {
      function setupCarousel(root) {
        var track = root.querySelector('.bo-seg__track');
        var nav = root.querySelector('.bo-seg__nav');
        if (!track || !nav || track.dataset.boSegReady === '1') return;
        track.dataset.boSegReady = '1';
        var prev = nav.querySelector('[data-dir="prev"]');
        var next = nav.querySelector('[data-dir="next"]');

        function step() {
          var card = track.querySelector('.bo-seg__card');
          if (!card) return track.clientWidth;
          var gap = parseFloat(getComputedStyle(track).columnGap || '16') || 16;
          return card.getBoundingClientRect().width + gap;
        }
        function update() {
          var overflow = track.scrollWidth - track.clientWidth > 2;
          if (overflow) { nav.removeAttribute('hidden'); } else { nav.setAttribute('hidden', ''); }
          var max = track.scrollWidth - track.clientWidth - 2;
          if (prev) prev.disabled = track.scrollLeft <= 2;
          if (next) next.disabled = track.scrollLeft >= max;
        }
        if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
        if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
        track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
        window.addEventListener('resize', function () { window.requestAnimationFrame(update); });
        update();
      }

      function setupModals(root) {
        root.querySelectorAll('.bo-seg__open').forEach(function (btn) {
          if (btn.dataset.boSegBound === '1') return;
          btn.dataset.boSegBound = '1';
          btn.addEventListener('click', function () {
            var dlg = document.getElementById(btn.getAttribute('data-bo-seg-open'));
            if (dlg && typeof dlg.showModal === 'function') {
              dlg.showModal();
              document.documentElement.classList.add('bo-seg-modal-lock');
            }
          });
        });
        root.querySelectorAll('.bo-seg__modal').forEach(function (dlg) {
          if (dlg.dataset.boSegBound === '1') return;
          dlg.dataset.boSegBound = '1';
          var closeBtn = dlg.querySelector('[data-bo-seg-close]');
          if (closeBtn) closeBtn.addEventListener('click', function () { dlg.close(); });
          dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
          dlg.addEventListener('close', function () { document.documentElement.classList.remove('bo-seg-modal-lock'); });
        });
      }

      function init() {
        document.querySelectorAll('.bo-seg').forEach(function (el) { setupCarousel(el); setupModals(el); });
      }
      if (document.readyState !== 'loading') { init(); } else { document.addEventListener('DOMContentLoaded', init); }
      document.addEventListener('shopify:section:load', function (e) {
        var el = e.target && e.target.querySelector ? e.target.querySelector('.bo-seg') : null;
        if (el) { var t = el.querySelector('.bo-seg__track'); if (t) { t.dataset.boSegReady = ''; } setupCarousel(el); setupModals(el); }
      });
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bo-sueno-pdp"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  var root = document.getElementById('bo-snpdp');
  if (!root) return;
  var endpoint = root.getAttribute('data-endpoint') || '';
  var source = root.getAttribute('data-source') || 'alpha-sueno-pdp';
  var modoVenta = root.getAttribute('data-modo-venta') === '1';
  var LS_KEY = 'bo_snw_joined_v1';

  function normalizePhone(raw) {
    var d = String(raw || '').replace(/\D/g, '');
    if (d.length === 11 && d.indexOf('591') === 0) d = d.slice(3);
    if (d.length === 8 && (d[0] === '6' || d[0] === '7')) return d;
    return null;
  }

  function markDone(form, already, focus) {
    form.classList.add('is-done');
    var ok = form.querySelector('[data-clw-ok]');
    if (ok) {
      if (already) {
        var t = ok.querySelector('strong');
        if (t) t.textContent = 'Ya estabas en la lista';
      }
      ok.hidden = false;
      if (focus) {
        ok.setAttribute('tabindex', '-1');
        ok.focus({ preventScroll: true });
      }
    }
  }

  function setErr(form, msg) {
    var err = form.querySelector('[data-clw-err]');
    if (!err) return;
    if (msg) { err.textContent = msg; err.hidden = false; }
    else { err.textContent = ''; err.hidden = true; }
  }

  var joined = false;
  if (!modoVenta) {
    var forms = root.querySelectorAll('[data-clw-form]');
    try { joined = !!localStorage.getItem(LS_KEY); } catch (e) {}
    if (joined) forms.forEach(function (f) { markDone(f, true, false); });

    forms.forEach(function (form) {
      form.addEventListener('submit', function (ev) {
        ev.preventDefault();
        setErr(form, '');
        var nameIn = form.querySelector('input[name="name"]');
        var phoneIn = form.querySelector('input[name="phone"]');
        var btn = form.querySelector('[data-clw-btn]');
        var name = (nameIn.value || '').trim();
        var phone = normalizePhone(phoneIn.value);

        nameIn.setAttribute('aria-invalid', name.length < 2 ? 'true' : 'false');
        phoneIn.setAttribute('aria-invalid', phone ? 'false' : 'true');

        if (name.length < 2) { setErr(form, 'Escribe tu nombre para poder avisarte.'); nameIn.focus(); return; }
        if (!phone) { setErr(form, 'Revisa tu celular: son 8 dígitos y empieza en 6 o 7.'); phoneIn.focus(); return; }
        if (!endpoint) { setErr(form, 'El registro no está disponible en este momento. Escríbenos por WhatsApp.'); return; }

        btn.disabled = true;
        var label = btn.querySelector('[data-clw-btn-label]');
        var prev = label ? label.textContent : '';
        if (label) label.textContent = 'Registrando…';

        fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ name: name, phone: phone, source: source })
        })
          .then(function (r) { return r.json().catch(function () { return {}; }); })
          .then(function (data) {
            if (data && data.ok) {
              try { localStorage.setItem(LS_KEY, '1'); } catch (e) {}
              forms.forEach(function (f) { markDone(f, f !== form ? true : !!data.already, f === form); });
              var st = root.querySelector('[data-sticky]');
              if (st) st.hidden = true;
              joined = true;
              if (!data.already && typeof window.boTrack === 'function') {
                window.boTrack('Lead', { content_name: 'Alpha Sueno Waitlist', content_category: 'preventa-pdp' });
              }
            } else if (data && data.error === 'phone') {
              setErr(form, 'Revisa tu celular: son 8 dígitos y empieza en 6 o 7.');
            } else {
              setErr(form, 'No pudimos registrarte. Intenta de nuevo en unos segundos.');
            }
          })
          .catch(function () {
            setErr(form, 'Sin conexión. Revisa tu internet e intenta de nuevo.');
          })
          .then(function () {
            btn.disabled = false;
            if (label) label.textContent = prev;
          });
      });
    });
  }

  function initCarousel(carousel, dotsWrap, slideSel) {
    if (!carousel || !dotsWrap) return;
    var slides = carousel.querySelectorAll(slideSel);
    if (!slides.length) return;
    slides.forEach(function () { dotsWrap.appendChild(document.createElement('span')); });
    var dots = dotsWrap.querySelectorAll('span');
    var syncDots = function () {
      var mid = carousel.scrollLeft + carousel.clientWidth / 2;
      var idx = 0;
      slides.forEach(function (s, i) { if (s.offsetLeft <= mid) idx = i; });
      dots.forEach(function (d, i) { d.classList.toggle('is-on', i === idx); });
    };
    carousel.addEventListener('scroll', function () {
      window.requestAnimationFrame(syncDots);
    }, { passive: true });
    syncDots();
  }
  initCarousel(root.querySelector('[data-gallery]'), root.querySelector('[data-dots]'), '.bo-snpdp__slide');
  initCarousel(root.querySelector('[data-gallery2]'), root.querySelector('[data-dots2]'), '.bo-snpdp__foto');

  /* NUEVO: flechas de la galería principal (desktop) */
  (function () {
    var gallery = root.querySelector('[data-gallery]');
    var prev = root.querySelector('[data-gprev]');
    var next = root.querySelector('[data-gnext]');
    if (!gallery || !prev || !next) return;
    function step(dir) {
      var slide = gallery.querySelector('.bo-snpdp__slide');
      var w = slide ? slide.getBoundingClientRect().width + 10 : gallery.clientWidth * 0.85;
      /* scroll instantáneo: con scroll-snap mandatory el smooth se cancela; el snap alinea el slide */
      gallery.scrollBy({ left: dir * w });
    }
    prev.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });
  })();

  /* NUEVO: scroll reveal sobrio (respeta prefers-reduced-motion) */
  (function () {
    var els = root.querySelectorAll('[data-reveal]');
    if (!els.length) return;
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced || !('IntersectionObserver' in window)) return;
    var rio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          rio.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -30px' });
    els.forEach(function (el) {
      el.classList.add('bo-reveal');
      rio.observe(el);
    });
  })();

  if ('IntersectionObserver' in window) {
    var vids = root.querySelectorAll('video');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.play().catch(function () {}); }
        else { e.target.pause(); }
      });
    }, { threshold: 0.15 });
    vids.forEach(function (v) { io.observe(v); });

    var sticky = root.querySelector('[data-sticky]');
    var topForm = document.getElementById('bo-snpdp-form-top');
    var finalSec = document.getElementById('bo-snpdp-final');
    if (sticky && topForm) {
      var topVisible = true, finalVisible = false;
      var refresh = function () {
        sticky.hidden = topVisible || finalVisible || joined || window.innerWidth >= 900;
      };
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { topVisible = e.isIntersecting; });
        refresh();
      }, { threshold: 0.05 }).observe(topForm);
      if (finalSec) {
        new IntersectionObserver(function (es) {
          es.forEach(function (e) { finalVisible = e.isIntersecting; });
          refresh();
        }, { threshold: 0.05 }).observe(finalSec);
      }
      root.addEventListener('click', function (e) {
        if (e.target.closest('[data-sticky-btn]')) {
          var target = finalSec || topForm;
          var y = target.getBoundingClientRect().top + window.pageYOffset - 8;
          window.scrollTo({ top: y, behavior: 'smooth' });
        }
      });
      window.addEventListener('resize', refresh, { passive: true });
      refresh();
    }
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
